!function (e, t) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function (e) {
        if (!e.document) throw new Error("jQuery requires a window with a document");
        return t(e)
    } : t(e)
}("undefined" != typeof window ? window : this, function (e, t) {
    function n(e) {
        var t = !!e && "length" in e && e.length, n = re.type(e);
        return "function" !== n && !re.isWindow(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e)
    }

    function r(e, t, n) {
        if (re.isFunction(t)) return re.grep(e, function (e, r) {
            return !!t.call(e, r, e) !== n
        });
        if (t.nodeType) return re.grep(e, function (e) {
            return e === t !== n
        });
        if ("string" == typeof t) {
            if (de.test(t)) return re.filter(t, e, n);
            t = re.filter(t, e)
        }
        return re.grep(e, function (e) {
            return K.call(t, e) > -1 !== n
        })
    }

    function i(e, t) {
        for (; (e = e[t]) && 1 !== e.nodeType;) ;
        return e
    }

    function o(e) {
        var t = {};
        return re.each(e.match(ye) || [], function (e, n) {
            t[n] = !0
        }), t
    }

    function s() {
        Y.removeEventListener("DOMContentLoaded", s), e.removeEventListener("load", s), re.ready()
    }

    function a() {
        this.expando = re.expando + a.uid++
    }

    function u(e, t, n) {
        var r;
        if (void 0 === n && 1 === e.nodeType) if (r = "data-" + t.replace(ke, "-$&").toLowerCase(), "string" == typeof (n = e.getAttribute(r))) {
            try {
                n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : $e.test(n) ? re.parseJSON(n) : n)
            } catch (e) {
            }
            Te.set(e, t, n)
        } else n = void 0;
        return n
    }

    function l(e, t, n, r) {
        var i, o = 1, s = 20, a = r ? function () {
                return r.cur()
            } : function () {
                return re.css(e, t, "")
            }, u = a(), l = n && n[3] || (re.cssNumber[t] ? "" : "px"),
            c = (re.cssNumber[t] || "px" !== l && +u) && Ee.exec(re.css(e, t));
        if (c && c[3] !== l) {
            l = l || c[3], n = n || [], c = +u || 1;
            do {
                c /= o = o || ".5", re.style(e, t, c + l)
            } while (o !== (o = a() / u) && 1 !== o && --s)
        }
        return n && (c = +c || +u || 0, i = n[1] ? c + (n[1] + 1) * n[2] : +n[2], r && (r.unit = l, r.start = c, r.end = i)), i
    }

    function c(e, t) {
        var n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [];
        return void 0 === t || t && re.nodeName(e, t) ? re.merge([e], n) : n
    }

    function f(e, t) {
        for (var n = 0, r = e.length; n < r; n++) Ce.set(e[n], "globalEval", !t || Ce.get(t[n], "globalEval"))
    }

    function p(e, t, n, r, i) {
        for (var o, s, a, u, l, p, d = t.createDocumentFragment(), h = [], v = 0, m = e.length; v < m; v++) if ((o = e[v]) || 0 === o) if ("object" === re.type(o)) re.merge(h, o.nodeType ? [o] : o); else if (He.test(o)) {
            for (s = s || d.appendChild(t.createElement("div")), a = (Ae.exec(o) || ["", ""])[1].toLowerCase(), u = Le[a] || Le._default, s.innerHTML = u[1] + re.htmlPrefilter(o) + u[2], p = u[0]; p--;) s = s.lastChild;
            re.merge(h, s.childNodes), (s = d.firstChild).textContent = ""
        } else h.push(t.createTextNode(o));
        for (d.textContent = "", v = 0; o = h[v++];) if (r && re.inArray(o, r) > -1) i && i.push(o); else if (l = re.contains(o.ownerDocument, o), s = c(d.appendChild(o), "script"), l && f(s), n) for (p = 0; o = s[p++];) qe.test(o.type || "") && n.push(o);
        return d
    }

    function d() {
        return !0
    }

    function h() {
        return !1
    }

    function v() {
        try {
            return Y.activeElement
        } catch (e) {
        }
    }

    function m(e, t, n, r, i, o) {
        var s, a;
        if ("object" == typeof t) {
            "string" != typeof n && (r = r || n, n = void 0);
            for (a in t) m(e, a, n, r, t[a], o);
            return e
        }
        if (null == r && null == i ? (i = n, r = n = void 0) : null == i && ("string" == typeof n ? (i = r, r = void 0) : (i = r, r = n, n = void 0)), !1 === i) i = h; else if (!i) return e;
        return 1 === o && (s = i, (i = function (e) {
            return re().off(e), s.apply(this, arguments)
        }).guid = s.guid || (s.guid = re.guid++)), e.each(function () {
            re.event.add(this, t, i, r, n)
        })
    }

    function g(e, t) {
        return re.nodeName(e, "table") && re.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e
    }

    function y(e) {
        return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e
    }

    function x(e) {
        var t = We.exec(e.type);
        return t ? e.type = t[1] : e.removeAttribute("type"), e
    }

    function b(e, t) {
        var n, r, i, o, s, a, u, l;
        if (1 === t.nodeType) {
            if (Ce.hasData(e) && (o = Ce.access(e), s = Ce.set(t, o), l = o.events)) {
                delete s.handle, s.events = {};
                for (i in l) for (n = 0, r = l[i].length; n < r; n++) re.event.add(t, i, l[i][n])
            }
            Te.hasData(e) && (a = Te.access(e), u = re.extend({}, a), Te.set(t, u))
        }
    }

    function w(e, t) {
        var n = t.nodeName.toLowerCase();
        "input" === n && je.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue)
    }

    function C(e, t, n, r) {
        t = J.apply([], t);
        var i, o, s, a, u, l, f = 0, d = e.length, h = d - 1, v = t[0], m = re.isFunction(v);
        if (m || d > 1 && "string" == typeof v && !ne.checkClone && Ie.test(v)) return e.each(function (i) {
            var o = e.eq(i);
            m && (t[0] = v.call(this, i, o.html())), C(o, t, n, r)
        });
        if (d && (i = p(t, e[0].ownerDocument, !1, e, r), o = i.firstChild, 1 === i.childNodes.length && (i = o), o || r)) {
            for (a = (s = re.map(c(i, "script"), y)).length; f < d; f++) u = i, f !== h && (u = re.clone(u, !0, !0), a && re.merge(s, c(u, "script"))), n.call(e[f], u, f);
            if (a) for (l = s[s.length - 1].ownerDocument, re.map(s, x), f = 0; f < a; f++) u = s[f], qe.test(u.type || "") && !Ce.access(u, "globalEval") && re.contains(l, u) && (u.src ? re._evalUrl && re._evalUrl(u.src) : re.globalEval(u.textContent.replace(_e, "")))
        }
        return e
    }

    function T(e, t, n) {
        for (var r, i = t ? re.filter(t, e) : e, o = 0; null != (r = i[o]); o++) n || 1 !== r.nodeType || re.cleanData(c(r)), r.parentNode && (n && re.contains(r.ownerDocument, r) && f(c(r, "script")), r.parentNode.removeChild(r));
        return e
    }

    function $(e, t) {
        var n = re(t.createElement(e)).appendTo(t.body), r = re.css(n[0], "display");
        return n.detach(), r
    }

    function k(e) {
        var t = Y, n = Ue[e];
        return n || ("none" !== (n = $(e, t)) && n || ((t = (Be = (Be || re("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement))[0].contentDocument).write(), t.close(), n = $(e, t), Be.detach()), Ue[e] = n), n
    }

    function S(e, t, n) {
        var r, i, o, s, a = e.style;
        return n = n || Ve(e), "" !== (s = n ? n.getPropertyValue(t) || n[t] : void 0) && void 0 !== s || re.contains(e.ownerDocument, e) || (s = re.style(e, t)), n && !ne.pixelMarginRight() && ze.test(s) && Xe.test(t) && (r = a.width, i = a.minWidth, o = a.maxWidth, a.minWidth = a.maxWidth = a.width = s, s = n.width, a.width = r, a.minWidth = i, a.maxWidth = o), void 0 !== s ? s + "" : s
    }

    function E(e, t) {
        return {
            get: function () {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get
            }
        }
    }

    function N(e) {
        if (e in et) return e;
        for (var t = e[0].toUpperCase() + e.slice(1), n = Ze.length; n--;) if ((e = Ze[n] + t) in et) return e
    }

    function D(e, t, n) {
        var r = Ee.exec(t);
        return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t
    }

    function j(e, t, n, r, i) {
        for (var o = n === (r ? "border" : "content") ? 4 : "width" === t ? 1 : 0, s = 0; o < 4; o += 2) "margin" === n && (s += re.css(e, n + Ne[o], !0, i)), r ? ("content" === n && (s -= re.css(e, "padding" + Ne[o], !0, i)), "margin" !== n && (s -= re.css(e, "border" + Ne[o] + "Width", !0, i))) : (s += re.css(e, "padding" + Ne[o], !0, i), "padding" !== n && (s += re.css(e, "border" + Ne[o] + "Width", !0, i)));
        return s
    }

    function A(e, t, n) {
        var r = !0, i = "width" === t ? e.offsetWidth : e.offsetHeight, o = Ve(e),
            s = "border-box" === re.css(e, "boxSizing", !1, o);
        if (i <= 0 || null == i) {
            if (((i = S(e, t, o)) < 0 || null == i) && (i = e.style[t]), ze.test(i)) return i;
            r = s && (ne.boxSizingReliable() || i === e.style[t]), i = parseFloat(i) || 0
        }
        return i + j(e, t, n || (s ? "border" : "content"), r, o) + "px"
    }

    function q(e, t) {
        for (var n, r, i, o = [], s = 0, a = e.length; s < a; s++) (r = e[s]).style && (o[s] = Ce.get(r, "olddisplay"), n = r.style.display, t ? (o[s] || "none" !== n || (r.style.display = ""), "" === r.style.display && De(r) && (o[s] = Ce.access(r, "olddisplay", k(r.nodeName)))) : (i = De(r), "none" === n && i || Ce.set(r, "olddisplay", i ? n : re.css(r, "display"))));
        for (s = 0; s < a; s++) (r = e[s]).style && (t && "none" !== r.style.display && "" !== r.style.display || (r.style.display = t ? o[s] || "" : "none"));
        return e
    }

    function L(e, t, n, r, i) {
        return new L.prototype.init(e, t, n, r, i)
    }

    function H() {
        return e.setTimeout(function () {
            tt = void 0
        }), tt = re.now()
    }

    function O(e, t) {
        var n, r = 0, i = {
            height: e
        };
        for (t = t ? 1 : 0; r < 4; r += 2 - t) i["margin" + (n = Ne[r])] = i["padding" + n] = e;
        return t && (i.opacity = i.width = e), i
    }

    function F(e, t, n) {
        for (var r, i = (P.tweeners[t] || []).concat(P.tweeners["*"]), o = 0, s = i.length; o < s; o++) if (r = i[o].call(n, t, e)) return r
    }

    function R(e, t) {
        var n, r, i, o, s;
        for (n in e) if (r = re.camelCase(n), i = t[r], o = e[n], re.isArray(o) && (i = o[1], o = e[n] = o[0]), n !== r && (e[r] = o, delete e[n]), (s = re.cssHooks[r]) && "expand" in s) {
            o = s.expand(o), delete e[r];
            for (n in o) n in e || (e[n] = o[n], t[n] = i)
        } else t[r] = i
    }

    function P(e, t, n) {
        var r, i, o = 0, s = P.prefilters.length, a = re.Deferred().always(function () {
            delete u.elem
        }), u = function () {
            if (i) return !1;
            for (var t = tt || H(), n = Math.max(0, l.startTime + l.duration - t), r = 1 - (n / l.duration || 0), o = 0, s = l.tweens.length; o < s; o++) l.tweens[o].run(r);
            return a.notifyWith(e, [l, r, n]), r < 1 && s ? n : (a.resolveWith(e, [l]), !1)
        }, l = a.promise({
            elem: e,
            props: re.extend({}, t),
            opts: re.extend(!0, {
                specialEasing: {}, easing: re.easing._default
            }, n),
            originalProperties: t,
            originalOptions: n,
            startTime: tt || H(),
            duration: n.duration,
            tweens: [],
            createTween: function (t, n) {
                var r = re.Tween(e, l.opts, t, n, l.opts.specialEasing[t] || l.opts.easing);
                return l.tweens.push(r), r
            },
            stop: function (t) {
                var n = 0, r = t ? l.tweens.length : 0;
                if (i) return this;
                for (i = !0; n < r; n++) l.tweens[n].run(1);
                return t ? (a.notifyWith(e, [l, 1, 0]), a.resolveWith(e, [l, t])) : a.rejectWith(e, [l, t]), this
            }
        }), c = l.props;
        for (R(c, l.opts.specialEasing); o < s; o++) if (r = P.prefilters[o].call(l, e, c, l.opts)) return re.isFunction(r.stop) && (re._queueHooks(l.elem, l.opts.queue).stop = re.proxy(r.stop, r)), r;
        return re.map(c, F, l), re.isFunction(l.opts.start) && l.opts.start.call(e, l), re.fx.timer(re.extend(u, {
            elem: e, anim: l, queue: l.opts.queue
        })), l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always)
    }

    function M(e) {
        return e.getAttribute && e.getAttribute("class") || ""
    }

    function I(e) {
        return function (t, n) {
            "string" != typeof t && (n = t, t = "*");
            var r, i = 0, o = t.toLowerCase().match(ye) || [];
            if (re.isFunction(n)) for (; r = o[i++];) "+" === r[0] ? (r = r.slice(1) || "*", (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n)
        }
    }

    function W(e, t, n, r) {
        function i(a) {
            var u;
            return o[a] = !0, re.each(e[a] || [], function (e, a) {
                var l = a(t, n, r);
                return "string" != typeof l || s || o[l] ? s ? !(u = l) : void 0 : (t.dataTypes.unshift(l), i(l), !1)
            }), u
        }

        var o = {}, s = e === Tt;
        return i(t.dataTypes[0]) || !o["*"] && i("*")
    }

    function _(e, t) {
        var n, r, i = re.ajaxSettings.flatOptions || {};
        for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
        return r && re.extend(!0, e, r), e
    }

    function B(e, t, n) {
        for (var r, i, o, s, a = e.contents, u = e.dataTypes; "*" === u[0];) u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
        if (r) for (i in a) if (a[i] && a[i].test(r)) {
            u.unshift(i);
            break
        }
        if (u[0] in n) o = u[0]; else {
            for (i in n) {
                if (!u[0] || e.converters[i + " " + u[0]]) {
                    o = i;
                    break
                }
                s || (s = i)
            }
            o = o || s
        }
        if (o) return o !== u[0] && u.unshift(o), n[o]
    }

    function U(e, t, n, r) {
        var i, o, s, a, u, l = {}, c = e.dataTypes.slice();
        if (c[1]) for (s in e.converters) l[s.toLowerCase()] = e.converters[s];
        for (o = c.shift(); o;) if (e.responseFields[o] && (n[e.responseFields[o]] = t), !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), u = o, o = c.shift()) if ("*" === o) o = u; else if ("*" !== u && u !== o) {
            if (!(s = l[u + " " + o] || l["* " + o])) for (i in l) if ((a = i.split(" "))[1] === o && (s = l[u + " " + a[0]] || l["* " + a[0]])) {
                !0 === s ? s = l[i] : !0 !== l[i] && (o = a[0], c.unshift(a[1]));
                break
            }
            if (!0 !== s) if (s && e.throws) t = s(t); else try {
                t = s(t)
            } catch (e) {
                return {
                    state: "parsererror", error: s ? e : "No conversion from " + u + " to " + o
                }
            }
        }
        return {
            state: "success", data: t
        }
    }

    function X(e, t, n, r) {
        var i;
        if (re.isArray(t)) re.each(t, function (t, i) {
            n || Et.test(e) ? r(e, i) : X(e + "[" + ("object" == typeof i && null != i ? t : "") + "]", i, n, r)
        }); else if (n || "object" !== re.type(t)) r(e, t); else for (i in t) X(e + "[" + i + "]", t[i], n, r)
    }

    function z(e) {
        return re.isWindow(e) ? e : 9 === e.nodeType && e.defaultView
    }

    var V = [], Y = e.document, G = V.slice, J = V.concat, Q = V.push, K = V.indexOf, Z = {}, ee = Z.toString,
        te = Z.hasOwnProperty, ne = {}, re = function (e, t) {
            return new re.fn.init(e, t)
        }, ie = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, oe = /^-ms-/, se = /-([\da-z])/gi, ae = function (e, t) {
            return t.toUpperCase()
        };
    re.fn = re.prototype = {
        jquery: "2.2.4", constructor: re, selector: "", length: 0, toArray: function () {
            return G.call(this)
        }, get: function (e) {
            return null != e ? e < 0 ? this[e + this.length] : this[e] : G.call(this)
        }, pushStack: function (e) {
            var t = re.merge(this.constructor(), e);
            return t.prevObject = this, t.context = this.context, t
        }, each: function (e) {
            return re.each(this, e)
        }, map: function (e) {
            return this.pushStack(re.map(this, function (t, n) {
                return e.call(t, n, t)
            }))
        }, slice: function () {
            return this.pushStack(G.apply(this, arguments))
        }, first: function () {
            return this.eq(0)
        }, last: function () {
            return this.eq(-1)
        }, eq: function (e) {
            var t = this.length, n = +e + (e < 0 ? t : 0);
            return this.pushStack(n >= 0 && n < t ? [this[n]] : [])
        }, end: function () {
            return this.prevObject || this.constructor()
        }, push: Q, sort: V.sort, splice: V.splice
    }, re.extend = re.fn.extend = function () {
        var e, t, n, r, i, o, s = arguments[0] || {}, a = 1, u = arguments.length, l = !1;
        for ("boolean" == typeof s && (l = s, s = arguments[a] || {}, a++), "object" == typeof s || re.isFunction(s) || (s = {}), a === u && (s = this, a--); a < u; a++) if (null != (e = arguments[a])) for (t in e) n = s[t], s !== (r = e[t]) && (l && r && (re.isPlainObject(r) || (i = re.isArray(r))) ? (i ? (i = !1, o = n && re.isArray(n) ? n : []) : o = n && re.isPlainObject(n) ? n : {}, s[t] = re.extend(l, o, r)) : void 0 !== r && (s[t] = r));
        return s
    }, re.extend({
        expando: "jQuery" + ("2.2.4" + Math.random()).replace(/\D/g, ""), isReady: !0, error: function (e) {
            throw new Error(e)
        }, noop: function () {
        }, isFunction: function (e) {
            return "function" === re.type(e)
        }, isArray: Array.isArray, isWindow: function (e) {
            return null != e && e === e.window
        }, isNumeric: function (e) {
            var t = e && e.toString();
            return !re.isArray(e) && t - parseFloat(t) + 1 >= 0
        }, isPlainObject: function (e) {
            var t;
            if ("object" !== re.type(e) || e.nodeType || re.isWindow(e)) return !1;
            if (e.constructor && !te.call(e, "constructor") && !te.call(e.constructor.prototype || {}, "isPrototypeOf")) return !1;
            for (t in e) ;
            return void 0 === t || te.call(e, t)
        }, isEmptyObject: function (e) {
            var t;
            for (t in e) return !1;
            return !0
        }, type: function (e) {
            return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? Z[ee.call(e)] || "object" : typeof e
        }, globalEval: function (e) {
            var t, n = eval;
            (e = re.trim(e)) && (1 === e.indexOf("use strict") ? ((t = Y.createElement("script")).text = e, Y.head.appendChild(t).parentNode.removeChild(t)) : n(e))
        }, camelCase: function (e) {
            return e.replace(oe, "ms-").replace(se, ae)
        }, nodeName: function (e, t) {
            return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
        }, each: function (e, t) {
            var r, i = 0;
            if (n(e)) for (r = e.length; i < r && !1 !== t.call(e[i], i, e[i]); i++) ; else for (i in e) if (!1 === t.call(e[i], i, e[i])) break;
            return e
        }, trim: function (e) {
            return null == e ? "" : (e + "").replace(ie, "")
        }, makeArray: function (e, t) {
            var r = t || [];
            return null != e && (n(Object(e)) ? re.merge(r, "string" == typeof e ? [e] : e) : Q.call(r, e)), r
        }, inArray: function (e, t, n) {
            return null == t ? -1 : K.call(t, e, n)
        }, merge: function (e, t) {
            for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r];
            return e.length = i, e
        }, grep: function (e, t, n) {
            for (var r = [], i = 0, o = e.length, s = !n; i < o; i++) !t(e[i], i) !== s && r.push(e[i]);
            return r
        }, map: function (e, t, r) {
            var i, o, s = 0, a = [];
            if (n(e)) for (i = e.length; s < i; s++) null != (o = t(e[s], s, r)) && a.push(o); else for (s in e) null != (o = t(e[s], s, r)) && a.push(o);
            return J.apply([], a)
        }, guid: 1, proxy: function (e, t) {
            var n, r, i;
            if ("string" == typeof t && (n = e[t], t = e, e = n), re.isFunction(e)) return r = G.call(arguments, 2), i = function () {
                return e.apply(t || this, r.concat(G.call(arguments)))
            }, i.guid = e.guid = e.guid || re.guid++, i
        }, now: Date.now, support: ne
    }), "function" == typeof Symbol && (re.fn[Symbol.iterator] = V[Symbol.iterator]), re.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
        Z["[object " + t + "]"] = t.toLowerCase()
    });
    var ue = function (e) {
        function t(e, t, n, r) {
            var i, o, s, a, l, f, p, d, h = t && t.ownerDocument, v = t ? t.nodeType : 9;
            if (n = n || [], "string" != typeof e || !e || 1 !== v && 9 !== v && 11 !== v) return n;
            if (!r && ((t ? t.ownerDocument || t : P) !== j && D(t), t = t || j, q)) {
                if (11 !== v && (f = ve.exec(e))) if (i = f[1]) {
                    if (9 === v) {
                        if (!(s = t.getElementById(i))) return n;
                        if (s.id === i) return n.push(s), n
                    } else if (h && (s = h.getElementById(i)) && F(t, s) && s.id === i) return n.push(s), n
                } else {
                    if (f[2]) return J.apply(n, t.getElementsByTagName(e)), n;
                    if ((i = f[3]) && x.getElementsByClassName && t.getElementsByClassName) return J.apply(n, t.getElementsByClassName(i)), n
                }
                if (x.qsa && !B[e + " "] && (!L || !L.test(e))) {
                    if (1 !== v) h = t, d = e; else if ("object" !== t.nodeName.toLowerCase()) {
                        for ((a = t.getAttribute("id")) ? a = a.replace(ge, "\\$&") : t.setAttribute("id", a = R), o = (p = T(e)).length, l = ce.test(a) ? "#" + a : "[id='" + a + "']"; o--;) p[o] = l + " " + c(p[o]);
                        d = p.join(","), h = me.test(e) && u(t.parentNode) || t
                    }
                    if (d) try {
                        return J.apply(n, h.querySelectorAll(d)), n
                    } catch (e) {
                    } finally {
                        a === R && t.removeAttribute("id")
                    }
                }
            }
            return k(e.replace(oe, "$1"), t, n, r)
        }

        function n() {
            function e(n, r) {
                return t.push(n + " ") > b.cacheLength && delete e[t.shift()], e[n + " "] = r
            }

            var t = [];
            return e
        }

        function r(e) {
            return e[R] = !0, e
        }

        function i(e) {
            var t = j.createElement("div");
            try {
                return !!e(t)
            } catch (e) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t), t = null
            }
        }

        function o(e, t) {
            for (var n = e.split("|"), r = n.length; r--;) b.attrHandle[n[r]] = t
        }

        function s(e, t) {
            var n = t && e,
                r = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || X) - (~e.sourceIndex || X);
            if (r) return r;
            if (n) for (; n = n.nextSibling;) if (n === t) return -1;
            return e ? 1 : -1
        }

        function a(e) {
            return r(function (t) {
                return t = +t, r(function (n, r) {
                    for (var i, o = e([], n.length, t), s = o.length; s--;) n[i = o[s]] && (n[i] = !(r[i] = n[i]))
                })
            })
        }

        function u(e) {
            return e && void 0 !== e.getElementsByTagName && e
        }

        function l() {
        }

        function c(e) {
            for (var t = 0, n = e.length, r = ""; t < n; t++) r += e[t].value;
            return r
        }

        function f(e, t, n) {
            var r = t.dir, i = n && "parentNode" === r, o = I++;
            return t.first ? function (t, n, o) {
                for (; t = t[r];) if (1 === t.nodeType || i) return e(t, n, o)
            } : function (t, n, s) {
                var a, u, l, c = [M, o];
                if (s) {
                    for (; t = t[r];) if ((1 === t.nodeType || i) && e(t, n, s)) return !0
                } else for (; t = t[r];) if (1 === t.nodeType || i) {
                    if (l = t[R] || (t[R] = {}), u = l[t.uniqueID] || (l[t.uniqueID] = {}), (a = u[r]) && a[0] === M && a[1] === o) return c[2] = a[2];
                    if (u[r] = c, c[2] = e(t, n, s)) return !0
                }
            }
        }

        function p(e) {
            return e.length > 1 ? function (t, n, r) {
                for (var i = e.length; i--;) if (!e[i](t, n, r)) return !1;
                return !0
            } : e[0]
        }

        function d(e, n, r) {
            for (var i = 0, o = n.length; i < o; i++) t(e, n[i], r);
            return r
        }

        function h(e, t, n, r, i) {
            for (var o, s = [], a = 0, u = e.length, l = null != t; a < u; a++) (o = e[a]) && (n && !n(o, r, i) || (s.push(o), l && t.push(a)));
            return s
        }

        function v(e, t, n, i, o, s) {
            return i && !i[R] && (i = v(i)), o && !o[R] && (o = v(o, s)), r(function (r, s, a, u) {
                var l, c, f, p = [], v = [], m = s.length, g = r || d(t || "*", a.nodeType ? [a] : a, []),
                    y = !e || !r && t ? g : h(g, p, e, a, u), x = n ? o || (r ? e : m || i) ? [] : s : y;
                if (n && n(y, x, a, u), i) for (l = h(x, v), i(l, [], a, u), c = l.length; c--;) (f = l[c]) && (x[v[c]] = !(y[v[c]] = f));
                if (r) {
                    if (o || e) {
                        if (o) {
                            for (l = [], c = x.length; c--;) (f = x[c]) && l.push(y[c] = f);
                            o(null, x = [], l, u)
                        }
                        for (c = x.length; c--;) (f = x[c]) && (l = o ? K(r, f) : p[c]) > -1 && (r[l] = !(s[l] = f))
                    }
                } else x = h(x === s ? x.splice(m, x.length) : x), o ? o(null, s, x, u) : J.apply(s, x)
            })
        }

        function m(e) {
            for (var t, n, r, i = e.length, o = b.relative[e[0].type], s = o || b.relative[" "], a = o ? 1 : 0, u = f(function (e) {
                return e === t
            }, s, !0), l = f(function (e) {
                return K(t, e) > -1
            }, s, !0), d = [function (e, n, r) {
                var i = !o && (r || n !== S) || ((t = n).nodeType ? u(e, n, r) : l(e, n, r));
                return t = null, i
            }]; a < i; a++) if (n = b.relative[e[a].type]) d = [f(p(d), n)]; else {
                if ((n = b.filter[e[a].type].apply(null, e[a].matches))[R]) {
                    for (r = ++a; r < i && !b.relative[e[r].type]; r++) ;
                    return v(a > 1 && p(d), a > 1 && c(e.slice(0, a - 1).concat({
                        value: " " === e[a - 2].type ? "*" : ""
                    })).replace(oe, "$1"), n, a < r && m(e.slice(a, r)), r < i && m(e = e.slice(r)), r < i && c(e))
                }
                d.push(n)
            }
            return p(d)
        }

        function g(e, n) {
            var i = n.length > 0, o = e.length > 0, s = function (r, s, a, u, l) {
                var c, f, p, d = 0, v = "0", m = r && [], g = [], y = S, x = r || o && b.find.TAG("*", l),
                    w = M += null == y ? 1 : Math.random() || .1, C = x.length;
                for (l && (S = s === j || s || l); v !== C && null != (c = x[v]); v++) {
                    if (o && c) {
                        for (f = 0, s || c.ownerDocument === j || (D(c), a = !q); p = e[f++];) if (p(c, s || j, a)) {
                            u.push(c);
                            break
                        }
                        l && (M = w)
                    }
                    i && ((c = !p && c) && d--, r && m.push(c))
                }
                if (d += v, i && v !== d) {
                    for (f = 0; p = n[f++];) p(m, g, s, a);
                    if (r) {
                        if (d > 0) for (; v--;) m[v] || g[v] || (g[v] = Y.call(u));
                        g = h(g)
                    }
                    J.apply(u, g), l && !r && g.length > 0 && d + n.length > 1 && t.uniqueSort(u)
                }
                return l && (M = w, S = y), m
            };
            return i ? r(s) : s
        }

        var y, x, b, w, C, T, $, k, S, E, N, D, j, A, q, L, H, O, F, R = "sizzle" + 1 * new Date, P = e.document, M = 0,
            I = 0, W = n(), _ = n(), B = n(), U = function (e, t) {
                return e === t && (N = !0), 0
            }, X = 1 << 31, z = {}.hasOwnProperty, V = [], Y = V.pop, G = V.push, J = V.push, Q = V.slice,
            K = function (e, t) {
                for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
                return -1
            },
            Z = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            ee = "[\\x20\\t\\r\\n\\f]", te = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
            ne = "\\[" + ee + "*(" + te + ")(?:" + ee + "*([*^$|!~]?=)" + ee + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + te + "))|)" + ee + "*\\]",
            re = ":(" + te + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + ne + ")*)|.*)\\)|)",
            ie = new RegExp(ee + "+", "g"), oe = new RegExp("^" + ee + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ee + "+$", "g"),
            se = new RegExp("^" + ee + "*," + ee + "*"), ae = new RegExp("^" + ee + "*([>+~]|" + ee + ")" + ee + "*"),
            ue = new RegExp("=" + ee + "*([^\\]'\"]*?)" + ee + "*\\]", "g"), le = new RegExp(re),
            ce = new RegExp("^" + te + "$"), fe = {
                ID: new RegExp("^#(" + te + ")"),
                CLASS: new RegExp("^\\.(" + te + ")"),
                TAG: new RegExp("^(" + te + "|[*])"),
                ATTR: new RegExp("^" + ne),
                PSEUDO: new RegExp("^" + re),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + ee + "*(even|odd|(([+-]|)(\\d*)n|)" + ee + "*(?:([+-]|)" + ee + "*(\\d+)|))" + ee + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + Z + ")$", "i"),
                needsContext: new RegExp("^" + ee + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + ee + "*((?:-\\d)?\\d*)" + ee + "*\\)|)(?=[^-]|$)", "i")
            }, pe = /^(?:input|select|textarea|button)$/i, de = /^h\d$/i, he = /^[^{]+\{\s*\[native \w/,
            ve = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, me = /[+~]/, ge = /'|\\/g,
            ye = new RegExp("\\\\([\\da-f]{1,6}" + ee + "?|(" + ee + ")|.)", "ig"), xe = function (e, t, n) {
                var r = "0x" + t - 65536;
                return r !== r || n ? t : r < 0 ? String.fromCharCode(r + 65536) : String.fromCharCode(r >> 10 | 55296, 1023 & r | 56320)
            }, be = function () {
                D()
            };
        try {
            J.apply(V = Q.call(P.childNodes), P.childNodes), V[P.childNodes.length].nodeType
        } catch (e) {
            J = {
                apply: V.length ? function (e, t) {
                    G.apply(e, Q.call(t))
                } : function (e, t) {
                    for (var n = e.length, r = 0; e[n++] = t[r++];) ;
                    e.length = n - 1
                }
            }
        }
        x = t.support = {}, C = t.isXML = function (e) {
            var t = e && (e.ownerDocument || e).documentElement;
            return !!t && "HTML" !== t.nodeName
        }, D = t.setDocument = function (e) {
            var t, n, r = e ? e.ownerDocument || e : P;
            return r !== j && 9 === r.nodeType && r.documentElement ? (j = r, A = j.documentElement, q = !C(j), (n = j.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", be, !1) : n.attachEvent && n.attachEvent("onunload", be)), x.attributes = i(function (e) {
                return e.className = "i", !e.getAttribute("className")
            }), x.getElementsByTagName = i(function (e) {
                return e.appendChild(j.createComment("")), !e.getElementsByTagName("*").length
            }), x.getElementsByClassName = he.test(j.getElementsByClassName), x.getById = i(function (e) {
                return A.appendChild(e).id = R, !j.getElementsByName || !j.getElementsByName(R).length
            }), x.getById ? (b.find.ID = function (e, t) {
                if (void 0 !== t.getElementById && q) {
                    var n = t.getElementById(e);
                    return n ? [n] : []
                }
            }, b.filter.ID = function (e) {
                var t = e.replace(ye, xe);
                return function (e) {
                    return e.getAttribute("id") === t
                }
            }) : (delete b.find.ID, b.filter.ID = function (e) {
                var t = e.replace(ye, xe);
                return function (e) {
                    var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                    return n && n.value === t
                }
            }), b.find.TAG = x.getElementsByTagName ? function (e, t) {
                return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : x.qsa ? t.querySelectorAll(e) : void 0
            } : function (e, t) {
                var n, r = [], i = 0, o = t.getElementsByTagName(e);
                if ("*" === e) {
                    for (; n = o[i++];) 1 === n.nodeType && r.push(n);
                    return r
                }
                return o
            }, b.find.CLASS = x.getElementsByClassName && function (e, t) {
                if (void 0 !== t.getElementsByClassName && q) return t.getElementsByClassName(e)
            }, H = [], L = [], (x.qsa = he.test(j.querySelectorAll)) && (i(function (e) {
                A.appendChild(e).innerHTML = "<a id='" + R + "'></a><select id='" + R + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && L.push("[*^$]=" + ee + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || L.push("\\[" + ee + "*(?:value|" + Z + ")"), e.querySelectorAll("[id~=" + R + "-]").length || L.push("~="), e.querySelectorAll(":checked").length || L.push(":checked"), e.querySelectorAll("a#" + R + "+*").length || L.push(".#.+[+~]")
            }), i(function (e) {
                var t = j.createElement("input");
                t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && L.push("name" + ee + "*[*^$|!~]?="), e.querySelectorAll(":enabled").length || L.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), L.push(",.*:")
            })), (x.matchesSelector = he.test(O = A.matches || A.webkitMatchesSelector || A.mozMatchesSelector || A.oMatchesSelector || A.msMatchesSelector)) && i(function (e) {
                x.disconnectedMatch = O.call(e, "div"), O.call(e, "[s!='']:x"), H.push("!=", re)
            }), L = L.length && new RegExp(L.join("|")), H = H.length && new RegExp(H.join("|")), t = he.test(A.compareDocumentPosition), F = t || he.test(A.contains) ? function (e, t) {
                var n = 9 === e.nodeType ? e.documentElement : e, r = t && t.parentNode;
                return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)))
            } : function (e, t) {
                if (t) for (; t = t.parentNode;) if (t === e) return !0;
                return !1
            }, U = t ? function (e, t) {
                if (e === t) return N = !0, 0;
                var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                return n || (1 & (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !x.sortDetached && t.compareDocumentPosition(e) === n ? e === j || e.ownerDocument === P && F(P, e) ? -1 : t === j || t.ownerDocument === P && F(P, t) ? 1 : E ? K(E, e) - K(E, t) : 0 : 4 & n ? -1 : 1)
            } : function (e, t) {
                if (e === t) return N = !0, 0;
                var n, r = 0, i = e.parentNode, o = t.parentNode, a = [e], u = [t];
                if (!i || !o) return e === j ? -1 : t === j ? 1 : i ? -1 : o ? 1 : E ? K(E, e) - K(E, t) : 0;
                if (i === o) return s(e, t);
                for (n = e; n = n.parentNode;) a.unshift(n);
                for (n = t; n = n.parentNode;) u.unshift(n);
                for (; a[r] === u[r];) r++;
                return r ? s(a[r], u[r]) : a[r] === P ? -1 : u[r] === P ? 1 : 0
            }, j) : j
        }, t.matches = function (e, n) {
            return t(e, null, null, n)
        }, t.matchesSelector = function (e, n) {
            if ((e.ownerDocument || e) !== j && D(e), n = n.replace(ue, "='$1']"), x.matchesSelector && q && !B[n + " "] && (!H || !H.test(n)) && (!L || !L.test(n))) try {
                var r = O.call(e, n);
                if (r || x.disconnectedMatch || e.document && 11 !== e.document.nodeType) return r
            } catch (e) {
            }
            return t(n, j, null, [e]).length > 0
        }, t.contains = function (e, t) {
            return (e.ownerDocument || e) !== j && D(e), F(e, t)
        }, t.attr = function (e, t) {
            (e.ownerDocument || e) !== j && D(e);
            var n = b.attrHandle[t.toLowerCase()],
                r = n && z.call(b.attrHandle, t.toLowerCase()) ? n(e, t, !q) : void 0;
            return void 0 !== r ? r : x.attributes || !q ? e.getAttribute(t) : (r = e.getAttributeNode(t)) && r.specified ? r.value : null
        }, t.error = function (e) {
            throw new Error("Syntax error, unrecognized expression: " + e)
        }, t.uniqueSort = function (e) {
            var t, n = [], r = 0, i = 0;
            if (N = !x.detectDuplicates, E = !x.sortStable && e.slice(0), e.sort(U), N) {
                for (; t = e[i++];) t === e[i] && (r = n.push(i));
                for (; r--;) e.splice(n[r], 1)
            }
            return E = null, e
        }, w = t.getText = function (e) {
            var t, n = "", r = 0, i = e.nodeType;
            if (i) {
                if (1 === i || 9 === i || 11 === i) {
                    if ("string" == typeof e.textContent) return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling) n += w(e)
                } else if (3 === i || 4 === i) return e.nodeValue
            } else for (; t = e[r++];) n += w(t);
            return n
        }, (b = t.selectors = {
            cacheLength: 50, createPseudo: r, match: fe, attrHandle: {}, find: {}, relative: {
                ">": {
                    dir: "parentNode", first: !0
                }, " ": {
                    dir: "parentNode"
                }, "+": {
                    dir: "previousSibling", first: !0
                }, "~": {
                    dir: "previousSibling"
                }
            }, preFilter: {
                ATTR: function (e) {
                    return e[1] = e[1].replace(ye, xe), e[3] = (e[3] || e[4] || e[5] || "").replace(ye, xe), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
                }, CHILD: function (e) {
                    return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || t.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && t.error(e[0]), e
                }, PSEUDO: function (e) {
                    var t, n = !e[6] && e[2];
                    return fe.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && le.test(n) && (t = T(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3))
                }
            }, filter: {
                TAG: function (e) {
                    var t = e.replace(ye, xe).toLowerCase();
                    return "*" === e ? function () {
                        return !0
                    } : function (e) {
                        return e.nodeName && e.nodeName.toLowerCase() === t
                    }
                }, CLASS: function (e) {
                    var t = W[e + " "];
                    return t || (t = new RegExp("(^|" + ee + ")" + e + "(" + ee + "|$)")) && W(e, function (e) {
                        return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
                    })
                }, ATTR: function (e, n, r) {
                    return function (i) {
                        var o = t.attr(i, e);
                        return null == o ? "!=" === n : !n || (o += "", "=" === n ? o === r : "!=" === n ? o !== r : "^=" === n ? r && 0 === o.indexOf(r) : "*=" === n ? r && o.indexOf(r) > -1 : "$=" === n ? r && o.slice(-r.length) === r : "~=" === n ? (" " + o.replace(ie, " ") + " ").indexOf(r) > -1 : "|=" === n && (o === r || o.slice(0, r.length + 1) === r + "-"))
                    }
                }, CHILD: function (e, t, n, r, i) {
                    var o = "nth" !== e.slice(0, 3), s = "last" !== e.slice(-4), a = "of-type" === t;
                    return 1 === r && 0 === i ? function (e) {
                        return !!e.parentNode
                    } : function (t, n, u) {
                        var l, c, f, p, d, h, v = o !== s ? "nextSibling" : "previousSibling", m = t.parentNode,
                            g = a && t.nodeName.toLowerCase(), y = !u && !a, x = !1;
                        if (m) {
                            if (o) {
                                for (; v;) {
                                    for (p = t; p = p[v];) if (a ? p.nodeName.toLowerCase() === g : 1 === p.nodeType) return !1;
                                    h = v = "only" === e && !h && "nextSibling"
                                }
                                return !0
                            }
                            if (h = [s ? m.firstChild : m.lastChild], s && y) {
                                for (x = (d = (l = (c = (f = (p = m)[R] || (p[R] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] || [])[0] === M && l[1]) && l[2], p = d && m.childNodes[d]; p = ++d && p && p[v] || (x = d = 0) || h.pop();) if (1 === p.nodeType && ++x && p === t) {
                                    c[e] = [M, d, x];
                                    break
                                }
                            } else if (y && (x = d = (l = (c = (f = (p = t)[R] || (p[R] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] || [])[0] === M && l[1]), !1 === x) for (; (p = ++d && p && p[v] || (x = d = 0) || h.pop()) && ((a ? p.nodeName.toLowerCase() !== g : 1 !== p.nodeType) || !++x || (y && ((c = (f = p[R] || (p[R] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] = [M, x]), p !== t));) ;
                            return (x -= i) === r || x % r == 0 && x / r >= 0
                        }
                    }
                }, PSEUDO: function (e, n) {
                    var i, o = b.pseudos[e] || b.setFilters[e.toLowerCase()] || t.error("unsupported pseudo: " + e);
                    return o[R] ? o(n) : o.length > 1 ? (i = [e, e, "", n], b.setFilters.hasOwnProperty(e.toLowerCase()) ? r(function (e, t) {
                        for (var r, i = o(e, n), s = i.length; s--;) e[r = K(e, i[s])] = !(t[r] = i[s])
                    }) : function (e) {
                        return o(e, 0, i)
                    }) : o
                }
            }, pseudos: {
                not: r(function (e) {
                    var t = [], n = [], i = $(e.replace(oe, "$1"));
                    return i[R] ? r(function (e, t, n, r) {
                        for (var o, s = i(e, null, r, []), a = e.length; a--;) (o = s[a]) && (e[a] = !(t[a] = o))
                    }) : function (e, r, o) {
                        return t[0] = e, i(t, null, o, n), t[0] = null, !n.pop()
                    }
                }), has: r(function (e) {
                    return function (n) {
                        return t(e, n).length > 0
                    }
                }), contains: r(function (e) {
                    return e = e.replace(ye, xe), function (t) {
                        return (t.textContent || t.innerText || w(t)).indexOf(e) > -1
                    }
                }), lang: r(function (e) {
                    return ce.test(e || "") || t.error("unsupported lang: " + e), e = e.replace(ye, xe).toLowerCase(), function (t) {
                        var n;
                        do {
                            if (n = q ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-")
                        } while ((t = t.parentNode) && 1 === t.nodeType);
                        return !1
                    }
                }), target: function (t) {
                    var n = e.location && e.location.hash;
                    return n && n.slice(1) === t.id
                }, root: function (e) {
                    return e === A
                }, focus: function (e) {
                    return e === j.activeElement && (!j.hasFocus || j.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                }, enabled: function (e) {
                    return !1 === e.disabled
                }, disabled: function (e) {
                    return !0 === e.disabled
                }, checked: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && !!e.checked || "option" === t && !!e.selected
                }, selected: function (e) {
                    return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
                }, empty: function (e) {
                    for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                    return !0
                }, parent: function (e) {
                    return !b.pseudos.empty(e)
                }, header: function (e) {
                    return de.test(e.nodeName)
                }, input: function (e) {
                    return pe.test(e.nodeName)
                }, button: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && "button" === e.type || "button" === t
                }, text: function (e) {
                    var t;
                    return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                }, first: a(function () {
                    return [0]
                }), last: a(function (e, t) {
                    return [t - 1]
                }), eq: a(function (e, t, n) {
                    return [n < 0 ? n + t : n]
                }), even: a(function (e, t) {
                    for (var n = 0; n < t; n += 2) e.push(n);
                    return e
                }), odd: a(function (e, t) {
                    for (var n = 1; n < t; n += 2) e.push(n);
                    return e
                }), lt: a(function (e, t, n) {
                    for (var r = n < 0 ? n + t : n; --r >= 0;) e.push(r);
                    return e
                }), gt: a(function (e, t, n) {
                    for (var r = n < 0 ? n + t : n; ++r < t;) e.push(r);
                    return e
                })
            }
        }).pseudos.nth = b.pseudos.eq;
        for (y in {
            radio: !0, checkbox: !0, file: !0, password: !0, image: !0
        }) b.pseudos[y] = function (e) {
            return function (t) {
                return "input" === t.nodeName.toLowerCase() && t.type === e
            }
        }(y);
        for (y in {
            submit: !0, reset: !0
        }) b.pseudos[y] = function (e) {
            return function (t) {
                var n = t.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && t.type === e
            }
        }(y);
        return l.prototype = b.filters = b.pseudos, b.setFilters = new l, T = t.tokenize = function (e, n) {
            var r, i, o, s, a, u, l, c = _[e + " "];
            if (c) return n ? 0 : c.slice(0);
            for (a = e, u = [], l = b.preFilter; a;) {
                r && !(i = se.exec(a)) || (i && (a = a.slice(i[0].length) || a), u.push(o = [])), r = !1, (i = ae.exec(a)) && (r = i.shift(), o.push({
                    value: r, type: i[0].replace(oe, " ")
                }), a = a.slice(r.length));
                for (s in b.filter) !(i = fe[s].exec(a)) || l[s] && !(i = l[s](i)) || (r = i.shift(), o.push({
                    value: r, type: s, matches: i
                }), a = a.slice(r.length));
                if (!r) break
            }
            return n ? a.length : a ? t.error(e) : _(e, u).slice(0)
        }, $ = t.compile = function (e, t) {
            var n, r = [], i = [], o = B[e + " "];
            if (!o) {
                for (t || (t = T(e)), n = t.length; n--;) (o = m(t[n]))[R] ? r.push(o) : i.push(o);
                (o = B(e, g(i, r))).selector = e
            }
            return o
        }, k = t.select = function (e, t, n, r) {
            var i, o, s, a, l, f = "function" == typeof e && e, p = !r && T(e = f.selector || e);
            if (n = n || [], 1 === p.length) {
                if ((o = p[0] = p[0].slice(0)).length > 2 && "ID" === (s = o[0]).type && x.getById && 9 === t.nodeType && q && b.relative[o[1].type]) {
                    if (!(t = (b.find.ID(s.matches[0].replace(ye, xe), t) || [])[0])) return n;
                    f && (t = t.parentNode), e = e.slice(o.shift().value.length)
                }
                for (i = fe.needsContext.test(e) ? 0 : o.length; i-- && (s = o[i], !b.relative[a = s.type]);) if ((l = b.find[a]) && (r = l(s.matches[0].replace(ye, xe), me.test(o[0].type) && u(t.parentNode) || t))) {
                    if (o.splice(i, 1), !(e = r.length && c(o))) return J.apply(n, r), n;
                    break
                }
            }
            return (f || $(e, p))(r, t, !q, n, !t || me.test(e) && u(t.parentNode) || t), n
        }, x.sortStable = R.split("").sort(U).join("") === R, x.detectDuplicates = !!N, D(), x.sortDetached = i(function (e) {
            return 1 & e.compareDocumentPosition(j.createElement("div"))
        }), i(function (e) {
            return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
        }) || o("type|href|height|width", function (e, t, n) {
            if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
        }), x.attributes && i(function (e) {
            return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
        }) || o("value", function (e, t, n) {
            if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue
        }), i(function (e) {
            return null == e.getAttribute("disabled")
        }) || o(Z, function (e, t, n) {
            var r;
            if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null
        }), t
    }(e);
    re.find = ue, re.expr = ue.selectors, re.expr[":"] = re.expr.pseudos, re.uniqueSort = re.unique = ue.uniqueSort, re.text = ue.getText, re.isXMLDoc = ue.isXML, re.contains = ue.contains;
    var le = function (e, t, n) {
        for (var r = [], i = void 0 !== n; (e = e[t]) && 9 !== e.nodeType;) if (1 === e.nodeType) {
            if (i && re(e).is(n)) break;
            r.push(e)
        }
        return r
    }, ce = function (e, t) {
        for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
        return n
    }, fe = re.expr.match.needsContext, pe = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/, de = /^.[^:#\[\.,]*$/;
    re.filter = function (e, t, n) {
        var r = t[0];
        return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === r.nodeType ? re.find.matchesSelector(r, e) ? [r] : [] : re.find.matches(e, re.grep(t, function (e) {
            return 1 === e.nodeType
        }))
    }, re.fn.extend({
        find: function (e) {
            var t, n = this.length, r = [], i = this;
            if ("string" != typeof e) return this.pushStack(re(e).filter(function () {
                for (t = 0; t < n; t++) if (re.contains(i[t], this)) return !0
            }));
            for (t = 0; t < n; t++) re.find(e, i[t], r);
            return r = this.pushStack(n > 1 ? re.unique(r) : r), r.selector = this.selector ? this.selector + " " + e : e, r
        }, filter: function (e) {
            return this.pushStack(r(this, e || [], !1))
        }, not: function (e) {
            return this.pushStack(r(this, e || [], !0))
        }, is: function (e) {
            return !!r(this, "string" == typeof e && fe.test(e) ? re(e) : e || [], !1).length
        }
    });
    var he, ve = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
    (re.fn.init = function (e, t, n) {
        var r, i;
        if (!e) return this;
        if (n = n || he, "string" == typeof e) {
            if (!(r = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : ve.exec(e)) || !r[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
            if (r[1]) {
                if (t = t instanceof re ? t[0] : t, re.merge(this, re.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : Y, !0)), pe.test(r[1]) && re.isPlainObject(t)) for (r in t) re.isFunction(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
                return this
            }
            return (i = Y.getElementById(r[2])) && i.parentNode && (this.length = 1, this[0] = i), this.context = Y, this.selector = e, this
        }
        return e.nodeType ? (this.context = this[0] = e, this.length = 1, this) : re.isFunction(e) ? void 0 !== n.ready ? n.ready(e) : e(re) : (void 0 !== e.selector && (this.selector = e.selector, this.context = e.context), re.makeArray(e, this))
    }).prototype = re.fn, he = re(Y);
    var me = /^(?:parents|prev(?:Until|All))/, ge = {
        children: !0, contents: !0, next: !0, prev: !0
    };
    re.fn.extend({
        has: function (e) {
            var t = re(e, this), n = t.length;
            return this.filter(function () {
                for (var e = 0; e < n; e++) if (re.contains(this, t[e])) return !0
            })
        }, closest: function (e, t) {
            for (var n, r = 0, i = this.length, o = [], s = fe.test(e) || "string" != typeof e ? re(e, t || this.context) : 0; r < i; r++) for (n = this[r]; n && n !== t; n = n.parentNode) if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && re.find.matchesSelector(n, e))) {
                o.push(n);
                break
            }
            return this.pushStack(o.length > 1 ? re.uniqueSort(o) : o)
        }, index: function (e) {
            return e ? "string" == typeof e ? K.call(re(e), this[0]) : K.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        }, add: function (e, t) {
            return this.pushStack(re.uniqueSort(re.merge(this.get(), re(e, t))))
        }, addBack: function (e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }
    }), re.each({
        parent: function (e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null
        }, parents: function (e) {
            return le(e, "parentNode")
        }, parentsUntil: function (e, t, n) {
            return le(e, "parentNode", n)
        }, next: function (e) {
            return i(e, "nextSibling")
        }, prev: function (e) {
            return i(e, "previousSibling")
        }, nextAll: function (e) {
            return le(e, "nextSibling")
        }, prevAll: function (e) {
            return le(e, "previousSibling")
        }, nextUntil: function (e, t, n) {
            return le(e, "nextSibling", n)
        }, prevUntil: function (e, t, n) {
            return le(e, "previousSibling", n)
        }, siblings: function (e) {
            return ce((e.parentNode || {}).firstChild, e)
        }, children: function (e) {
            return ce(e.firstChild)
        }, contents: function (e) {
            return e.contentDocument || re.merge([], e.childNodes)
        }
    }, function (e, t) {
        re.fn[e] = function (n, r) {
            var i = re.map(this, t, n);
            return "Until" !== e.slice(-5) && (r = n), r && "string" == typeof r && (i = re.filter(r, i)), this.length > 1 && (ge[e] || re.uniqueSort(i), me.test(e) && i.reverse()), this.pushStack(i)
        }
    });
    var ye = /\S+/g;
    re.Callbacks = function (e) {
        e = "string" == typeof e ? o(e) : re.extend({}, e);
        var t, n, r, i, s = [], a = [], u = -1, l = function () {
            for (i = e.once, r = t = !0; a.length; u = -1) for (n = a.shift(); ++u < s.length;) !1 === s[u].apply(n[0], n[1]) && e.stopOnFalse && (u = s.length, n = !1);
            e.memory || (n = !1), t = !1, i && (s = n ? [] : "")
        }, c = {
            add: function () {
                return s && (n && !t && (u = s.length - 1, a.push(n)), function t(n) {
                    re.each(n, function (n, r) {
                        re.isFunction(r) ? e.unique && c.has(r) || s.push(r) : r && r.length && "string" !== re.type(r) && t(r)
                    })
                }(arguments), n && !t && l()), this
            }, remove: function () {
                return re.each(arguments, function (e, t) {
                    for (var n; (n = re.inArray(t, s, n)) > -1;) s.splice(n, 1), n <= u && u--
                }), this
            }, has: function (e) {
                return e ? re.inArray(e, s) > -1 : s.length > 0
            }, empty: function () {
                return s && (s = []), this
            }, disable: function () {
                return i = a = [], s = n = "", this
            }, disabled: function () {
                return !s
            }, lock: function () {
                return i = a = [], n || (s = n = ""), this
            }, locked: function () {
                return !!i
            }, fireWith: function (e, n) {
                return i || (n = [e, (n = n || []).slice ? n.slice() : n], a.push(n), t || l()), this
            }, fire: function () {
                return c.fireWith(this, arguments), this
            }, fired: function () {
                return !!r
            }
        };
        return c
    }, re.extend({
        Deferred: function (e) {
            var t = [["resolve", "done", re.Callbacks("once memory"), "resolved"], ["reject", "fail", re.Callbacks("once memory"), "rejected"], ["notify", "progress", re.Callbacks("memory")]],
                n = "pending", r = {
                    state: function () {
                        return n
                    }, always: function () {
                        return i.done(arguments).fail(arguments), this
                    }, then: function () {
                        var e = arguments;
                        return re.Deferred(function (n) {
                            re.each(t, function (t, o) {
                                var s = re.isFunction(e[t]) && e[t];
                                i[o[1]](function () {
                                    var e = s && s.apply(this, arguments);
                                    e && re.isFunction(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[o[0] + "With"](this === r ? n.promise() : this, s ? [e] : arguments)
                                })
                            }), e = null
                        }).promise()
                    }, promise: function (e) {
                        return null != e ? re.extend(e, r) : r
                    }
                }, i = {};
            return r.pipe = r.then, re.each(t, function (e, o) {
                var s = o[2], a = o[3];
                r[o[1]] = s.add, a && s.add(function () {
                    n = a
                }, t[1 ^ e][2].disable, t[2][2].lock), i[o[0]] = function () {
                    return i[o[0] + "With"](this === i ? r : this, arguments), this
                }, i[o[0] + "With"] = s.fireWith
            }), r.promise(i), e && e.call(i, i), i
        }, when: function (e) {
            var t, n, r, i = 0, o = G.call(arguments), s = o.length,
                a = 1 !== s || e && re.isFunction(e.promise) ? s : 0, u = 1 === a ? e : re.Deferred(),
                l = function (e, n, r) {
                    return function (i) {
                        n[e] = this, r[e] = arguments.length > 1 ? G.call(arguments) : i, r === t ? u.notifyWith(n, r) : --a || u.resolveWith(n, r)
                    }
                };
            if (s > 1) for (t = new Array(s), n = new Array(s), r = new Array(s); i < s; i++) o[i] && re.isFunction(o[i].promise) ? o[i].promise().progress(l(i, n, t)).done(l(i, r, o)).fail(u.reject) : --a;
            return a || u.resolveWith(r, o), u.promise()
        }
    });
    var xe;
    re.fn.ready = function (e) {
        return re.ready.promise().done(e), this
    }, re.extend({
        isReady: !1, readyWait: 1, holdReady: function (e) {
            e ? re.readyWait++ : re.ready(!0)
        }, ready: function (e) {
            (!0 === e ? --re.readyWait : re.isReady) || (re.isReady = !0, !0 !== e && --re.readyWait > 0 || (xe.resolveWith(Y, [re]), re.fn.triggerHandler && (re(Y).triggerHandler("ready"), re(Y).off("ready"))))
        }
    }), re.ready.promise = function (t) {
        return xe || (xe = re.Deferred(), "complete" === Y.readyState || "loading" !== Y.readyState && !Y.documentElement.doScroll ? e.setTimeout(re.ready) : (Y.addEventListener("DOMContentLoaded", s), e.addEventListener("load", s))), xe.promise(t)
    }, re.ready.promise();
    var be = function (e, t, n, r, i, o, s) {
        var a = 0, u = e.length, l = null == n;
        if ("object" === re.type(n)) {
            i = !0;
            for (a in n) be(e, t, a, n[a], !0, o, s)
        } else if (void 0 !== r && (i = !0, re.isFunction(r) || (s = !0), l && (s ? (t.call(e, r), t = null) : (l = t, t = function (e, t, n) {
            return l.call(re(e), n)
        })), t)) for (; a < u; a++) t(e[a], n, s ? r : r.call(e[a], a, t(e[a], n)));
        return i ? e : l ? t.call(e) : u ? t(e[0], n) : o
    }, we = function (e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
    };
    a.uid = 1, a.prototype = {
        register: function (e, t) {
            var n = t || {};
            return e.nodeType ? e[this.expando] = n : Object.defineProperty(e, this.expando, {
                value: n, writable: !0, configurable: !0
            }), e[this.expando]
        }, cache: function (e) {
            if (!we(e)) return {};
            var t = e[this.expando];
            return t || (t = {}, we(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                value: t, configurable: !0
            }))), t
        }, set: function (e, t, n) {
            var r, i = this.cache(e);
            if ("string" == typeof t) i[t] = n; else for (r in t) i[r] = t[r];
            return i
        }, get: function (e, t) {
            return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][t]
        }, access: function (e, t, n) {
            var r;
            return void 0 === t || t && "string" == typeof t && void 0 === n ? void 0 !== (r = this.get(e, t)) ? r : this.get(e, re.camelCase(t)) : (this.set(e, t, n), void 0 !== n ? n : t)
        }, remove: function (e, t) {
            var n, r, i, o = e[this.expando];
            if (void 0 !== o) {
                if (void 0 === t) this.register(e); else {
                    re.isArray(t) ? r = t.concat(t.map(re.camelCase)) : (i = re.camelCase(t), r = t in o ? [t, i] : (r = i) in o ? [r] : r.match(ye) || []), n = r.length;
                    for (; n--;) delete o[r[n]]
                }
                (void 0 === t || re.isEmptyObject(o)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
            }
        }, hasData: function (e) {
            var t = e[this.expando];
            return void 0 !== t && !re.isEmptyObject(t)
        }
    };
    var Ce = new a, Te = new a, $e = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, ke = /[A-Z]/g;
    re.extend({
        hasData: function (e) {
            return Te.hasData(e) || Ce.hasData(e)
        }, data: function (e, t, n) {
            return Te.access(e, t, n)
        }, removeData: function (e, t) {
            Te.remove(e, t)
        }, _data: function (e, t, n) {
            return Ce.access(e, t, n)
        }, _removeData: function (e, t) {
            Ce.remove(e, t)
        }
    }), re.fn.extend({
        data: function (e, t) {
            var n, r, i, o = this[0], s = o && o.attributes;
            if (void 0 === e) {
                if (this.length && (i = Te.get(o), 1 === o.nodeType && !Ce.get(o, "hasDataAttrs"))) {
                    for (n = s.length; n--;) s[n] && 0 === (r = s[n].name).indexOf("data-") && (r = re.camelCase(r.slice(5)), u(o, r, i[r]));
                    Ce.set(o, "hasDataAttrs", !0)
                }
                return i
            }
            return "object" == typeof e ? this.each(function () {
                Te.set(this, e)
            }) : be(this, function (t) {
                var n, r;
                if (o && void 0 === t) {
                    if (void 0 !== (n = Te.get(o, e) || Te.get(o, e.replace(ke, "-$&").toLowerCase()))) return n;
                    if (r = re.camelCase(e), void 0 !== (n = Te.get(o, r))) return n;
                    if (void 0 !== (n = u(o, r, void 0))) return n
                } else r = re.camelCase(e), this.each(function () {
                    var n = Te.get(this, r);
                    Te.set(this, r, t), e.indexOf("-") > -1 && void 0 !== n && Te.set(this, e, t)
                })
            }, null, t, arguments.length > 1, null, !0)
        }, removeData: function (e) {
            return this.each(function () {
                Te.remove(this, e)
            })
        }
    }), re.extend({
        queue: function (e, t, n) {
            var r;
            if (e) return t = (t || "fx") + "queue", r = Ce.get(e, t), n && (!r || re.isArray(n) ? r = Ce.access(e, t, re.makeArray(n)) : r.push(n)), r || []
        }, dequeue: function (e, t) {
            t = t || "fx";
            var n = re.queue(e, t), r = n.length, i = n.shift(), o = re._queueHooks(e, t);
            "inprogress" === i && (i = n.shift(), r--), i && ("fx" === t && n.unshift("inprogress"), delete o.stop, i.call(e, function () {
                re.dequeue(e, t)
            }, o)), !r && o && o.empty.fire()
        }, _queueHooks: function (e, t) {
            var n = t + "queueHooks";
            return Ce.get(e, n) || Ce.access(e, n, {
                empty: re.Callbacks("once memory").add(function () {
                    Ce.remove(e, [t + "queue", n])
                })
            })
        }
    }), re.fn.extend({
        queue: function (e, t) {
            var n = 2;
            return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? re.queue(this[0], e) : void 0 === t ? this : this.each(function () {
                var n = re.queue(this, e, t);
                re._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && re.dequeue(this, e)
            })
        }, dequeue: function (e) {
            return this.each(function () {
                re.dequeue(this, e)
            })
        }, clearQueue: function (e) {
            return this.queue(e || "fx", [])
        }, promise: function (e, t) {
            var n, r = 1, i = re.Deferred(), o = this, s = this.length, a = function () {
                --r || i.resolveWith(o, [o])
            };
            for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; s--;) (n = Ce.get(o[s], e + "queueHooks")) && n.empty && (r++, n.empty.add(a));
            return a(), i.promise(t)
        }
    });
    var Se = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, Ee = new RegExp("^(?:([+-])=|)(" + Se + ")([a-z%]*)$", "i"),
        Ne = ["Top", "Right", "Bottom", "Left"], De = function (e, t) {
            return e = t || e, "none" === re.css(e, "display") || !re.contains(e.ownerDocument, e)
        }, je = /^(?:checkbox|radio)$/i, Ae = /<([\w:-]+)/, qe = /^$|\/(?:java|ecma)script/i, Le = {
            option: [1, "<select multiple='multiple'>", "</select>"],
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""]
        };
    Le.optgroup = Le.option, Le.tbody = Le.tfoot = Le.colgroup = Le.caption = Le.thead, Le.th = Le.td;
    var He = /<|&#?\w+;/;
    !function () {
        var e = Y.createDocumentFragment().appendChild(Y.createElement("div")), t = Y.createElement("input");
        t.setAttribute("type", "radio"), t.setAttribute("checked", "checked"), t.setAttribute("name", "t"), e.appendChild(t), ne.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked, e.innerHTML = "<textarea>x</textarea>", ne.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue
    }();
    var Oe = /^key/, Fe = /^(?:mouse|pointer|contextmenu|drag|drop)|click/, Re = /^([^.]*)(?:\.(.+)|)/;
    re.event = {
        global: {},
        add: function (e, t, n, r, i) {
            var o, s, a, u, l, c, f, p, d, h, v, m = Ce.get(e);
            if (m) for (n.handler && (n = (o = n).handler, i = o.selector), n.guid || (n.guid = re.guid++), (u = m.events) || (u = m.events = {}), (s = m.handle) || (s = m.handle = function (t) {
                return void 0 !== re && re.event.triggered !== t.type ? re.event.dispatch.apply(e, arguments) : void 0
            }), l = (t = (t || "").match(ye) || [""]).length; l--;) d = v = (a = Re.exec(t[l]) || [])[1], h = (a[2] || "").split(".").sort(), d && (f = re.event.special[d] || {}, d = (i ? f.delegateType : f.bindType) || d, f = re.event.special[d] || {}, c = re.extend({
                type: d,
                origType: v,
                data: r,
                handler: n,
                guid: n.guid,
                selector: i,
                needsContext: i && re.expr.match.needsContext.test(i),
                namespace: h.join(".")
            }, o), (p = u[d]) || ((p = u[d] = []).delegateCount = 0, f.setup && !1 !== f.setup.call(e, r, h, s) || e.addEventListener && e.addEventListener(d, s)), f.add && (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)), i ? p.splice(p.delegateCount++, 0, c) : p.push(c), re.event.global[d] = !0)
        },
        remove: function (e, t, n, r, i) {
            var o, s, a, u, l, c, f, p, d, h, v, m = Ce.hasData(e) && Ce.get(e);
            if (m && (u = m.events)) {
                for (l = (t = (t || "").match(ye) || [""]).length; l--;) if (a = Re.exec(t[l]) || [], d = v = a[1], h = (a[2] || "").split(".").sort(), d) {
                    for (f = re.event.special[d] || {}, p = u[d = (r ? f.delegateType : f.bindType) || d] || [], a = a[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = o = p.length; o--;) c = p[o], !i && v !== c.origType || n && n.guid !== c.guid || a && !a.test(c.namespace) || r && r !== c.selector && ("**" !== r || !c.selector) || (p.splice(o, 1), c.selector && p.delegateCount--, f.remove && f.remove.call(e, c));
                    s && !p.length && (f.teardown && !1 !== f.teardown.call(e, h, m.handle) || re.removeEvent(e, d, m.handle), delete u[d])
                } else for (d in u) re.event.remove(e, d + t[l], n, r, !0);
                re.isEmptyObject(u) && Ce.remove(e, "handle events")
            }
        },
        dispatch: function (e) {
            e = re.event.fix(e);
            var t, n, r, i, o, s = [], a = G.call(arguments), u = (Ce.get(this, "events") || {})[e.type] || [],
                l = re.event.special[e.type] || {};
            if (a[0] = e, e.delegateTarget = this, !l.preDispatch || !1 !== l.preDispatch.call(this, e)) {
                for (s = re.event.handlers.call(this, e, u), t = 0; (i = s[t++]) && !e.isPropagationStopped();) for (e.currentTarget = i.elem, n = 0; (o = i.handlers[n++]) && !e.isImmediatePropagationStopped();) e.rnamespace && !e.rnamespace.test(o.namespace) || (e.handleObj = o, e.data = o.data, void 0 !== (r = ((re.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, a)) && !1 === (e.result = r) && (e.preventDefault(), e.stopPropagation()));
                return l.postDispatch && l.postDispatch.call(this, e), e.result
            }
        },
        handlers: function (e, t) {
            var n, r, i, o, s = [], a = t.delegateCount, u = e.target;
            if (a && u.nodeType && ("click" !== e.type || isNaN(e.button) || e.button < 1)) for (; u !== this; u = u.parentNode || this) if (1 === u.nodeType && (!0 !== u.disabled || "click" !== e.type)) {
                for (r = [], n = 0; n < a; n++) void 0 === r[i = (o = t[n]).selector + " "] && (r[i] = o.needsContext ? re(i, this).index(u) > -1 : re.find(i, this, null, [u]).length), r[i] && r.push(o);
                r.length && s.push({
                    elem: u, handlers: r
                })
            }
            return a < t.length && s.push({
                elem: this, handlers: t.slice(a)
            }), s
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "), filter: function (e, t) {
                return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function (e, t) {
                var n, r, i, o = t.button;
                return null == e.pageX && null != t.clientX && (r = (n = e.target.ownerDocument || Y).documentElement, i = n.body, e.pageX = t.clientX + (r && r.scrollLeft || i && i.scrollLeft || 0) - (r && r.clientLeft || i && i.clientLeft || 0), e.pageY = t.clientY + (r && r.scrollTop || i && i.scrollTop || 0) - (r && r.clientTop || i && i.clientTop || 0)), e.which || void 0 === o || (e.which = 1 & o ? 1 : 2 & o ? 3 : 4 & o ? 2 : 0), e
            }
        },
        fix: function (e) {
            if (e[re.expando]) return e;
            var t, n, r, i = e.type, o = e, s = this.fixHooks[i];
            for (s || (this.fixHooks[i] = s = Fe.test(i) ? this.mouseHooks : Oe.test(i) ? this.keyHooks : {}), r = s.props ? this.props.concat(s.props) : this.props, e = new re.Event(o), t = r.length; t--;) e[n = r[t]] = o[n];
            return e.target || (e.target = Y), 3 === e.target.nodeType && (e.target = e.target.parentNode), s.filter ? s.filter(e, o) : e
        },
        special: {
            load: {
                noBubble: !0
            }, focus: {
                trigger: function () {
                    if (this !== v() && this.focus) return this.focus(), !1
                }, delegateType: "focusin"
            }, blur: {
                trigger: function () {
                    if (this === v() && this.blur) return this.blur(), !1
                }, delegateType: "focusout"
            }, click: {
                trigger: function () {
                    if ("checkbox" === this.type && this.click && re.nodeName(this, "input")) return this.click(), !1
                }, _default: function (e) {
                    return re.nodeName(e.target, "a")
                }
            }, beforeunload: {
                postDispatch: function (e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                }
            }
        }
    }, re.removeEvent = function (e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n)
    }, re.Event = function (e, t) {
        if (!(this instanceof re.Event)) return new re.Event(e, t);
        e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? d : h) : this.type = e, t && re.extend(this, t), this.timeStamp = e && e.timeStamp || re.now(), this[re.expando] = !0
    }, re.Event.prototype = {
        constructor: re.Event,
        isDefaultPrevented: h,
        isPropagationStopped: h,
        isImmediatePropagationStopped: h,
        isSimulated: !1,
        preventDefault: function () {
            var e = this.originalEvent;
            this.isDefaultPrevented = d, e && !this.isSimulated && e.preventDefault()
        },
        stopPropagation: function () {
            var e = this.originalEvent;
            this.isPropagationStopped = d, e && !this.isSimulated && e.stopPropagation()
        },
        stopImmediatePropagation: function () {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = d, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation()
        }
    }, re.each({
        mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout"
    }, function (e, t) {
        re.event.special[e] = {
            delegateType: t, bindType: t, handle: function (e) {
                var n, r = this, i = e.relatedTarget, o = e.handleObj;
                return i && (i === r || re.contains(r, i)) || (e.type = o.origType, n = o.handler.apply(this, arguments), e.type = t), n
            }
        }
    }), re.fn.extend({
        on: function (e, t, n, r) {
            return m(this, e, t, n, r)
        }, one: function (e, t, n, r) {
            return m(this, e, t, n, r, 1)
        }, off: function (e, t, n) {
            var r, i;
            if (e && e.preventDefault && e.handleObj) return r = e.handleObj, re(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;
            if ("object" == typeof e) {
                for (i in e) this.off(i, t, e[i]);
                return this
            }
            return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = h), this.each(function () {
                re.event.remove(this, e, n, t)
            })
        }
    });
    var Pe = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi, Me = /<script|<style|<link/i,
        Ie = /checked\s*(?:[^=]|=\s*.checked.)/i, We = /^true\/(.*)/, _e = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    re.extend({
        htmlPrefilter: function (e) {
            return e.replace(Pe, "<$1></$2>")
        }, clone: function (e, t, n) {
            var r, i, o, s, a = e.cloneNode(!0), u = re.contains(e.ownerDocument, e);
            if (!(ne.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || re.isXMLDoc(e))) for (s = c(a), r = 0, i = (o = c(e)).length; r < i; r++) w(o[r], s[r]);
            if (t) if (n) for (o = o || c(e), s = s || c(a), r = 0, i = o.length; r < i; r++) b(o[r], s[r]); else b(e, a);
            return (s = c(a, "script")).length > 0 && f(s, !u && c(e, "script")), a
        }, cleanData: function (e) {
            for (var t, n, r, i = re.event.special, o = 0; void 0 !== (n = e[o]); o++) if (we(n)) {
                if (t = n[Ce.expando]) {
                    if (t.events) for (r in t.events) i[r] ? re.event.remove(n, r) : re.removeEvent(n, r, t.handle);
                    n[Ce.expando] = void 0
                }
                n[Te.expando] && (n[Te.expando] = void 0)
            }
        }
    }), re.fn.extend({
        domManip: C, detach: function (e) {
            return T(this, e, !0)
        }, remove: function (e) {
            return T(this, e)
        }, text: function (e) {
            return be(this, function (e) {
                return void 0 === e ? re.text(this) : this.empty().each(function () {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                })
            }, null, e, arguments.length)
        }, append: function () {
            return C(this, arguments, function (e) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || g(this, e).appendChild(e)
            })
        }, prepend: function () {
            return C(this, arguments, function (e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = g(this, e);
                    t.insertBefore(e, t.firstChild)
                }
            })
        }, before: function () {
            return C(this, arguments, function (e) {
                this.parentNode && this.parentNode.insertBefore(e, this)
            })
        }, after: function () {
            return C(this, arguments, function (e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
            })
        }, empty: function () {
            for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (re.cleanData(c(e, !1)), e.textContent = "");
            return this
        }, clone: function (e, t) {
            return e = null != e && e, t = null == t ? e : t, this.map(function () {
                return re.clone(this, e, t)
            })
        }, html: function (e) {
            return be(this, function (e) {
                var t = this[0] || {}, n = 0, r = this.length;
                if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                if ("string" == typeof e && !Me.test(e) && !Le[(Ae.exec(e) || ["", ""])[1].toLowerCase()]) {
                    e = re.htmlPrefilter(e);
                    try {
                        for (; n < r; n++) 1 === (t = this[n] || {}).nodeType && (re.cleanData(c(t, !1)), t.innerHTML = e);
                        t = 0
                    } catch (e) {
                    }
                }
                t && this.empty().append(e)
            }, null, e, arguments.length)
        }, replaceWith: function () {
            var e = [];
            return C(this, arguments, function (t) {
                var n = this.parentNode;
                re.inArray(this, e) < 0 && (re.cleanData(c(this)), n && n.replaceChild(t, this))
            }, e)
        }
    }), re.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function (e, t) {
        re.fn[e] = function (e) {
            for (var n, r = [], i = re(e), o = i.length - 1, s = 0; s <= o; s++) n = s === o ? this : this.clone(!0), re(i[s])[t](n), Q.apply(r, n.get());
            return this.pushStack(r)
        }
    });
    var Be, Ue = {
        HTML: "block", BODY: "block"
    }, Xe = /^margin/, ze = new RegExp("^(" + Se + ")(?!px)[a-z%]+$", "i"), Ve = function (t) {
        var n = t.ownerDocument.defaultView;
        return n && n.opener || (n = e), n.getComputedStyle(t)
    }, Ye = function (e, t, n, r) {
        var i, o, s = {};
        for (o in t) s[o] = e.style[o], e.style[o] = t[o];
        i = n.apply(e, r || []);
        for (o in t) e.style[o] = s[o];
        return i
    }, Ge = Y.documentElement;
    !function () {
        function t() {
            a.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%", a.innerHTML = "", Ge.appendChild(s);
            var t = e.getComputedStyle(a);
            n = "1%" !== t.top, o = "2px" === t.marginLeft, r = "4px" === t.width, a.style.marginRight = "50%", i = "4px" === t.marginRight, Ge.removeChild(s)
        }

        var n, r, i, o, s = Y.createElement("div"), a = Y.createElement("div");
        a.style && (a.style.backgroundClip = "content-box", a.cloneNode(!0).style.backgroundClip = "", ne.clearCloneStyle = "content-box" === a.style.backgroundClip, s.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute", s.appendChild(a), re.extend(ne, {
            pixelPosition: function () {
                return t(), n
            }, boxSizingReliable: function () {
                return null == r && t(), r
            }, pixelMarginRight: function () {
                return null == r && t(), i
            }, reliableMarginLeft: function () {
                return null == r && t(), o
            }, reliableMarginRight: function () {
                var t, n = a.appendChild(Y.createElement("div"));
                return n.style.cssText = a.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", n.style.marginRight = n.style.width = "0", a.style.width = "1px", Ge.appendChild(s), t = !parseFloat(e.getComputedStyle(n).marginRight), Ge.removeChild(s), a.removeChild(n), t
            }
        }))
    }();
    var Je = /^(none|table(?!-c[ea]).+)/, Qe = {
        position: "absolute", visibility: "hidden", display: "block"
    }, Ke = {
        letterSpacing: "0", fontWeight: "400"
    }, Ze = ["Webkit", "O", "Moz", "ms"], et = Y.createElement("div").style;
    re.extend({
        cssHooks: {
            opacity: {
                get: function (e, t) {
                    if (t) {
                        var n = S(e, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        }, cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        }, cssProps: {
            float: "cssFloat"
        }, style: function (e, t, n, r) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var i, o, s, a = re.camelCase(t), u = e.style;
                if (t = re.cssProps[a] || (re.cssProps[a] = N(a) || a), s = re.cssHooks[t] || re.cssHooks[a], void 0 === n) return s && "get" in s && void 0 !== (i = s.get(e, !1, r)) ? i : u[t];
                "string" == (o = typeof n) && (i = Ee.exec(n)) && i[1] && (n = l(e, t, i), o = "number"), null != n && n === n && ("number" === o && (n += i && i[3] || (re.cssNumber[a] ? "" : "px")), ne.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (u[t] = "inherit"), s && "set" in s && void 0 === (n = s.set(e, n, r)) || (u[t] = n))
            }
        }, css: function (e, t, n, r) {
            var i, o, s, a = re.camelCase(t);
            return t = re.cssProps[a] || (re.cssProps[a] = N(a) || a), (s = re.cssHooks[t] || re.cssHooks[a]) && "get" in s && (i = s.get(e, !0, n)), void 0 === i && (i = S(e, t, r)), "normal" === i && t in Ke && (i = Ke[t]), "" === n || n ? (o = parseFloat(i), !0 === n || isFinite(o) ? o || 0 : i) : i
        }
    }), re.each(["height", "width"], function (e, t) {
        re.cssHooks[t] = {
            get: function (e, n, r) {
                if (n) return Je.test(re.css(e, "display")) && 0 === e.offsetWidth ? Ye(e, Qe, function () {
                    return A(e, t, r)
                }) : A(e, t, r)
            }, set: function (e, n, r) {
                var i, o = r && Ve(e), s = r && j(e, t, r, "border-box" === re.css(e, "boxSizing", !1, o), o);
                return s && (i = Ee.exec(n)) && "px" !== (i[3] || "px") && (e.style[t] = n, n = re.css(e, t)), D(0, n, s)
            }
        }
    }), re.cssHooks.marginLeft = E(ne.reliableMarginLeft, function (e, t) {
        if (t) return (parseFloat(S(e, "marginLeft")) || e.getBoundingClientRect().left - Ye(e, {
            marginLeft: 0
        }, function () {
            return e.getBoundingClientRect().left
        })) + "px"
    }), re.cssHooks.marginRight = E(ne.reliableMarginRight, function (e, t) {
        if (t) return Ye(e, {
            display: "inline-block"
        }, S, [e, "marginRight"])
    }), re.each({
        margin: "", padding: "", border: "Width"
    }, function (e, t) {
        re.cssHooks[e + t] = {
            expand: function (n) {
                for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++) i[e + Ne[r] + t] = o[r] || o[r - 2] || o[0];
                return i
            }
        }, Xe.test(e) || (re.cssHooks[e + t].set = D)
    }), re.fn.extend({
        css: function (e, t) {
            return be(this, function (e, t, n) {
                var r, i, o = {}, s = 0;
                if (re.isArray(t)) {
                    for (r = Ve(e), i = t.length; s < i; s++) o[t[s]] = re.css(e, t[s], !1, r);
                    return o
                }
                return void 0 !== n ? re.style(e, t, n) : re.css(e, t)
            }, e, t, arguments.length > 1)
        }, show: function () {
            return q(this, !0)
        }, hide: function () {
            return q(this)
        }, toggle: function (e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
                De(this) ? re(this).show() : re(this).hide()
            })
        }
    }), re.Tween = L, L.prototype = {
        constructor: L, init: function (e, t, n, r, i, o) {
            this.elem = e, this.prop = n, this.easing = i || re.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = r, this.unit = o || (re.cssNumber[n] ? "" : "px")
        }, cur: function () {
            var e = L.propHooks[this.prop];
            return e && e.get ? e.get(this) : L.propHooks._default.get(this)
        }, run: function (e) {
            var t, n = L.propHooks[this.prop];
            return this.options.duration ? this.pos = t = re.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : L.propHooks._default.set(this), this
        }
    }, L.prototype.init.prototype = L.prototype, L.propHooks = {
        _default: {
            get: function (e) {
                var t;
                return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = re.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0
            }, set: function (e) {
                re.fx.step[e.prop] ? re.fx.step[e.prop](e) : 1 !== e.elem.nodeType || null == e.elem.style[re.cssProps[e.prop]] && !re.cssHooks[e.prop] ? e.elem[e.prop] = e.now : re.style(e.elem, e.prop, e.now + e.unit)
            }
        }
    }, L.propHooks.scrollTop = L.propHooks.scrollLeft = {
        set: function (e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
    }, re.easing = {
        linear: function (e) {
            return e
        }, swing: function (e) {
            return .5 - Math.cos(e * Math.PI) / 2
        }, _default: "swing"
    }, re.fx = L.prototype.init, re.fx.step = {};
    var tt, nt, rt = /^(?:toggle|show|hide)$/, it = /queueHooks$/;
    re.Animation = re.extend(P, {
        tweeners: {
            "*": [function (e, t) {
                var n = this.createTween(e, t);
                return l(n.elem, e, Ee.exec(t), n), n
            }]
        }, tweener: function (e, t) {
            re.isFunction(e) ? (t = e, e = ["*"]) : e = e.match(ye);
            for (var n, r = 0, i = e.length; r < i; r++) n = e[r], P.tweeners[n] = P.tweeners[n] || [], P.tweeners[n].unshift(t)
        }, prefilters: [function (e, t, n) {
            var r, i, o, s, a, u, l, c = this, f = {}, p = e.style, d = e.nodeType && De(e), h = Ce.get(e, "fxshow");
            n.queue || (null == (a = re._queueHooks(e, "fx")).unqueued && (a.unqueued = 0, u = a.empty.fire, a.empty.fire = function () {
                a.unqueued || u()
            }), a.unqueued++, c.always(function () {
                c.always(function () {
                    a.unqueued--, re.queue(e, "fx").length || a.empty.fire()
                })
            })), 1 === e.nodeType && ("height" in t || "width" in t) && (n.overflow = [p.overflow, p.overflowX, p.overflowY], "inline" === ("none" === (l = re.css(e, "display")) ? Ce.get(e, "olddisplay") || k(e.nodeName) : l) && "none" === re.css(e, "float") && (p.display = "inline-block")), n.overflow && (p.overflow = "hidden", c.always(function () {
                p.overflow = n.overflow[0], p.overflowX = n.overflow[1], p.overflowY = n.overflow[2]
            }));
            for (r in t) if (i = t[r], rt.exec(i)) {
                if (delete t[r], o = o || "toggle" === i, i === (d ? "hide" : "show")) {
                    if ("show" !== i || !h || void 0 === h[r]) continue;
                    d = !0
                }
                f[r] = h && h[r] || re.style(e, r)
            } else l = void 0;
            if (re.isEmptyObject(f)) "inline" === ("none" === l ? k(e.nodeName) : l) && (p.display = l); else {
                h ? "hidden" in h && (d = h.hidden) : h = Ce.access(e, "fxshow", {}), o && (h.hidden = !d), d ? re(e).show() : c.done(function () {
                    re(e).hide()
                }), c.done(function () {
                    var t;
                    Ce.remove(e, "fxshow");
                    for (t in f) re.style(e, t, f[t])
                });
                for (r in f) s = F(d ? h[r] : 0, r, c), r in h || (h[r] = s.start, d && (s.end = s.start, s.start = "width" === r || "height" === r ? 1 : 0))
            }
        }], prefilter: function (e, t) {
            t ? P.prefilters.unshift(e) : P.prefilters.push(e)
        }
    }), re.speed = function (e, t, n) {
        var r = e && "object" == typeof e ? re.extend({}, e) : {
            complete: n || !n && t || re.isFunction(e) && e, duration: e, easing: n && t || t && !re.isFunction(t) && t
        };
        return r.duration = re.fx.off ? 0 : "number" == typeof r.duration ? r.duration : r.duration in re.fx.speeds ? re.fx.speeds[r.duration] : re.fx.speeds._default, null != r.queue && !0 !== r.queue || (r.queue = "fx"), r.old = r.complete, r.complete = function () {
            re.isFunction(r.old) && r.old.call(this), r.queue && re.dequeue(this, r.queue)
        }, r
    }, re.fn.extend({
        fadeTo: function (e, t, n, r) {
            return this.filter(De).css("opacity", 0).show().end().animate({
                opacity: t
            }, e, n, r)
        }, animate: function (e, t, n, r) {
            var i = re.isEmptyObject(e), o = re.speed(t, n, r), s = function () {
                var t = P(this, re.extend({}, e), o);
                (i || Ce.get(this, "finish")) && t.stop(!0)
            };
            return s.finish = s, i || !1 === o.queue ? this.each(s) : this.queue(o.queue, s)
        }, stop: function (e, t, n) {
            var r = function (e) {
                var t = e.stop;
                delete e.stop, t(n)
            };
            return "string" != typeof e && (n = t, t = e, e = void 0), t && !1 !== e && this.queue(e || "fx", []), this.each(function () {
                var t = !0, i = null != e && e + "queueHooks", o = re.timers, s = Ce.get(this);
                if (i) s[i] && s[i].stop && r(s[i]); else for (i in s) s[i] && s[i].stop && it.test(i) && r(s[i]);
                for (i = o.length; i--;) o[i].elem !== this || null != e && o[i].queue !== e || (o[i].anim.stop(n), t = !1, o.splice(i, 1));
                !t && n || re.dequeue(this, e)
            })
        }, finish: function (e) {
            return !1 !== e && (e = e || "fx"), this.each(function () {
                var t, n = Ce.get(this), r = n[e + "queue"], i = n[e + "queueHooks"], o = re.timers,
                    s = r ? r.length : 0;
                for (n.finish = !0, re.queue(this, e, []), i && i.stop && i.stop.call(this, !0), t = o.length; t--;) o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
                for (t = 0; t < s; t++) r[t] && r[t].finish && r[t].finish.call(this);
                delete n.finish
            })
        }
    }), re.each(["toggle", "show", "hide"], function (e, t) {
        var n = re.fn[t];
        re.fn[t] = function (e, r, i) {
            return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(O(t, !0), e, r, i)
        }
    }), re.each({
        slideDown: O("show"), slideUp: O("hide"), slideToggle: O("toggle"), fadeIn: {
            opacity: "show"
        }, fadeOut: {
            opacity: "hide"
        }, fadeToggle: {
            opacity: "toggle"
        }
    }, function (e, t) {
        re.fn[e] = function (e, n, r) {
            return this.animate(t, e, n, r)
        }
    }), re.timers = [], re.fx.tick = function () {
        var e, t = 0, n = re.timers;
        for (tt = re.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
        n.length || re.fx.stop(), tt = void 0
    }, re.fx.timer = function (e) {
        re.timers.push(e), e() ? re.fx.start() : re.timers.pop()
    }, re.fx.interval = 13, re.fx.start = function () {
        nt || (nt = e.setInterval(re.fx.tick, re.fx.interval))
    }, re.fx.stop = function () {
        e.clearInterval(nt), nt = null
    }, re.fx.speeds = {
        slow: 600, fast: 200, _default: 400
    }, re.fn.delay = function (t, n) {
        return t = re.fx ? re.fx.speeds[t] || t : t, n = n || "fx", this.queue(n, function (n, r) {
            var i = e.setTimeout(n, t);
            r.stop = function () {
                e.clearTimeout(i)
            }
        })
    }, function () {
        var e = Y.createElement("input"), t = Y.createElement("select"), n = t.appendChild(Y.createElement("option"));
        e.type = "checkbox", ne.checkOn = "" !== e.value, ne.optSelected = n.selected, t.disabled = !0, ne.optDisabled = !n.disabled, (e = Y.createElement("input")).value = "t", e.type = "radio", ne.radioValue = "t" === e.value
    }();
    var ot, st = re.expr.attrHandle;
    re.fn.extend({
        attr: function (e, t) {
            return be(this, re.attr, e, t, arguments.length > 1)
        }, removeAttr: function (e) {
            return this.each(function () {
                re.removeAttr(this, e)
            })
        }
    }), re.extend({
        attr: function (e, t, n) {
            var r, i, o = e.nodeType;
            if (3 !== o && 8 !== o && 2 !== o) return void 0 === e.getAttribute ? re.prop(e, t, n) : (1 === o && re.isXMLDoc(e) || (t = t.toLowerCase(), i = re.attrHooks[t] || (re.expr.match.bool.test(t) ? ot : void 0)), void 0 !== n ? null === n ? void re.removeAttr(e, t) : i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e.setAttribute(t, n + ""), n) : i && "get" in i && null !== (r = i.get(e, t)) ? r : null == (r = re.find.attr(e, t)) ? void 0 : r)
        }, attrHooks: {
            type: {
                set: function (e, t) {
                    if (!ne.radioValue && "radio" === t && re.nodeName(e, "input")) {
                        var n = e.value;
                        return e.setAttribute("type", t), n && (e.value = n), t
                    }
                }
            }
        }, removeAttr: function (e, t) {
            var n, r, i = 0, o = t && t.match(ye);
            if (o && 1 === e.nodeType) for (; n = o[i++];) r = re.propFix[n] || n, re.expr.match.bool.test(n) && (e[r] = !1), e.removeAttribute(n)
        }
    }), ot = {
        set: function (e, t, n) {
            return !1 === t ? re.removeAttr(e, n) : e.setAttribute(n, n), n
        }
    }, re.each(re.expr.match.bool.source.match(/\w+/g), function (e, t) {
        var n = st[t] || re.find.attr;
        st[t] = function (e, t, r) {
            var i, o;
            return r || (o = st[t], st[t] = i, i = null != n(e, t, r) ? t.toLowerCase() : null, st[t] = o), i
        }
    });
    var at = /^(?:input|select|textarea|button)$/i, ut = /^(?:a|area)$/i;
    re.fn.extend({
        prop: function (e, t) {
            return be(this, re.prop, e, t, arguments.length > 1)
        }, removeProp: function (e) {
            return this.each(function () {
                delete this[re.propFix[e] || e]
            })
        }
    }), re.extend({
        prop: function (e, t, n) {
            var r, i, o = e.nodeType;
            if (3 !== o && 8 !== o && 2 !== o) return 1 === o && re.isXMLDoc(e) || (t = re.propFix[t] || t, i = re.propHooks[t]), void 0 !== n ? i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : e[t] = n : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t]
        }, propHooks: {
            tabIndex: {
                get: function (e) {
                    var t = re.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : at.test(e.nodeName) || ut.test(e.nodeName) && e.href ? 0 : -1
                }
            }
        }, propFix: {
            for: "htmlFor", class: "className"
        }
    }), ne.optSelected || (re.propHooks.selected = {
        get: function (e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex, null
        }, set: function (e) {
            var t = e.parentNode;
            t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex)
        }
    }), re.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
        re.propFix[this.toLowerCase()] = this
    });
    var lt = /[\t\r\n\f]/g;
    re.fn.extend({
        addClass: function (e) {
            var t, n, r, i, o, s, a, u = 0;
            if (re.isFunction(e)) return this.each(function (t) {
                re(this).addClass(e.call(this, t, M(this)))
            });
            if ("string" == typeof e && e) for (t = e.match(ye) || []; n = this[u++];) if (i = M(n), r = 1 === n.nodeType && (" " + i + " ").replace(lt, " ")) {
                for (s = 0; o = t[s++];) r.indexOf(" " + o + " ") < 0 && (r += o + " ");
                i !== (a = re.trim(r)) && n.setAttribute("class", a)
            }
            return this
        }, removeClass: function (e) {
            var t, n, r, i, o, s, a, u = 0;
            if (re.isFunction(e)) return this.each(function (t) {
                re(this).removeClass(e.call(this, t, M(this)))
            });
            if (!arguments.length) return this.attr("class", "");
            if ("string" == typeof e && e) for (t = e.match(ye) || []; n = this[u++];) if (i = M(n), r = 1 === n.nodeType && (" " + i + " ").replace(lt, " ")) {
                for (s = 0; o = t[s++];) for (; r.indexOf(" " + o + " ") > -1;) r = r.replace(" " + o + " ", " ");
                i !== (a = re.trim(r)) && n.setAttribute("class", a)
            }
            return this
        }, toggleClass: function (e, t) {
            var n = typeof e;
            return "boolean" == typeof t && "string" === n ? t ? this.addClass(e) : this.removeClass(e) : re.isFunction(e) ? this.each(function (n) {
                re(this).toggleClass(e.call(this, n, M(this), t), t)
            }) : this.each(function () {
                var t, r, i, o;
                if ("string" === n) for (r = 0, i = re(this), o = e.match(ye) || []; t = o[r++];) i.hasClass(t) ? i.removeClass(t) : i.addClass(t); else void 0 !== e && "boolean" !== n || ((t = M(this)) && Ce.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : Ce.get(this, "__className__") || ""))
            })
        }, hasClass: function (e) {
            var t, n, r = 0;
            for (t = " " + e + " "; n = this[r++];) if (1 === n.nodeType && (" " + M(n) + " ").replace(lt, " ").indexOf(t) > -1) return !0;
            return !1
        }
    });
    var ct = /\r/g, ft = /[\x20\t\r\n\f]+/g;
    re.fn.extend({
        val: function (e) {
            var t, n, r, i = this[0];
            {
                if (arguments.length) return r = re.isFunction(e), this.each(function (n) {
                    var i;
                    1 === this.nodeType && (null == (i = r ? e.call(this, n, re(this).val()) : e) ? i = "" : "number" == typeof i ? i += "" : re.isArray(i) && (i = re.map(i, function (e) {
                        return null == e ? "" : e + ""
                    })), (t = re.valHooks[this.type] || re.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, i, "value") || (this.value = i))
                });
                if (i) return (t = re.valHooks[i.type] || re.valHooks[i.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(i, "value")) ? n : "string" == typeof (n = i.value) ? n.replace(ct, "") : null == n ? "" : n
            }
        }
    }), re.extend({
        valHooks: {
            option: {
                get: function (e) {
                    var t = re.find.attr(e, "value");
                    return null != t ? t : re.trim(re.text(e)).replace(ft, " ")
                }
            }, select: {
                get: function (e) {
                    for (var t, n, r = e.options, i = e.selectedIndex, o = "select-one" === e.type || i < 0, s = o ? null : [], a = o ? i + 1 : r.length, u = i < 0 ? a : o ? i : 0; u < a; u++) if (((n = r[u]).selected || u === i) && (ne.optDisabled ? !n.disabled : null === n.getAttribute("disabled")) && (!n.parentNode.disabled || !re.nodeName(n.parentNode, "optgroup"))) {
                        if (t = re(n).val(), o) return t;
                        s.push(t)
                    }
                    return s
                }, set: function (e, t) {
                    for (var n, r, i = e.options, o = re.makeArray(t), s = i.length; s--;) ((r = i[s]).selected = re.inArray(re.valHooks.option.get(r), o) > -1) && (n = !0);
                    return n || (e.selectedIndex = -1), o
                }
            }
        }
    }), re.each(["radio", "checkbox"], function () {
        re.valHooks[this] = {
            set: function (e, t) {
                if (re.isArray(t)) return e.checked = re.inArray(re(e).val(), t) > -1
            }
        }, ne.checkOn || (re.valHooks[this].get = function (e) {
            return null === e.getAttribute("value") ? "on" : e.value
        })
    });
    var pt = /^(?:focusinfocus|focusoutblur)$/;
    re.extend(re.event, {
        trigger: function (t, n, r, i) {
            var o, s, a, u, l, c, f, p = [r || Y], d = te.call(t, "type") ? t.type : t,
                h = te.call(t, "namespace") ? t.namespace.split(".") : [];
            if (s = a = r = r || Y, 3 !== r.nodeType && 8 !== r.nodeType && !pt.test(d + re.event.triggered) && (d.indexOf(".") > -1 && (d = (h = d.split(".")).shift(), h.sort()), l = d.indexOf(":") < 0 && "on" + d, t = t[re.expando] ? t : new re.Event(d, "object" == typeof t && t), t.isTrigger = i ? 2 : 3, t.namespace = h.join("."), t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = r), n = null == n ? [t] : re.makeArray(n, [t]), f = re.event.special[d] || {}, i || !f.trigger || !1 !== f.trigger.apply(r, n))) {
                if (!i && !f.noBubble && !re.isWindow(r)) {
                    for (u = f.delegateType || d, pt.test(u + d) || (s = s.parentNode); s; s = s.parentNode) p.push(s), a = s;
                    a === (r.ownerDocument || Y) && p.push(a.defaultView || a.parentWindow || e)
                }
                for (o = 0; (s = p[o++]) && !t.isPropagationStopped();) t.type = o > 1 ? u : f.bindType || d, (c = (Ce.get(s, "events") || {})[t.type] && Ce.get(s, "handle")) && c.apply(s, n), (c = l && s[l]) && c.apply && we(s) && (t.result = c.apply(s, n), !1 === t.result && t.preventDefault());
                return t.type = d, i || t.isDefaultPrevented() || f._default && !1 !== f._default.apply(p.pop(), n) || !we(r) || l && re.isFunction(r[d]) && !re.isWindow(r) && ((a = r[l]) && (r[l] = null), re.event.triggered = d, r[d](), re.event.triggered = void 0, a && (r[l] = a)), t.result
            }
        }, simulate: function (e, t, n) {
            var r = re.extend(new re.Event, n, {
                type: e, isSimulated: !0
            });
            re.event.trigger(r, null, t)
        }
    }), re.fn.extend({
        trigger: function (e, t) {
            return this.each(function () {
                re.event.trigger(e, t, this)
            })
        }, triggerHandler: function (e, t) {
            var n = this[0];
            if (n) return re.event.trigger(e, t, n, !0)
        }
    }), re.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (e, t) {
        re.fn[t] = function (e, n) {
            return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t)
        }
    }), re.fn.extend({
        hover: function (e, t) {
            return this.mouseenter(e).mouseleave(t || e)
        }
    }), ne.focusin = "onfocusin" in e, ne.focusin || re.each({
        focus: "focusin", blur: "focusout"
    }, function (e, t) {
        var n = function (e) {
            re.event.simulate(t, e.target, re.event.fix(e))
        };
        re.event.special[t] = {
            setup: function () {
                var r = this.ownerDocument || this, i = Ce.access(r, t);
                i || r.addEventListener(e, n, !0), Ce.access(r, t, (i || 0) + 1)
            }, teardown: function () {
                var r = this.ownerDocument || this, i = Ce.access(r, t) - 1;
                i ? Ce.access(r, t, i) : (r.removeEventListener(e, n, !0), Ce.remove(r, t))
            }
        }
    });
    var dt = e.location, ht = re.now(), vt = /\?/;
    re.parseJSON = function (e) {
        return JSON.parse(e + "")
    }, re.parseXML = function (t) {
        var n;
        if (!t || "string" != typeof t) return null;
        try {
            n = (new e.DOMParser).parseFromString(t, "text/xml")
        } catch (e) {
            n = void 0
        }
        return n && !n.getElementsByTagName("parsererror").length || re.error("Invalid XML: " + t), n
    };
    var mt = /#.*$/, gt = /([?&])_=[^&]*/, yt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        xt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, bt = /^(?:GET|HEAD)$/, wt = /^\/\//, Ct = {},
        Tt = {}, $t = "*/".concat("*"), kt = Y.createElement("a");
    kt.href = dt.href, re.extend({
        active: 0, lastModified: {}, etag: {}, ajaxSettings: {
            url: dt.href,
            type: "GET",
            isLocal: xt.test(dt.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": $t,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML", text: "responseText", json: "responseJSON"
            },
            converters: {
                "* text": String, "text html": !0, "text json": re.parseJSON, "text xml": re.parseXML
            },
            flatOptions: {
                url: !0, context: !0
            }
        }, ajaxSetup: function (e, t) {
            return t ? _(_(e, re.ajaxSettings), t) : _(re.ajaxSettings, e)
        }, ajaxPrefilter: I(Ct), ajaxTransport: I(Tt), ajax: function (t, n) {
            function r(t, n, r, a) {
                var l, f, y, x, w, T = n;
                2 !== b && (b = 2, u && e.clearTimeout(u), i = void 0, s = a || "", C.readyState = t > 0 ? 4 : 0, l = t >= 200 && t < 300 || 304 === t, r && (x = B(p, C, r)), x = U(p, x, C, l), l ? (p.ifModified && ((w = C.getResponseHeader("Last-Modified")) && (re.lastModified[o] = w), (w = C.getResponseHeader("etag")) && (re.etag[o] = w)), 204 === t || "HEAD" === p.type ? T = "nocontent" : 304 === t ? T = "notmodified" : (T = x.state, f = x.data, l = !(y = x.error))) : (y = T, !t && T || (T = "error", t < 0 && (t = 0))), C.status = t, C.statusText = (n || T) + "", l ? v.resolveWith(d, [f, T, C]) : v.rejectWith(d, [C, T, y]), C.statusCode(g), g = void 0, c && h.trigger(l ? "ajaxSuccess" : "ajaxError", [C, p, l ? f : y]), m.fireWith(d, [C, T]), c && (h.trigger("ajaxComplete", [C, p]), --re.active || re.event.trigger("ajaxStop")))
            }

            "object" == typeof t && (n = t, t = void 0), n = n || {};
            var i, o, s, a, u, l, c, f, p = re.ajaxSetup({}, n), d = p.context || p,
                h = p.context && (d.nodeType || d.jquery) ? re(d) : re.event, v = re.Deferred(),
                m = re.Callbacks("once memory"), g = p.statusCode || {}, y = {}, x = {}, b = 0, w = "canceled", C = {
                    readyState: 0, getResponseHeader: function (e) {
                        var t;
                        if (2 === b) {
                            if (!a) for (a = {}; t = yt.exec(s);) a[t[1].toLowerCase()] = t[2];
                            t = a[e.toLowerCase()]
                        }
                        return null == t ? null : t
                    }, getAllResponseHeaders: function () {
                        return 2 === b ? s : null
                    }, setRequestHeader: function (e, t) {
                        var n = e.toLowerCase();
                        return b || (e = x[n] = x[n] || e, y[e] = t), this
                    }, overrideMimeType: function (e) {
                        return b || (p.mimeType = e), this
                    }, statusCode: function (e) {
                        var t;
                        if (e) if (b < 2) for (t in e) g[t] = [g[t], e[t]]; else C.always(e[C.status]);
                        return this
                    }, abort: function (e) {
                        var t = e || w;
                        return i && i.abort(t), r(0, t), this
                    }
                };
            if (v.promise(C).complete = m.add, C.success = C.done, C.error = C.fail, p.url = ((t || p.url || dt.href) + "").replace(mt, "").replace(wt, dt.protocol + "//"), p.type = n.method || n.type || p.method || p.type, p.dataTypes = re.trim(p.dataType || "*").toLowerCase().match(ye) || [""], null == p.crossDomain) {
                l = Y.createElement("a");
                try {
                    l.href = p.url, l.href = l.href, p.crossDomain = kt.protocol + "//" + kt.host != l.protocol + "//" + l.host
                } catch (e) {
                    p.crossDomain = !0
                }
            }
            if (p.data && p.processData && "string" != typeof p.data && (p.data = re.param(p.data, p.traditional)), W(Ct, p, n, C), 2 === b) return C;
            (c = re.event && p.global) && 0 == re.active++ && re.event.trigger("ajaxStart"), p.type = p.type.toUpperCase(), p.hasContent = !bt.test(p.type), o = p.url, p.hasContent || (p.data && (o = p.url += (vt.test(o) ? "&" : "?") + p.data, delete p.data), !1 === p.cache && (p.url = gt.test(o) ? o.replace(gt, "$1_=" + ht++) : o + (vt.test(o) ? "&" : "?") + "_=" + ht++)), p.ifModified && (re.lastModified[o] && C.setRequestHeader("If-Modified-Since", re.lastModified[o]), re.etag[o] && C.setRequestHeader("If-None-Match", re.etag[o])), (p.data && p.hasContent && !1 !== p.contentType || n.contentType) && C.setRequestHeader("Content-Type", p.contentType), C.setRequestHeader("Accept", p.dataTypes[0] && p.accepts[p.dataTypes[0]] ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + $t + "; q=0.01" : "") : p.accepts["*"]);
            for (f in p.headers) C.setRequestHeader(f, p.headers[f]);
            if (p.beforeSend && (!1 === p.beforeSend.call(d, C, p) || 2 === b)) return C.abort();
            w = "abort";
            for (f in {
                success: 1, error: 1, complete: 1
            }) C[f](p[f]);
            if (i = W(Tt, p, n, C)) {
                if (C.readyState = 1, c && h.trigger("ajaxSend", [C, p]), 2 === b) return C;
                p.async && p.timeout > 0 && (u = e.setTimeout(function () {
                    C.abort("timeout")
                }, p.timeout));
                try {
                    b = 1, i.send(y, r)
                } catch (e) {
                    if (!(b < 2)) throw e;
                    r(-1, e)
                }
            } else r(-1, "No Transport");
            return C
        }, getJSON: function (e, t, n) {
            return re.get(e, t, n, "json")
        }, getScript: function (e, t) {
            return re.get(e, void 0, t, "script")
        }
    }), re.each(["get", "post"], function (e, t) {
        re[t] = function (e, n, r, i) {
            return re.isFunction(n) && (i = i || r, r = n, n = void 0), re.ajax(re.extend({
                url: e, type: t, dataType: i, data: n, success: r
            }, re.isPlainObject(e) && e))
        }
    }), re._evalUrl = function (e) {
        return re.ajax({
            url: e, type: "GET", dataType: "script", async: !1, global: !1, throws: !0
        })
    }, re.fn.extend({
        wrapAll: function (e) {
            var t;
            return re.isFunction(e) ? this.each(function (t) {
                re(this).wrapAll(e.call(this, t))
            }) : (this[0] && (t = re(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
                for (var e = this; e.firstElementChild;) e = e.firstElementChild;
                return e
            }).append(this)), this)
        }, wrapInner: function (e) {
            return re.isFunction(e) ? this.each(function (t) {
                re(this).wrapInner(e.call(this, t))
            }) : this.each(function () {
                var t = re(this), n = t.contents();
                n.length ? n.wrapAll(e) : t.append(e)
            })
        }, wrap: function (e) {
            var t = re.isFunction(e);
            return this.each(function (n) {
                re(this).wrapAll(t ? e.call(this, n) : e)
            })
        }, unwrap: function () {
            return this.parent().each(function () {
                re.nodeName(this, "body") || re(this).replaceWith(this.childNodes)
            }).end()
        }
    }), re.expr.filters.hidden = function (e) {
        return !re.expr.filters.visible(e)
    }, re.expr.filters.visible = function (e) {
        return e.offsetWidth > 0 || e.offsetHeight > 0 || e.getClientRects().length > 0
    };
    var St = /%20/g, Et = /\[\]$/, Nt = /\r?\n/g, Dt = /^(?:submit|button|image|reset|file)$/i,
        jt = /^(?:input|select|textarea|keygen)/i;
    re.param = function (e, t) {
        var n, r = [], i = function (e, t) {
            t = re.isFunction(t) ? t() : null == t ? "" : t, r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t)
        };
        if (void 0 === t && (t = re.ajaxSettings && re.ajaxSettings.traditional), re.isArray(e) || e.jquery && !re.isPlainObject(e)) re.each(e, function () {
            i(this.name, this.value)
        }); else for (n in e) X(n, e[n], t, i);
        return r.join("&").replace(St, "+")
    }, re.fn.extend({
        serialize: function () {
            return re.param(this.serializeArray())
        }, serializeArray: function () {
            return this.map(function () {
                var e = re.prop(this, "elements");
                return e ? re.makeArray(e) : this
            }).filter(function () {
                var e = this.type;
                return this.name && !re(this).is(":disabled") && jt.test(this.nodeName) && !Dt.test(e) && (this.checked || !je.test(e))
            }).map(function (e, t) {
                var n = re(this).val();
                return null == n ? null : re.isArray(n) ? re.map(n, function (e) {
                    return {
                        name: t.name, value: e.replace(Nt, "\r\n")
                    }
                }) : {
                    name: t.name, value: n.replace(Nt, "\r\n")
                }
            }).get()
        }
    }), re.ajaxSettings.xhr = function () {
        try {
            return new e.XMLHttpRequest
        } catch (e) {
        }
    };
    var At = {
        0: 200, 1223: 204
    }, qt = re.ajaxSettings.xhr();
    ne.cors = !!qt && "withCredentials" in qt, ne.ajax = qt = !!qt, re.ajaxTransport(function (t) {
        var n, r;
        if (ne.cors || qt && !t.crossDomain) return {
            send: function (i, o) {
                var s, a = t.xhr();
                if (a.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields) for (s in t.xhrFields) a[s] = t.xhrFields[s];
                t.mimeType && a.overrideMimeType && a.overrideMimeType(t.mimeType), t.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest");
                for (s in i) a.setRequestHeader(s, i[s]);
                n = function (e) {
                    return function () {
                        n && (n = r = a.onload = a.onerror = a.onabort = a.onreadystatechange = null, "abort" === e ? a.abort() : "error" === e ? "number" != typeof a.status ? o(0, "error") : o(a.status, a.statusText) : o(At[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                            binary: a.response
                        } : {
                            text: a.responseText
                        }, a.getAllResponseHeaders()))
                    }
                }, a.onload = n(), r = a.onerror = n("error"), void 0 !== a.onabort ? a.onabort = r : a.onreadystatechange = function () {
                    4 === a.readyState && e.setTimeout(function () {
                        n && r()
                    })
                }, n = n("abort");
                try {
                    a.send(t.hasContent && t.data || null)
                } catch (e) {
                    if (n) throw e
                }
            }, abort: function () {
                n && n()
            }
        }
    }), re.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        }, contents: {
            script: /\b(?:java|ecma)script\b/
        }, converters: {
            "text script": function (e) {
                return re.globalEval(e), e
            }
        }
    }), re.ajaxPrefilter("script", function (e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET")
    }), re.ajaxTransport("script", function (e) {
        if (e.crossDomain) {
            var t, n;
            return {
                send: function (r, i) {
                    t = re("<script>").prop({
                        charset: e.scriptCharset, src: e.url
                    }).on("load error", n = function (e) {
                        t.remove(), n = null, e && i("error" === e.type ? 404 : 200, e.type)
                    }), Y.head.appendChild(t[0])
                }, abort: function () {
                    n && n()
                }
            }
        }
    });
    var Lt = [], Ht = /(=)\?(?=&|$)|\?\?/;
    re.ajaxSetup({
        jsonp: "callback", jsonpCallback: function () {
            var e = Lt.pop() || re.expando + "_" + ht++;
            return this[e] = !0, e
        }
    }), re.ajaxPrefilter("json jsonp", function (t, n, r) {
        var i, o, s,
            a = !1 !== t.jsonp && (Ht.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Ht.test(t.data) && "data");
        if (a || "jsonp" === t.dataTypes[0]) return i = t.jsonpCallback = re.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, a ? t[a] = t[a].replace(Ht, "$1" + i) : !1 !== t.jsonp && (t.url += (vt.test(t.url) ? "&" : "?") + t.jsonp + "=" + i), t.converters["script json"] = function () {
            return s || re.error(i + " was not called"), s[0]
        }, t.dataTypes[0] = "json", o = e[i], e[i] = function () {
            s = arguments
        }, r.always(function () {
            void 0 === o ? re(e).removeProp(i) : e[i] = o, t[i] && (t.jsonpCallback = n.jsonpCallback, Lt.push(i)), s && re.isFunction(o) && o(s[0]), s = o = void 0
        }), "script"
    }), re.parseHTML = function (e, t, n) {
        if (!e || "string" != typeof e) return null;
        "boolean" == typeof t && (n = t, t = !1), t = t || Y;
        var r = pe.exec(e), i = !n && [];
        return r ? [t.createElement(r[1])] : (r = p([e], t, i), i && i.length && re(i).remove(), re.merge([], r.childNodes))
    };
    var Ot = re.fn.load;
    re.fn.load = function (e, t, n) {
        if ("string" != typeof e && Ot) return Ot.apply(this, arguments);
        var r, i, o, s = this, a = e.indexOf(" ");
        return a > -1 && (r = re.trim(e.slice(a)), e = e.slice(0, a)), re.isFunction(t) ? (n = t, t = void 0) : t && "object" == typeof t && (i = "POST"), s.length > 0 && re.ajax({
            url: e, type: i || "GET", dataType: "html", data: t
        }).done(function (e) {
            o = arguments, s.html(r ? re("<div>").append(re.parseHTML(e)).find(r) : e)
        }).always(n && function (e, t) {
            s.each(function () {
                n.apply(this, o || [e.responseText, t, e])
            })
        }), this
    }, re.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
        re.fn[t] = function (e) {
            return this.on(t, e)
        }
    }), re.expr.filters.animated = function (e) {
        return re.grep(re.timers, function (t) {
            return e === t.elem
        }).length
    }, re.offset = {
        setOffset: function (e, t, n) {
            var r, i, o, s, a, u, l = re.css(e, "position"), c = re(e), f = {};
            "static" === l && (e.style.position = "relative"), a = c.offset(), o = re.css(e, "top"), u = re.css(e, "left"), ("absolute" === l || "fixed" === l) && (o + u).indexOf("auto") > -1 ? (s = (r = c.position()).top, i = r.left) : (s = parseFloat(o) || 0, i = parseFloat(u) || 0), re.isFunction(t) && (t = t.call(e, n, re.extend({}, a))), null != t.top && (f.top = t.top - a.top + s), null != t.left && (f.left = t.left - a.left + i), "using" in t ? t.using.call(e, f) : c.css(f)
        }
    }, re.fn.extend({
        offset: function (e) {
            if (arguments.length) return void 0 === e ? this : this.each(function (t) {
                re.offset.setOffset(this, e, t)
            });
            var t, n, r = this[0], i = {
                top: 0, left: 0
            }, o = r && r.ownerDocument;
            if (o) return t = o.documentElement, re.contains(t, r) ? (i = r.getBoundingClientRect(), n = z(o), {
                top: i.top + n.pageYOffset - t.clientTop, left: i.left + n.pageXOffset - t.clientLeft
            }) : i
        }, position: function () {
            if (this[0]) {
                var e, t, n = this[0], r = {
                    top: 0, left: 0
                };
                return "fixed" === re.css(n, "position") ? t = n.getBoundingClientRect() : (e = this.offsetParent(), t = this.offset(), re.nodeName(e[0], "html") || (r = e.offset()), r.top += re.css(e[0], "borderTopWidth", !0), r.left += re.css(e[0], "borderLeftWidth", !0)), {
                    top: t.top - r.top - re.css(n, "marginTop", !0), left: t.left - r.left - re.css(n, "marginLeft", !0)
                }
            }
        }, offsetParent: function () {
            return this.map(function () {
                for (var e = this.offsetParent; e && "static" === re.css(e, "position");) e = e.offsetParent;
                return e || Ge
            })
        }
    }), re.each({
        scrollLeft: "pageXOffset", scrollTop: "pageYOffset"
    }, function (e, t) {
        var n = "pageYOffset" === t;
        re.fn[e] = function (r) {
            return be(this, function (e, r, i) {
                var o = z(e);
                if (void 0 === i) return o ? o[t] : e[r];
                o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : e[r] = i
            }, e, r, arguments.length)
        }
    }), re.each(["top", "left"], function (e, t) {
        re.cssHooks[t] = E(ne.pixelPosition, function (e, n) {
            if (n) return n = S(e, t), ze.test(n) ? re(e).position()[t] + "px" : n
        })
    }), re.each({
        Height: "height", Width: "width"
    }, function (e, t) {
        re.each({
            padding: "inner" + e, content: t, "": "outer" + e
        }, function (n, r) {
            re.fn[r] = function (r, i) {
                var o = arguments.length && (n || "boolean" != typeof r),
                    s = n || (!0 === r || !0 === i ? "margin" : "border");
                return be(this, function (t, n, r) {
                    var i;
                    return re.isWindow(t) ? t.document.documentElement["client" + e] : 9 === t.nodeType ? (i = t.documentElement, Math.max(t.body["scroll" + e], i["scroll" + e], t.body["offset" + e], i["offset" + e], i["client" + e])) : void 0 === r ? re.css(t, n, s) : re.style(t, n, r, s)
                }, t, o ? r : void 0, o, null)
            }
        })
    }), re.fn.extend({
        bind: function (e, t, n) {
            return this.on(e, null, t, n)
        }, unbind: function (e, t) {
            return this.off(e, null, t)
        }, delegate: function (e, t, n, r) {
            return this.on(t, e, n, r)
        }, undelegate: function (e, t, n) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
        }, size: function () {
            return this.length
        }
    }), re.fn.andSelf = re.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function () {
        return re
    });
    var Ft = e.jQuery, Rt = e.$;
    return re.noConflict = function (t) {
        return e.$ === re && (e.$ = Rt), t && e.jQuery === re && (e.jQuery = Ft), re
    }, t || (e.jQuery = e.$ = re), re
}), function (e) {
    var t = !1;
    if ("function" == typeof define && define.amd && (define(e), t = !0), "object" == typeof exports && (module.exports = e(), t = !0), !t) {
        var n = window.Cookies, r = window.Cookies = e();
        r.noConflict = function () {
            return window.Cookies = n, r
        }
    }
}(function () {
    function e() {
        for (var e = 0, t = {}; e < arguments.length; e++) {
            var n = arguments[e];
            for (var r in n) t[r] = n[r]
        }
        return t
    }

    function t(n) {
        function r(t, i, o) {
            var s;
            if ("undefined" != typeof document) {
                if (arguments.length > 1) {
                    if ("number" == typeof (o = e({
                        path: "/"
                    }, r.defaults, o)).expires) {
                        var a = new Date;
                        a.setMilliseconds(a.getMilliseconds() + 864e5 * o.expires), o.expires = a
                    }
                    o.expires = o.expires ? o.expires.toUTCString() : "";
                    try {
                        s = JSON.stringify(i), /^[\{\[]/.test(s) && (i = s)
                    } catch (e) {
                    }
                    i = n.write ? n.write(i, t) : encodeURIComponent(String(i)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), t = (t = (t = encodeURIComponent(String(t))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape);
                    var u = "";
                    for (var l in o) o[l] && (u += "; " + l, !0 !== o[l] && (u += "=" + o[l]));
                    return document.cookie = t + "=" + i + u
                }
                t || (s = {});
                for (var c = document.cookie ? document.cookie.split("; ") : [], f = /(%[0-9A-Z]{2})+/g, p = 0; p < c.length; p++) {
                    var d = c[p].split("="), h = d.slice(1).join("=");
                    '"' === h.charAt(0) && (h = h.slice(1, -1));
                    try {
                        var v = d[0].replace(f, decodeURIComponent);
                        if (h = n.read ? n.read(h, v) : n(h, v) || h.replace(f, decodeURIComponent), this.json) try {
                            h = JSON.parse(h)
                        } catch (e) {
                        }
                        if (t === v) {
                            s = h;
                            break
                        }
                        t || (s[v] = h)
                    } catch (e) {
                    }
                }
                return s
            }
        }

        return r.set = r, r.get = function (e) {
            return r.call(r, e)
        }, r.getJSON = function () {
            return r.apply({
                json: !0
            }, [].slice.call(arguments))
        }, r.defaults = {}, r.remove = function (t, n) {
            r(t, "", e(n, {
                expires: -1
            }))
        }, r.withConverter = t, r
    }

    return t(function () {
    })
});
class SelectionEdit {
	static getBoundaryElement(isStart) {
		var range, sel, container;
		if (document.selection) {
			range = document.selection.createRange();
			range.collapse(isStart);
			return range.parentElement();
		} else {
			sel = window.getSelection();
			if (sel.getRangeAt) {
				if (sel.rangeCount > 0) {
					range = sel.getRangeAt(0);
				}
			} else {
				// Old WebKit
				range = document.createRange();
				range.setStart(sel.anchorNode, sel.anchorOffset);
				range.setEnd(sel.focusNode, sel.focusOffset);

				// Handle the case when the selection was selected backwards (from the end to the start in the document)
				if (range.collapsed !== sel.isCollapsed) {
					range.setStart(sel.focusNode, sel.focusOffset);
					range.setEnd(sel.anchorNode, sel.anchorOffset);
				}
		   }

			if (range) {
			   container = range[isStart ? "startContainer" : "endContainer"];

			   // Check if the container is a text node and return its parent if so
			   return container.nodeType === 3 ? container.parentNode : container;
			}   
		}
	}
	
	static elementFromHTML(html) {
		let template = document.createElement('template');
		html = html.trim(); // Never return a text node of whitespace as the result
		template.innerHTML = html;
		return template.content.firstChild;
	}
	
	static replace(html, ignoreEmptyRange) {
		let selection = window.getSelection && window.getSelection()
		if (!ignoreEmptyRange && (!selection || 'Range' != selection.type)) {
			return;
		}

		let replacement = SelectionEdit.elementFromHTML(html);
		let range = selection.getRangeAt(0);

		//replace content
		range.deleteContents();
		range.insertNode(replacement);

		//move caret
		range.setStartAfter(replacement);
		range.collapse(true);
		selection.removeAllRanges();
		selection.addRange(range);
	}
};

String.prototype.trim = function (charlist) {
	// Strip whitespace (or other characters) from the beginning and end of a string
	// +   original by: Ilia Kantor (http://javascript.ru)

	charlist = !charlist ? ' \s\xA0' : charlist.replace(/([\[\]\(\)\.\?\/\*\{\}\+\$\^\:])/g, '\$1');
	var re = new RegExp('^[' + charlist + ']+|[' + charlist + ']+$', 'g');
	return this.replace(re, '');
};

class Utils {
    static isElementInView(element, fullyInView) {
        var pageTop = $(window).scrollTop();
        var pageBottom = pageTop + $(window).height();
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).height();

        if (fullyInView === true) {
            return ((pageTop < elementTop) && (pageBottom > elementBottom));
        } else {
            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        }
    }
	
	static rollDelta(min, max, prev) {
		var delta = max - min + 1;
		var roll;
		do {
			var bit = Math.random();
			roll = min - 1 + Math.ceil(bit * delta);
			//console.log({min, max, delta, prev, roll, bit});
		} while (typeof(prev) != 'undefined' && roll == prev);
		
		return roll;
	}
	
	static rollMatched(roll, txt) {
		let dval = (str) => (('00' === str) ? 100 : parseInt(str));
		let range = txt.replace(/––-/, "-").split("-");
		if (1 in range) {
			return dval(range[0]) <= roll && roll <= dval(range[1]);
		}
		
		if (-1 < txt.indexOf('+')) {
			return dval(txt.split('+')[0]) <= roll;
		}
		
		return dval(range[0]) == roll;
	}
	static signedNumber(num, nospace = false) {
		num = parseFloat(num);
		return (num === 0) ? '0' : ((num < 0) ? ((nospace ? '-' : ' - ') + Math.abs(num)) : ((nospace ? '+' : ' + ') + num));
	}

	static transliterate(text) {
		let str = text.slice();
		for (const [re, to] of 
		[ [/\u0401/g, 'YO'],[/\u0419/g, 'I'],[/\u0426/g, 'TS'],[/\u0423/g, 'U'],[/\u041A/g, 'K'],[/\u0415/g, 'E'],[/\u041D/g, 'N'],[/\u0413/g, 'G'],[/\u0428/g, 'SH'],[/\u0429/g, 'SCH'],[/\u0417/g, 'Z'],[/\u0425/g, 'H'],[/\u042A/g, ''],[/\u0451/g, 'yo'],[/\u0439/g, 'i'],[/\u0446/g, 'ts'],[/\u0443/g, 'u'],[/\u043A/g, 'k'],[/\u0435/g, 'e'],[/\u043D/g, 'n'],[/\u0433/g, 'g'],[/\u0448/g, 'sh'],[/\u0449/g, 'sch'],[/\u0437/g, 'z'],[/\u0445/g, 'h'],[/\u044A/g, "'"],[/\u0424/g, 'F'],[/\u042B/g, 'I'],[/\u0412/g, 'V'],[/\u0410/g, 'A'],[/\u041F/g, 'P'],[/\u0420/g, 'R'],[/\u041E/g, 'O'],[/\u041B/g, 'L'],[/\u0414/g, 'D'],[/\u0416/g, 'ZH'],[/\u042D/g, 'E'],[/\u0444/g, 'f'],[/\u044B/g, 'i'],[/\u0432/g, 'v'],[/\u0430/g, 'a'],[/\u043F/g, 'p'],[/\u0440/g, 'r'],[/\u043E/g, 'o'],[/\u043B/g, 'l'],[/\u0434/g, 'd'],[/\u0436/g, 'zh'],[/\u044D/g, 'e'],[/\u042F/g, 'Ya'],[/\u0427/g, 'CH'],[/\u0421/g, 'S'],[/\u041C/g, 'M'],[/\u0418/g, 'I'],[/\u0422/g, 'T'],[/\u042C/g, "'"],[/\u0411/g, 'B'],[/\u042E/g, 'Yu'],[/\u044F/g, 'ya'],[/\u0447/g, 'ch'],[/\u0441/g, 's'],[/\u043C/g, 'm'],[/\u0438/g, 'i'],[/\u0442/g, 't'],[/\u044C/g, "'"],[/\u0431/g, 'b'],[/\u044E/g, 'yu'] ]
		) str = str.replace(re, to);

		return str;
	}
	
	static formatDate(format, date) {
		date = date ? new Date(date * 1000) : new Date();
		format = format.replace('Y', date.getYear());
		format = format.replace('H', date.getHours());
		format = format.replace('i', date.getMinutes());
		format = format.replace('s', date.getSeconds());
		return format;
	}
	
	static randomString(){
		return (Math.random() + 1).toString(36).substring(7);
	}

	/**
	 * Checks if passed argument is number
	 *
	 * @param {*} v - variable to check
	 *
	 * @returns {boolean}
	 */
	static isNumber(v) {
		return typeof v === 'number';
	}

	static isNumeric(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	}

	/**
	 * Checks if passed argument is array
	 *
	 * @param {*} v - variable to check
	 *
	 * @returns {boolean}
	 */
	static isArray(v) {
		return Array.isArray(v);
	}

	/**
	 * Check for a valid url string
	 *
	 * @param {string} textString — string to be checked
	 *
	 * @returns {boolean}
	 */
	static isUrl(textString) {
		const regex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;

		return regex.test(textString);
	};
}

class Cast {
	static boolean(val) {
		return ('true' === val) ? true : (('false' === val) ? false : Boolean(val));
	}
}

class Storage {
	static bvalue(key, value) {
		return Cast.boolean(Storage.value(key,value));
	}
	
	static ivalue(key, value) {
		return Number(Storage.value(key,value));
	}

	static jvalue(key, value) {
		if ('undefined' !== typeof value) {
			value = Storage.value(key, JSON.stringify(value));
		} else {
			value = JSON.parse(Storage.value(key));
		}

		return value;
	}
	
	static value(key, value) {
		if ('undefined' !== typeof value) {
			localStorage.setItem(key, value);
			//console.log('set', key, value);
		} else {
			value = localStorage.getItem(key) || false;
			//console.log('get', key, value);
		}
		return value;
	}
}

// = ennin/tooltips.js
// = ennin/tooltips_data.js
class DiceSet {
	dice = [];

	/**
	 *
	 * @param {String} string
	 * @returns {DiceSet}
	 */
	static fromString(string) {
		let set = new DiceSet();
		// console.log(string);
		let matches = string.replace(/\s/g, '').match(/(\+|-|−)?(\d*)[кd]?(\d*)/g);
		for (let match of matches) {
			if (!match) {
				continue;
			}

			let [_, sign, count, die] = match.match(/(\+|-|−)?(\d*)[кd]?(\d*)/);
			set.dice.push(new Dice({
				die: parseInt(die || 1),
				dice: parseInt(count || 1),
				sign: ('+' === sign) ? +1 : -1
			}));

		}

		set.sortDice();

		return set;
	}

	sortDice() {
		this.dice.sort((dice1, dice2) => dice2.die - dice1.die);
	}

	toString() {
		let string = '';
		for (let dice of this.dice) {
			if (dice.sign < 0 || string.length) {
				string += (dice.sign < 0) ? '-' : '+';
			}
			string += `${dice.dice}`;
			if (dice.die > 1) {
				string += `d${dice.die}`;
			}
		}
		return string;
	}

	roll(rollType = 0) {
		let result = [];
		for (let dice of this.dice) {
			let isD20 = (20 === dice.die && 1 === dice.dice);
			let rolled = dice.roll(isD20 ? rollType : Dice.rollType.NORMAL);
			result.push([dice.die, dice.sign, rolled]);
		}
		return result;
	}

	isD20Test() {
		return this.getD20() && 1 === this.getD20().dice;
	}

	getDice(die) {
		return this.dice.find((dice) => die === dice.die);
	}

	getD20() {
		return this.getDice(20);
	}
}

class Dice {
	/**
	 * тип броска d20
	 * @enum {number} rollType
	 */
	static rollType = {
		NORMAL: 0,
		ADVANTAGE: 1,
		DISADVANTAGE: 2,
	};

	die = null;
	dice = 1;
	bonus = 0;
	multiplier = 1;
	sign = 1;
	critRange = false;
	failRange = false;

	constructor (die, dice = 1, bonus = 0, critRange = false, failRange = false, multiplier = 1, sign = 1) {
		if ('object' == typeof(die)) {
			this.die = die.die;
			this.dice = die.dice || dice;
			this.bonus = die.bonus || bonus;
			this.critRange = die.critRange || critRange;
			this.failRange = die.failRange || failRange;
			this.multiplier = die.multiplier || multiplier;
			this.sign = die.sign || sign;
			return;
		} 
		this.die = die;
		this.dice = dice;
		this.bonus = bonus;
		this.critRange = critRange;	
		this.failRange = failRange;
		this.multiplier = multiplier;
		this.sign = sign;
	}
	
	avg() {
		return (1.0 + (this.die - 1) / 2) * this.dice * this.multiplier + this.bonus;
	}
	min() {
		return this.dice * this.multiplier + this.bonus;
	}
	max() {
		return this.die * this.dice * this.multiplier + this.bonus;
	}
	spread() {
		return this.max() - this.min() + 1;
	}
	simple() {
		return this.dice === 1 && this.bonus === 0 && this.multiplier === 1;
	}
	
	asText(mode) {
		var txt = `${this.dice}d${this.die}`;
			
		if (this.bonus) {
			txt += Utils.signedNumber(this.bonus);
		}
		if ('avg' === mode) {
			txt += ` = ${this.min()}-${this.max()} (avg ${this.avg()})`;
		}
		
		return txt;
	}

	roll(rollType= Dice.rollType.NORMAL) {
		let result = { result: 0, values: [  ], rolls: [] };

		if (2 > this.die) {
			result.result = this.dice;
			result.values = [ this.dice ];
			return result;
		}

		let sum = 0, prev;
		do {
			for (let i = 0; i < this.dice; ++i) {
				let roll = Utils.rollDelta(1, this.die);
				if (Dice.rollType.NORMAL !== rollType) {
					let second = Utils.rollDelta(1, this.die);
					result.rolls.push([roll, second]);
					roll = (Dice.rollType.ADVANTAGE === rollType) ? Math.max(roll, second) : Math.min(roll, second);
				}
				result.values.push(roll);
				sum += roll;
			}
		} while (typeof(prev) != 'undefined' && sum === prev);

		result.result = sum * this.multiplier + this.bonus;
		
		return result;
	}
}

class ROLLtABLE {
	static ref = {};	
	
	static rollTable(cell, index) {
		let ref = this.ref[index];
		let roll = ref.dice.roll().result;
		this.ref[index].rolled = roll;
		$(cell).attr('title', roll);
		let rows = ref.table.find('tr');
		rows.removeClass('rolled');
		
		let target;
		let oneToOneTable = !(!ref.dice.simple() || (rows.length - 1 !== ref.dice.spread()) || ('check' === ROLLtABLE.ref[index].mode));
		if (!oneToOneTable) {
			for (let index = 1; index < rows.length; ++index) {
				
				let row = $(rows.get(index));
				if (Utils.rollMatched(roll, row.children().first().html())) {
					target =  row;						
					break;
				}
			}
		} else {
			target = rows.eq(roll);
		}
		if (target) {
			target.addClass('rolled');
			if (!Utils.isElementInView(target)) {
				$('html, body').animate({ scrollTop: target.offset().top - $(window).height() / 2 }, 1100);
			}
		}
		
		return false;
	}
	
	static regTable(table, cell, die, dice = 1, bonus = 0, rolled = 0, mode = 'standard') {
		let index = Object.keys(this.ref).length;
		this.ref[index] = { 
			table : table, 
			cell : cell,
			dice : new Dice(die, dice, bonus),
			rolled : rolled,
			mode : mode,
		}
		return index;
	}
	
	static prepareTables(root) {
		root = $(root || document);
		root.find(".card:not(.embed) tr.table_header").each(function(index) {
			let table = $(this).closest('table');
			let cell = $(this).children().first();
			let content = cell.html();
			
			if (!table.hasClass('rolltable') && /^\s*(\d*)к(\d+)\s*$/.test(content)) {
				table.addClass('rolltable');					
				let dice = /(\d*)к(\d+)/.exec(content);
				if (!(1 in dice)) {
					return; 
				}
				
				index = ROLLtABLE.regTable(table, cell, parseInt(dice[2]), parseInt(('' === dice[1]) ? '1' : dice[1]), 0)

				content = content.replace(/к/, "<!-- !-->к");
				
				cell.click(() => ROLLtABLE.rollTable(this, index));
				cell.on('dblclick', () => false);
				cell.addClass('roller');
				cell.html('<span class="dice">' + content + '</span>');
			}
		});		
	}

	static prepareBeastAbilityRolls(root) {
		root = root || document;
		const abilityRows = root.querySelectorAll('.card:not(.embed) ul.params .abilities .stat-pair-row');
		abilityRows.forEach((abilityRow) => {
			const modCell = abilityRow.querySelector('div.mod');
			const savesCell = abilityRow.querySelector('div.save');
			const targetCell = abilityRow.querySelector('div.roll');
			if (!Utils.isNumeric(modCell.innerText)) {
				return;
			}

			modCell.onclick = this.clickBeastAbilityRoll(modCell.innerText, targetCell);
			savesCell.onclick = this.clickBeastAbilityRoll(savesCell.innerText, targetCell);
		});
	}

	static clickBeastAbilityRoll(modifier, target) {
		return () => {
			const mod = parseInt(modifier)
			const set = new Dice(20, 1, mod);
			const roll = set.roll();

			let tooltip = set.bonus
							? (roll.values.join(' + ') + Utils.signedNumber(set.bonus) + ` = ${roll.result}`)
							: roll.result;

			target.innerHTML = `= ${roll.result}`;
			target.title = tooltip;

			return false;
		};
	}

	static diceRegex() {
		return /(\d+)к(\d+)(\s*\+\s*\d+([^к]|$))?(\s*[-−]\s*\d+([^к]|$))?(\s*×\s*(\d+))?/igm;
	}
	
	static rollDice(roller, set = false) {
		if (!set) {
			let comp = this.diceRegex().exec($(roller).children().first().html());
			let bonusStr = (comp[5] || comp[3] || '0').replace(/\s/g, '').replace(/−/g, '-')
			set = new Dice({
				die: parseInt(comp[2] || 0),
				dice: parseInt(comp[1] || 0),
				bonus: parseInt(bonusStr),
				multiplier: parseInt(comp[8] || '1')
			});

		}
		
		let roll = set.roll();
		let tooltip = roll.values.join(' + ');
		{
			if (set.multiplier !== 1 || set.bonus) {
				tooltip = `(${tooltip})`;
			}
			if (set.multiplier !== 1) {
				tooltip = `${tooltip} * ${set.multiplier}`
			}
			if (set.bonus) {
				tooltip += Utils.signedNumber(set.bonus);
			}
			if (set.bonus || set.multiplier !== 1 || roll.values.length > 1) {
				 tooltip = `${tooltip} = ${roll.result}`;
			}
		}
		
		let receiver = $(roller).children().last();
		receiver.animate({ 'opacity': 0 }, 400, function() {
			if (set.critRange || set.failRange) {
				receiver.removeClass();
				let naturalRoll = roll.result - set.bonus;
				if (set.failRange >= naturalRoll) 
					receiver.addClass('natural_fail');
				if (set.critRange <= naturalRoll) 
					receiver.addClass('natural_crit');
			}		

			$(this).html(' = ' + roll.result).animate({ 'opacity': 1 }, 400);
		});
		receiver.attr('title', tooltip);
	}
	
	static prepareDice(root) {
		let prepareDiceReplace = (match) => {
			let add = '';
			let symbols = match.split('');
			let last = symbols[symbols.length - 1];
			if ( isNaN( parseInt(last) )) {
				add += last;
				match = match.substring(0, symbols.length - 1);
			}
			let roller = $('<span class="dice" onclick="return ROLLtABLE.rollDice(this);">');
			roller.html('<span>' + match + '</span><span></span>');
			let html = roller.wrap('<span/>').parent().html() + add;

			return html;
		};

		root = $(root || document);
		root.find('.card:not(.embed)').each((i, div) =>
			HTML
			  .fetchTextNodes(div, node => this.diceRegex().test(node.data))
			  .forEach(text => 
				$(text).replaceWith(
					text.nodeValue.replace(this.diceRegex(), prepareDiceReplace)
				)
			)
		);
	}

	static prepareHits(root) {
		let prepareHitsReplace = (match) => {
			let parts = match.split(' ');
			let bonusPosition = 0;
			for (let i in parts) {
				if (parseInt(parts[i])) {
					bonusPosition = parseInt(i);
				}
			}

			let halves = [parts.slice(0, 1 + bonusPosition).join(' '), parts.slice(bonusPosition + 1).join(' ')];
			let bonus = parseInt(parts[bonusPosition]);
			let roller = $(`<span class="dice" onclick="return ROLLtABLE.rollDice(this, new Dice(20, 1, ${bonus}, 20, 1));" ondblclick="return false;">`);
			roller.html('<span>' + halves[0] + '</span><span></span> ' + halves[1]);
			let html = roller.wrap('<span/>').parent().html();

			return html;
		}

		let regex = /\+\s*\d+\s+к\s+попаданию/g;
		root = $(root || document);
		root.find('.card:not(.embed) li.size-type-alignment').each((i, li) =>
			$(li).parent().find("li.subsection.desc div p").each((i, p) =>
				HTML.fetchTextNodes(p, node => regex.test(node.data))
					.forEach(text => $(text).replaceWith(
							text.nodeValue.replace(regex, prepareHitsReplace)
						)
					)
			)
		);
	}

	static clickSkillBonus(mod, target) {
		return () => {
			const set = new Dice(20, 1, mod);
			const roll = set.roll();

			let tooltip = set.bonus
				? (roll.values.join(' + ') + Utils.signedNumber(set.bonus) + ` = ${roll.result}`)
				: roll.result;

			target.innerHTML = ` = ${roll.result}`;
			target.title = tooltip;
		}
	}

	static prepareSkills(root) {
		root = root || document;
		root.querySelectorAll('.card:not(.embed) .params .skills .skill-bonus')
			.forEach((skillNode) => {
				const modHolder = skillNode.querySelector('.skill-bonus-value');
				const mod = parseInt(modHolder.innerHTML);

				const target = HTML.createElement('span', 'skill-bonus-roll');
				skillNode.appendChild(target);

				modHolder.onclick = this.clickSkillBonus(mod, target);

				console.log(skillNode);
				console.log(mod);
			});

		// let prepareSkillsReplace = (match) => {
		// 	let parts = match.split(' ');
		// 	let bonusPosition = 0;
		// 	for (let i in parts) {
		// 		if (parseInt(parts[i])) {
		// 			bonusPosition = parseInt(i);
		// 		}
		// 	}
		//
		// 	let halves = [parts.slice(0, 1 + bonusPosition).join(' '), parts.slice(bonusPosition + 1).join(' ')];
		// 	let bonus = parseInt(parts[bonusPosition]);
		// 	let roller = $(`<span class="dice" onclick="return ROLLtABLE.rollDice(this, new Dice(20, 1, ${bonus}, 20, 1));" ondblclick="return false;">`);
		// 	roller.html('<span>' + halves[0] + '</span><span></span> ' + halves[1]);
		// 	let html = roller.wrap('<span/>').parent().html();
		//
		// 	return html;
		// }
		//
		// let regex = /\+\s*\d+\s+к\s+попаданию/g;
		// root.find('.card:not(.embed) ul.params li.skills span.skill-bonus').each((i, li) =>
		// 	$(li).parent().find("li.subsection.desc div p").each((i, p) =>
		// 		HTML.fetchTextNodes(p, node => regex.test(node.data))
		// 			.forEach(text => $(text).replaceWith(
		// 					text.nodeValue.replace(regex, prepareSkillsReplace)
		// 				)
		// 			)
		// 	)
		// );
	}
	
	static prepareRecharge(root) {
		let prepareRechargeReplace = (match) => {
			let rangeStr = match.match(/(\d.)?6/);
			if (!rangeStr) {
				return match;
			}

			let range = rangeStr[0].replace(/[––-–]/g, "-").split("-");
			let success = range[1] ? parseInt(range[0]) : 6;
			let html = match.trim('()');
			html = `<span>${html}</span><span class="die"></span><span></span>`;
			html = `<span class="dice" onclick="return ROLLtABLE.rollDice(this, new Dice({die: 6, critRange: ${success}, failRange: ${success - 1}}));">${html}</span>`;
			html = `(${html})`;

			return html;
		}

		let regex = /\(перезарядка (\d.)?6\)/ig;
		root = $(root || document);
		root.find('.card:not(.embed)').each((i, div) =>
			HTML.fetchTextNodes(div, node => regex.test(node.data)).forEach(text => 
				$(text).replaceWith(
					text.nodeValue.replace(regex, prepareRechargeReplace)
				)
			)
		);
	}
}
let FeatureArrangerSorter = {
	fetch : (element1, element2, attribute) => [ $(element1).attr(attribute), $(element2).attr(attribute) ],

	compareNumber : (a, b) => a - b,
	compareString : (a, b) => a.localeCompare(b, undefined, { ignorePunctuation: true }),

	level : (element1, element2) => 
		FeatureArrangerSorter.compareNumber(...FeatureArrangerSorter.fetch(element1, element2, 'data-level')) 
		|| FeatureArrangerSorter.compareString(...FeatureArrangerSorter.fetch(element1, element2, 'data-rname')),
	
	rarity : (element1, element2) => 
		FeatureArrangerSorter.compareNumber(...FeatureArrangerSorter.fetch(element1, element2, 'data-rarity')) 
		|| FeatureArrangerSorter.compareString(...FeatureArrangerSorter.fetch(element1, element2, 'data-rname')),
	
	rname : (element1, element2) => 
		FeatureArrangerSorter.compareString(...FeatureArrangerSorter.fetch(element1, element2, 'data-rname')),
};
let FeatureArrangerFilter = {
	prepare: (arranger, key) => {
		let filtering = [ ];
		( [key].concat(arranger.options[key].dependent || []) ).forEach(
			dependency => filtering.push( 
				{ 
					key: dependency, 
					variants : FeatureArranger.mode(dependency)?.split(','), 
					field: FeatureArranger.options[dependency].field,
					passEmpty : FeatureArranger.options[dependency].passEmpty,
				} 
			)
		);
		return filtering;
	},
	check: (filtering, element) => {
		let checkRow = (filter, element) => {
			//console.log(filter);
			if (filter.variants.includes('any')) {
				return true;
			}
			
			let value = $(element).attr(filter.field);
			//console.log(value);
			if (!value && filter.passEmpty) {
				return true;
			}
			
			let intersection = FeatureArrangerFilter.intersect(filter.variants, value.split(","));
			
			return intersection.length;
		};
		
		//console.log(element);
		for (let filter of filtering) {			
			if (!checkRow(filter, element)) {
				//console.log('failed', filter.key);
				return false;
			}
		}
		
		return true;
	},
	intersect: (array1, array2) => {
		let intersection = array1.filter(v => array2.includes(v));
		return intersection;
	}
};
let FeatureArrangerCallback = {
	class_table_redraw : function(key) {
		// console.log('class_table_redraw', key);
		
		let unfold = (FeatureArranger.mode(key) === 'unfold');
		// let tasha = (FeatureArranger.mode(`${key}.tasha`) === 'on');
		//console.log(unfold);
		if (unfold) {
			$('.class_table_unfold').show();
			$('.class_table_fold').hide();
		} else {
			$('.class_table_fold').show();
			$('.class_table_unfold').hide();
		}
		
		
	},
};

let FeatureArranger = {
	options : { },
	setup: { 
		//debug: true, 
		debug: false, 
		//class_table_key: '',
	},
	
	init: function(root) {
		let postProcess = [];
		root = $(root || document);
		root.find('[data-sort="block"]').each((_, block) => {
			//elements
			$(block)
			 .find('[data-sort=container]')
			 .find('[data-sort=element]')
			 .each((idx, element) => 
				$(element).attr('data-rname', 
					$(element).attr('data-rname') 
					|| $(element).find('h3').text() 
					|| $(element).find('h4').text() 
					|| $(element).find('strong em').text()
				)
			 );

			//sorters, filters
			$(block)
			 .find('[data-sort=filter], [data-sort=multifilter], [data-sort=sorter]')
			 .each((_, func) => {
				//console.log(func);
				func = $(func);
				let options = [], key = func.attr('data-name'), isSort = ('sorter' === func.attr('data-sort'));
				func.find('[data-sort-function]').each((__, option) => { 
					option = $(option);
					let link = option.find('a'), value = option.attr('data-sort-function');
					options.push({
						caption: link.text(), 
						key: value, 
						default: !!option.attr('data-sort-default') 
					});

					if (isSort) {
						link.click(() => FeatureArranger.sort(key, value));
					} else {
						link.click(() => FeatureArranger.filter(key, value));
					}
				});
				
				FeatureArranger.options[key] = { 
					name: key, 
					options: options, 
					sort: func.attr('data-sort'),
					field: func.attr('data-field'),
					passEmpty: !!func.attr('data-pass-empty'),
					dependent: (func.attr('data-dependent') || '').split(',').filter(v => v.length),
				};
				//console.log(FeatureArranger.options[key]);
				if ('sorter' == FeatureArranger.options[key].sort) {
					postProcess.push(() => FeatureArranger.sort(key));
				} else {
					postProcess.push(() => FeatureArranger.filter(key));
				}
			 });
		});

		root.find('[data-function]').each((_, func) => {
			func = $(func);
			let options = [], key = func.attr('data-name');
			func.find('[data-option]').each((__, option) => { 
				option = $(option);
				options.push({ 
					caption: option.find('a').text(), 
					key: option.attr('data-option'), 
					default: !!option.attr('data-default') 
				});
			});
			
			FeatureArranger.options[key] = { 
				name: key, 
				options: options, 
				sort: func.attr('data-sort') || func.attr('data-function'),
				callback: func.attr('data-callback'),
			};
			
//			if (!!func.attr('data-root')) {
//				FeatureArranger.setup.class_table_key = key;
//			}
			console.log(FeatureArranger.options[key]);
			
			postProcess.push(() => FeatureArranger.updateButtons(key));
			postProcess.push(() => FeatureArranger.callback(key));
		});

		//#bay
		if (!$('#FeatureArrangerBay').length) {
			$('body').append($('<div id="FeatureArrangerBay">'));
		}

		postProcess.forEach(func => func());
		
//		setTimeout(() => { 
//			let opts = $('.feature_autoclick');
//			opts.length && opts[Math.floor(Math.random() * opts.length)].click();		
//		}, 1);
	},
	callback: function(key) {
		let cb = FeatureArranger.options[key].callback;
		if (cb && FeatureArrangerCallback[cb]) {
			FeatureArrangerCallback[cb](key);
		}
	},
	mode: function (key, mode) {
		//console.log('in', key, mode);
		if (!FeatureArranger.options[key]) {
			console.log('unknown option tag', key);
			console.trace();
			return;
		}
		
		let valueCookie = localStorage.getItem(key);
		//console.log('cookie', key, valueCookie);
		let valueDefault = FeatureArranger.options[key].options.filter(opt => opt.default).map(e => e.key).join(',');
		let valueStored = valueCookie || valueDefault;
		if (!mode) {
			//console.log('restored', key, valueStored);
			return valueStored;
		}
		
		if ( ['multifilter', 'multioption'].includes(FeatureArranger.options[key].sort) ) {
			let variants = ('-' === valueStored) ? [] : valueStored.split(',');
			if (variants.includes(mode)) {
				variants = variants.filter(v => v !== mode);
			} else {
				variants.push(mode);
			}			
			mode = variants.length ? variants.join(',') : '-';
		} else {
			//sort, filter, rest - replace
		}
		
		//console.log('cookie set', key, mode);
		localStorage.setItem(key, mode);
		//console.log('cookie', key, localStorage.getItem(key));
		
		return mode;
	},
	click: function(object) {
		let key = $(object).parents('[data-function]')?.attr('data-name');
		let value = $(object).parents('[data-option]')?.attr('data-option');
		FeatureArranger.mode(key, value);
		FeatureArranger.updateButtons(key);
		FeatureArranger.callback(key);
	},
	updateButtons: function(key, mode) {
		mode = mode || FeatureArranger.mode(key);
		let variants = mode.split(',');
		$(`[data-name="${key}"]`).find('a').each((_, button) => {
			let li = $(button).parent();
			let opt = li.attr('data-option') || li.attr('data-sort-function');
			if (variants.includes(opt)) {
				$(button).addClass('active');
				FeatureArranger.setup.debug && $(button).css('text-decoration', 'underline');
			} else {
				$(button).removeClass('active');
				FeatureArranger.setup.debug && $(button).css('text-decoration', 'none');
			}
		});
	},
	sort: function(key, mode) {
		mode = FeatureArranger.mode(key, mode);
		if (!mode) {
			return;
		}
		
		FeatureArranger.setup.debug && console.log('sorting', key, mode);
		let sorter = $(`[data-sort="sorter"][data-name="${key}"]`);
		let container = sorter.parent().find('[data-sort=container]');		
		let elements = container.find('[data-sort=element]');
		let bay = $('#FeatureArrangerBay');
		
		elements.sort(FeatureArrangerSorter[mode]);
		elements.each((i,e) => bay.append(e)); 
		elements.each((i,e) => container.append(e));
		
		FeatureArranger.updateButtons(key, mode);		
	},
	filter: function(key, mode) {
		mode = FeatureArranger.mode(key, mode);
		let option = FeatureArranger.options[key];
		
		FeatureArranger.setup.debug && console.log('filtering', key, mode);
		let variants = mode.split(',');
		let filter = $(`[data-sort="${option.sort}"][data-name="${key}"]`);
		let container = filter.parent().find('[data-sort=container]');
		let elements = container.find('[data-sort=element]');
		
		let filtering = FeatureArrangerFilter.prepare(FeatureArranger, key);
		elements.each((i, element) => {
			let passed = FeatureArrangerFilter.check(filtering, element);
			passed 
				? $(element).show() 
				: $(element).hide();
		}); 

		FeatureArranger.updateButtons(key, mode);		
	},
	
	keyTCEtoggle: 'TCEdisabled',
	toggleTasha: () => {
		Storage.value(FeatureArranger.keyTCEtoggle, !Storage.bvalue(FeatureArranger.keyTCEtoggle))
		FeatureArranger.updateTasha();
	},
	updateTasha: (root) => {
		root = $(root || document);
		let disabled = Storage.bvalue(FeatureArranger.keyTCEtoggle);
		if (disabled) {
			root.find('span.tce-content input[type=checkbox]').prop('checked', false);
			root.find('.TCE-feature-on').hide();
			root.find('.TCE-feature-off').show();
		} else {
			root.find('span.tce-content input[type=checkbox]').prop('checked', true);
			root.find('.TCE-feature-on').show();
			root.find('.TCE-feature-off').hide();
		}
	},
};
/**
 * спойлер превращает пару "заголовок-описание" в сворачиваемую
 * заголовок, head при этом обзаводится кнопкой свернуть-развернуть
 * кнопка прячет или показывает описание, body
 *
 * в более сложном варианте присутствует промежуточный элемент, neck
 * в таком случае вместе с телом скрывается и голова, а вместо обоих показывается шея
 */
class Spoiler {
	block = false;	
	button = null;
	constructor(head, neck, body, key) {
		this.head = head;
		this.neck = neck;
		this.body = body;
		this.key  = key;
	};

	click() {
		Storage.value(this.key, !this.body.classList.contains('spoiler_hide'));
		this.update();
	}
	
	update() {
		let isFold = Storage.bvalue(this.key);
		if (isFold) {
			this.button.innerText = 'развернуть';
			this.body.classList.add('spoiler_hide');
			if (this.neck) {
				this.neck.classList.remove('spoiler_hide');
				this.head.classList.add('spoiler_hide');
			}
		} else {
			this.button.innerText = 'свернуть';
			this.body.classList.remove('spoiler_hide');
			if (this.neck) {
				this.neck.classList.add('spoiler_hide');
				this.head.classList.remove('spoiler_hide');
			}
		}		
	}

	static create(head) {
		let key = (head.getAttribute('data-key') || Utils.transliterate(head.innerText)) + ':fold';
		let neck = null;
		let targetId = head.getAttribute('data-target');
		let body = targetId ? document.getElementById(targetId) : head.nextElementSibling;

		if (body.classList.contains('spoiler_neck')) {
			neck = body;
			body = neck.nextElementSibling;
		}

		if (!body) {
			body = document.createElement('SPAN');
			body.classList.add('fake-body');
			head.parentNode.insertBefore(body, head.nextSibling);
		}

		body.classList.add('spoiler_body');

		let spoiler = new Spoiler(head, neck, body, key);

		let button = document.createElement('span');
		button.classList.add('spoiler_head_button');
		button.onclick = () => spoiler.click();
		spoiler.button = button;

		if (head.classList.contains('spoiler_head_body')) {
			spoiler.block = true;
			button.classList.add('leftsided');
			head.parentNode.insertBefore(button, head);
		} else {
			head.appendChild(button);
		}

		spoiler.update();
	}
	
	static prepare(root) {
		root = root || document;
		root
			.querySelectorAll('.spoiler_head, .spoiler_head_body')
			.forEach(head => Spoiler.create(head));
	}
}
class Link {
	static follow(hash, ignoreHistory) {
		let target = document.getElementById(hash);
		if (!target) {
			return;
		}
		
		let header = target.closest('.hide-next-h2');
		if (header) {
			document.querySelectorAll('.hide-next.active').forEach(head => head.classList.remove('active'));
			document.querySelectorAll('.hide-wrapper').forEach(block => block.style.display = 'none');

			target.parentElement.classList.add('active');
			target.parentElement.nextElementSibling.style.display = 'block';
		}

		let parent = target;
		while (parent.parentElement) {
			parent = parent.parentElement;
			if (parent.classList.contains('hide-wrapper')) {
				parent.style.display = 'block';
				if (parent.previousElementSibling.classList.contains('hide-next')) {
					parent.previousElementSibling.classList.add('active');
				}
			}
		}

		if (!ignoreHistory) {
			let url = new URL(window.location);
			url.hash = hash;
			window.history.pushState({}, '', url);
		}
		target.scrollIntoView({block: 'start', behavior: 'smooth'});
	}

	static prepare(root) {
		if (window.location.hash) {
			let target = window.location.hash.substring(1);
			window.setTimeout(() => Link.follow(target, true), 1);
		}

		root = root || document;
		root.querySelectorAll('a[href^="#"]').forEach(function (elem) {
			elem.addEventListener('click', function (event) {
				event.preventDefault();
				Link.follow(elem.getAttribute('href').substring(1));
			});
		});
	}
};

document.addEventListener("DOMContentLoaded", () => {

	if (document.querySelectorAll("textarea.editor").length > 0) {
		return;
	}

	if (document.querySelectorAll(".editorio").length > 0) {
		return;
	}

	window.enhance = function (root) {
		root = root || document;

		ROLLtABLE.prepareTables(root);
		ROLLtABLE.prepareDice(root);
		ROLLtABLE.prepareHits(root);
		ROLLtABLE.prepareRecharge(root);
		ROLLtABLE.prepareBeastAbilityRolls(root);
		ROLLtABLE.prepareSkills(root);

		FeatureArranger.init(root);
		FeatureArranger.updateTasha(root);

		Spoiler.prepare(root);

		Link.prepare(root);
	}

	setTimeout(() => {
		window.enhance(document);
	}, 2);
});

/**
 * Класс для ajax запроса
 * const httpClient = new HttpClient();
 * const data = await httpClient.get(url);
 * const data = await httpClient.post(url, data);
 */
class HttpClient {

    async get(url) {
        return new Promise((resolve, reject) => {
            const xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = (evt) => {
                if (evt.currentTarget.readyState === 4 && evt.currentTarget.status === 200) {
                    try {
                        const response = JSON.parse(evt.currentTarget.response);
                        resolve(response);
                    } catch (exception) {
                        console.log(url);
                        reject(exception);
                    }
                }
            };
            xhttp.open('GET', url, true);
            xhttp.send();
        });
    }

    async post(url, data) {
        return new Promise((resolve, reject) => {
            const xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = (evt) => {
                if (evt.currentTarget.readyState === 4 && evt.currentTarget.status === 200) {
                    try {
                        const response = JSON.parse(evt.currentTarget.response);
                        resolve(response);
                    } catch (exception) {
                        console.log(exception);
                        console.log(evt.currentTarget.response);
                        reject(exception);
                    }
                }
            };
            xhttp.open('POST', url, true);
            xhttp.send(JSON.stringify(data));
        });
    }

    static async post(url, data) {
        const client = new HttpClient();
        let response = await client.post(url, data);
        if(!response.result) {
            (response.data.errors ?? ['Неизвестная ошибка']).forEach((err) => Alert.error(err))
        }
        return response;
    }

    static async get(url, data) {
        const client = new HttpClient();
        let response = await client.get(url);
        return response;
    }

    static responseCallback(response) {

        console.log(response)

        if (response.result || typeof response.data.result.callback === 'undefined') {
            return
        }

        return response.data.result.callback
    }
}
/**
 * Класс для обращений к АПИ
 */
class ApiRequest {

    static async uploadImg(url, img) {
        const httpClient = new HttpClient()
        const data = await httpClient.post(url, {image: img})
        if (!data.result) {
            Alert.error(data.data.result.error || 'error')
        }
        return data
    }

    static async uploadString(url, value, name = 'value', method = 'post') {
        await sleep(500)
        const httpClient = new HttpClient()
        let data;
        switch (method) {
            case 'post':
                data = await httpClient.post(url, {[name]: value})
                break;
            case 'get':
                data = await httpClient.get(url  + name + '/' + value + '/')
                break;
            default:
                console.log('unknown method');
                break;
        }

        if (!data.result) {
            Alert.error(data.data.result.error || 'error')
        }
        return data
    }


    static async get(url) {
        const client = new HttpClient();
        let response = await client.get(url);
        return response.data.result;
    }

    static async post(url, data) {
        const client = new HttpClient();
        let response = await client.post(url, data);
        return response.data.result;
    }
}
// = parts/class/Article.js

class Windows
{
    static modal = null;

    static showModal(
        title,
        classes,
        content,
        click = null,
        okCallback = null,
        cancelCallback = null
    ) {
        ModalWindow.create(title, classes, content, click, okCallback, cancelCallback)?.show()
    }

    static closeModal() {
        ModalWindow.last?.close()
    }
}

class ModalWindow {
    /**
     * last instance
     * @type {ModalWindow}
     */
    static last = null;
    /** Element */ ref = null;

    clickCallback = null;
    okCallback = null;
    cancelCallback = null;

    static create(
        title,
        classes,
        content,
        click = null,
        okCallback = null,
        cancelCallback = null
    ) {
        ModalWindow.last = new ModalWindow(title, classes, content, click, okCallback,cancelCallback);
        return ModalWindow.last;
    }

    constructor(
        title,
        classes,
        content,
        clickCallback = null,
        okCallback = null,
        cancelCallback = null
    ) {
        this.clickCallback = clickCallback;
        this.okCallback = okCallback;
        this.cancelCallback = cancelCallback;

        this.ref = HTML.createElement('div', ['modal', 'cancel-on-click']);

        const container = HTML.createElement(
            'div',
            ['modal-content', ...classes],
            { innerHTML: `<h3>${title}</h3><div class="modal-contains"></div>` }
        );

        if (content instanceof Element) {
            container.querySelector('.modal-contains').appendChild(content);
        } else {
            container.querySelector('.modal-contains').innerHTML = content.form;
        }

        this.ref.appendChild(container);
        this.ref.onclick = this.onClick();
        document.body.appendChild(this.ref);
    }

    show() {
        this.ref.style.display = 'block';
    }

    close() {
        this.ref.style.display = 'none';
        this.ref.remove();
    }

    onClick() {
        return (ev) => {
            if (ev.target.classList.contains('ignore-click')) {
                return true;
            }

            if (ev.target.classList.contains('cancel-on-click')) {
                return this.onCancel(ev.target);
            }

            if (ev.target.classList.contains('ok-on-click')) {
                return this.onOk(ev.target);
            }

            if (this.clickCallback) {
                this.clickCallback(this, ev.target);
            }
        }
    }

    onOk() {

    }

    onCancel() {
        console.log('cancel');
        if (this.cancelCallback) {
            this.cancelCallback(this);
        }
        this.close();
    }
}
/* Adds Element BEFORE NeighborElement */
Element.prototype.appendBefore = function (element) {
    element.parentNode.insertBefore(this, element);
}, false;

/* Adds Element AFTER NeighborElement */
Element.prototype.appendAfter = function (element) {
    element.parentNode.insertBefore(this, element.nextSibling);
}, false;

/**
 * Создает код иконки
 * @param name название иконки
 * @param size размер иконки
 * @param asString - вернуть как строку
 * @returns {HTMLSpanElement}
 */
function drawIcon(name, size = 24, asString = false) {
    let icon = document.createElement('span');
    icon.classList.add('svg', 'svg-' + size, 'svg--' + name);
    icon.innerHTML = drawSvg(name)
    return asString ? icon.outerHTML : icon;
}

function drawSvg(name) {
    return '<svg><use xlink:href="/beta/img/sprite.svg#' + name + '"></use></svg>'
}

/**
 * Создает новый элемент с классами из строки вида 'div.class1.class2'
 * @param string
 */
function newElement(string) {
    let arr = string.split('.');
    let elem = document.createElement(arr[0]);
    delete arr[0];
    arr.forEach(function (cls) {
        elem.classList.add(cls)
    })
    return elem;
}

/**
 * Создает новый элемент из html строки
 * @param string
 */
function newElementFromString(string) {
    let tmpDiv = document.createElement('div')
    tmpDiv.innerHTML = string
    let result = tmpDiv.firstChild
    tmpDiv.remove()
    return result;
}

/**
 * Возвращает координаты элемента
 * @param elem
 * @returns {{top: number, left: number}}
 */
function getCoords(elem) {
    let box = elem.getBoundingClientRect();

    let body = document.body;
    let docEl = document.documentElement;

    let scrollTop = window.scrollY || docEl.scrollTop || body.scrollTop;
    let scrollLeft = window.scrollX || docEl.scrollLeft || body.scrollLeft;

    let clientTop = docEl.clientTop || body.clientTop || 0;
    let clientLeft = docEl.clientLeft || body.clientLeft || 0;

    let top = box.top + scrollTop - clientTop;
    let left = box.left + scrollLeft - clientLeft;

    return {top: Math.round(top), left: Math.round(left)};
}

/**
 * Создает рандомную строку
 */
function randomString() {
    return (Math.random() + 1).toString(36).substring(7)
}

/**
 * Проверяет, является ли устройство мобильным
 * @returns {boolean}
 */
function isMobile() {
    let hasTouchScreen = false;

    if ("maxTouchPoints" in navigator) {
        hasTouchScreen = navigator.maxTouchPoints > 0;
    }

    return hasTouchScreen
}

/**
 *
 * @param str
 * @returns {boolean}
 */
function isNumeric(str) {
    if (typeof str != "string") return false // we only process strings!
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

/**
 * @param s
 * @param p
 * @param r
 * @returns {false|*}
 */
function strtr(s, p, r) {
    return !!s && {
        2: function () {
            for (let i in p) {
                s = strtr(s, i, p[i]);
            }
            return s;
        },
        3: function () {
            return s.replace(RegExp(p, 'g'), r);
        },
        0: function () {
            return;
        }
    }[arguments.length]();
}

/**
 * Проверяет, пересекаются ли массивы
 * @param a1
 * @param a2
 * @returns {boolean}
 */
function isArraysIntersect(a1, a2) {
    return a1.filter(function (n) {
        return a2.indexOf(n) !== -1;
    }).length > 0;
}

/**
 * Помещает выпадающий блок под родительским блоком
 * @param block выпадающий блок
 * @param parent родительский блок (блок относительно которого позиционировать
 */
function placeDropBlock(block, parent) {

    let coords = getCoords(parent)

    block.style.display = 'block'
    block.style.minWidth = parent.offsetWidth + 'px';
    block.style.top = coords.top + parent.offsetHeight + 2 + 'px';

    if (coords.left + block.offsetWidth + 20 > window.innerWidth) {
        block.style.left = coords.left - (block.offsetWidth - parent.offsetWidth) + 'px';
    } else {
        block.style.left = coords.left + 'px';
    }

    if (getCoords(block).top + block.offsetHeight + 8 > window.innerHeight) {
        block.style.maxHeight = window.innerHeight - 16 + 'px';
    } else {
        block.style.maxHeight = '400px';
    }

    let evt = document.createEvent("HTMLEvents");
    evt.initEvent('show', false, true);
    block.dispatchEvent(evt);

    //перепозиционирует блок при ресайзе окна
    if (!block.hasAttribute('data-resize-event')) {
        block.setAttribute('data-resize-event', true)

        window.addEventListener('resize', () => {
            if (block.classList.contains('active')) {
                placeDropBlock(block, parent)
            }
        })
    }

    // перепозиционирует блок при изменении отступа от верхней границы документа родителем
    let currentHeight = parent.offsetTop
    const observer = new ResizeObserver((entries) => {
            if (parent.offsetTop !== currentHeight && block.classList.contains('active')) {
                currentHeight = parent.offsetTop
                placeDropBlock(block, parent)
            }
        }
    )
    observer.observe(document.body);

    block.classList.add('active')
    parent.classList.add('active')
}

/**
 * Скрывает выпадающий блок
 * @param block
 * @param parent
 */
function hideDropBlock(block, parent = null) {

    block.classList.remove('active');
    block.removeAttribute('style')

    let evt = document.createEvent("HTMLEvents");
    evt.initEvent('hide', false, true);
    block.dispatchEvent(evt);

    if (parent) {
        parent.classList.remove('active')
    }
}

function getCookie(name) {
    let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(cName, cValue, expDays = 365) {
    let date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}

function resetSearch() {
    document.querySelectorAll('.search_columns .filter').forEach((elem) => {
        let field = ifField.getByElement(elem);
        field.reset();
    })
}

function toggleSearch(btn) {

    btn.classList.toggle('active')
    btn.setAttribute('title', btn.classList.contains('active') ? 'Меньше фильтров' : 'Больше фильтров')


    document.querySelector('.search_columns').classList.toggle('active', btn.classList.contains('active'))

    if (btn.classList.contains('active')) {
        setCookie('uncollapseSearch', 1)
    } else {
        Cookies.remove('uncollapseSearch')
    }
}

/**
 * меняет URL текущей страницы без перезагрузки
 * @param {String} url
 * @param {String} swapUrl
 */
function setCurrentPageUrl(url, swapUrl) {
    if (swapUrl && swapUrl !== window.location.href) {
        return;
    }
    window.history.pushState('', '', url)
}

/**
 * Запрос данных для элемента. Читает data-request. Блокирует элемент на время выполнения запроса.
 * @param {Element} elem
 */
async function request(elem) {
    elem.classList.add('disabled');
    await sleep(300);
    const httpClient = new HttpClient();
    const data = await httpClient.get(elem.getAttribute('data-request'));
    elem.classList.remove('disabled');
    return data;
}

/**
 * Асинхронная задержка
 * @param time
 * @returns {Promise<unknown>}
 */
function sleep(time = 300) {
    return new Promise(resolve => setTimeout(resolve, time));
}

/**
 * Численные окончания 1, 4, 5
 * @param number
 * @param words
 * @returns {*}
 */
function numEnding(number, words) {
    return words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? Math.abs(number) % 10 : 5]];
}

/**
 * Проверяет, пустой ли объект
 * @param obj
 * @returns {boolean}
 */
function isEmpty(obj) {

    if (obj === null || obj === undefined) {
        return true
    }

    for (const prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            return false;
        }
    }

    return JSON.stringify(obj) === JSON.stringify({});
}

/**
 * Проверяет url на валидность
 * @param url
 * @returns {boolean}
 */
function isValidUrl(url) {
    try {
        let tryUrl = new URL(url)
        return tryUrl.protocol === 'http:' || tryUrl.protocol === 'https:';
    } catch (err) {
        return false
    }
}

/**
 * Конвертит файл в строку base64
 * @param file
 */
function getBase64(file) {
    return new Promise(resolve => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function (event) {
            let base64 = event.target.result
            resolve(base64)
        }
    })
}

function elemHover(element, className, target = null) {
    target = target != null ? target : element
    element.addEventListener('mouseenter', e => target.classList.add(className))
    element.addEventListener('mouseleave', e => target.classList.remove(className))
}

//сортируем объект по ключам
function sortObject(notSorted) {
    return notSorted !== null && notSorted !== undefined ? Object.keys(notSorted)
        .sort()
        .reduce(function (acc, key) {
            acc[key] = notSorted[key];
            return acc;
        }, {}) : notSorted
}

ifFields = {};


/**
 * Класс поля ввода
 */
class ifField {

    /**
     * Поле ввода
     * @type {null}
     */
    field = null;
    /**
     * Враппер поля ввода
     * @type {null}
     */
    wrapper = null;
    /**
     * Содержимое Плейсхоледера
     * @type {null}
     */
    placeholderValue = null;
    /**
     * Выпадающий блок
     * @type {{}}
     */
    dropdownBlock = null;

    /**
     * Ключ в массиве полей ввода
     * @type {null}
     */
    index;
    /**
     * Имя поля ввода
     * @type {null}
     */
    name;
    /**
     * Тип поля ввода
     * @type {string}
     */
    type = '';
    /**
     * Тип данных поля
     * @type {null}
     */
    dataType;
    /**
     * Значение в поле ввода
     * @type {null}
     */
    value;
    /**
     * Шаблон выпадающего списка
     * @type {null}
     */
    listTemplate;
    /**
     * Флаг выбора только одного результата
     * @type {boolean}
     */
    isSingle;
    /**
     * Обект всех полей кастомного поля ввода
     */
    customFields = {};
    /**
     * Объект кнопок управления выпадающим полем
     */
    buttons = {};
    /**
     * при изменении поля ввода поиска непосредственный запрос откладывается на 0.Х секунд
     * @type {NodeJS.Timeout}
     */
    liveSearchDelayedRequest = null;
    /**
     * запросы на лайв
     * @type {{}}
     */
    liveSearchRequestList = 0;
    /**
     * счётчик запросов на лайв
     * @type {int}
     */
    liveSearchRequestCounter = 0;
    /**
     * Метка, что поле кастомное
     * @type {boolean|string}
     */
    custom = false;
    /**
     * Метка, что поле - фильтр поиска
     * @type {boolean}
     */
    filter = false;
    /**
     * Отключает дропдаун блок
     * @type {boolean}
     */
    disableDropdown = false;
    /**
     * Действие на кнопке поля
     * @type {null}
     */
    action = null;
    /**
     * Кнопка действия
     * @type {null}
     */
    actionButton = null;
    /**
     * фиксированный текст в начале поля ввода
     * @type {string}
     */
    before = null
    /**
     * Флаг, что поле редактировалось
     * @type {boolean}
     */
    edited = false;

    placeholder = null;

    /**
     * вариации. пока хз, как лучше сделать.
     * @type {array}
     */
    variants = [];

    /**
     * @param field
     * @param type
     */
    constructor(field, type) {
        this.index = field.name + '_' + randomString()
        if (!ifField.getByElement(field)) {
            ifFields[this.index] = this
        }
        this.field = field
        this.type = type
        this.name = field.name
        this.isSingle = this.field.hasAttribute('data-single')
        this.before = this.field.getAttribute('data-before') || null
        this.dataType = {
            text: 'string',
            live_search: 'string',
            dropdown: 'array',
            checkbox: 'bool',
            file: 'attachment',
        }[this.type];
        this.filter = this.field.classList.contains('filter')

        this.disableDropdown = this.field.hasAttribute('data-disable-dropdown')
        this.field.removeAttribute('data-disable-dropdown')

        this.parseValue()
        this.setFilledClass()

        this.field.addEventListener('change', () => {
            this.parseValue();
            this.setFilledClass();
            this.removeError();
            this.edited = true;
        })

    }

    /**
     * обновляет поле до текстового
     */
    buildField_text() {

        this.buildWrapper()

        this.field.addEventListener('click', () => {
            this.field.classList.add('active');
        })
        this.field.addEventListener('blur', () => {
            this.field.classList.remove('active');
        })

        this.buildPlaceholder();

        this.field.addEventListener('input', () => {
            this.dispatchEv()
        })

        this.buildField_custom()

    }

    /**
     * обновляет поле до живого ввода
     */
    buildField_liveSearch() {

        this.field.setAttribute('autocomplete', 'off')

        this.buildWrapper()

        this.buildPlaceholder()

        this.buildDropdownBlock()

        this.field.addEventListener('click', () => {
            if (this.field.classList.contains('active')) {
                this.field.classList.remove('active')
                this.hideDropdownBlock()
            } else {
                this.field.classList.add('active')
                this.placeDropdownBlock()
            }
        })

        document.addEventListener('click', () => {
            if (!this.wrapper.matches(':hover') && !this.dropdownBlock.matches(':hover')) {
                this.field.classList.remove('active')
                this.hideDropdownBlock()
            }
        })

        this.custom = this.field.hasAttribute('data-request') ? 'request' : 'local_filter'

        this.buildField_custom()

    }

    /**
     * Обновляет поле до поля с выпадающим списком
     */
    buildField_dropdown() {

        this.field.ariaReadOnly = true;
        this.field.setAttribute('autocomplete', 'off')

        this.buildWrapper()

        this.buildPlaceholder()

        this.buildDropdownBlock()

        this.field.addEventListener('click', () => {
            if (this.field.classList.contains('active')) {
                this.field.classList.remove('active')
                this.hideDropdownBlock()
            } else {
                this.field.classList.add('active')
                this.placeDropdownBlock()
            }
        });

        document.addEventListener('click', () => {
            if (!this.wrapper.matches(':hover') && !this.dropdownBlock.matches(':hover')) {
                this.field.classList.remove('active');
                this.hideDropdownBlock()
            }
        })

        let val = this.field.value;
        if (val === '') {
            val = "[]";
            this.field.setAttribute('value', '[]');
        }

        if (!this.field.hasAttribute('data-custom')) {
            val = JSON.parse(val);
            val.forEach((id) => {
                this.dropdownBlock.querySelectorAll('.if-list__item[data-value="' + id + '"]').forEach((item) => {
                    item.classList.add('active');
                });
            });
            this.recalcDropdown(false);
        }

        this.field.addEventListener('click', () => {
            this.field.blur()
        });

        this.buildField_custom()
    }

    /**
     * Обновляет поле до чекбокса
     */
    buildField_checkbox() {

        this.buildWrapper()

        if (this.field.hasAttribute('placeholder')) {
            this.buildPlaceholder()
        }

        let toggler = newElement('div.if-toggler')
        this.field.after(toggler);

        this.buildField_custom()

        this.field.addEventListener('change', () => {
            if (this.filter) {
                this.dispatchFilter(true)
            }
            if (this.action) {
                this.wrapper.classList.add('wait')
                this.action().then(() => {
                    this.wrapper.classList.remove('wait')
                })
            } else {
                console.log('action not set or field not edited')
            }
        })

    }

    /**
     * Обновляет поле до поля пр
     */
    buildField_attachment() {

        this.buildWrapper()

        this.field.addEventListener('click', () => {
            this.field.classList.toggle('active')
        });
        document.addEventListener('click', () => {
            if (!this.wrapper.matches(':hover')) {
                this.field.classList.remove('active')
            }
        })
        this.field.addEventListener('change', () => {
            this.files = this.field.files
            this.field.classList.remove('active')
            this.field.blur()
            this.placeholderValue.innerText = this.value ? this.value : '';
        })

        this.buildPlaceholder()

        this.field.addEventListener('input', () => {
            this.dispatchEv()
        });

        this.buildField_custom()

    }

    /**
     * Обновляет поле до кастомного
     */
    buildField_custom() {
        if (this.field.hasAttribute('data-custom') || this.custom) {

            this.custom = !this.custom ? this.field.getAttribute('data-custom') : this.custom;
            this.field.removeAttribute('data-custom')

            switch (this.custom) {

                case 'damage_type':
                    this.buildCustomDamageType()
                    break;

                case 'alignment':
                    this.buildCustomAlignment()
                    break;

                case 'request':
                    this.buildCustomRequest()
                    break;

                case 'local_filter':
                    this.buildCustomFilter()
                    break;

                default:
                    console.log('неизвестный data-custom: ' + this.field.getAttribute('data-custom'))
                    break;
            }
        }
    }

    /**
     * Оборачивает поле ввода в .if-wrapper
     */
    buildWrapper() {
        this.wrapper = newElement('div.if-wrapper__' + this.type);
        this.field.parentNode.insertBefore(this.wrapper, this.field);
        let fieldWrapper = newElement('div.inner-wrapper')
        this.wrapper.appendChild(fieldWrapper);

        fieldWrapper.appendChild(this.field);

        if (this.field.hasAttribute('data-action')) {
            let icon = this.field.getAttribute('data-action')
            this.actionButton = newElement('span.if-action-button.btn.btn-green')
            this.actionButton.appendChild(drawIcon(icon, 16))
            //this.actionButton.setAttribute('title', 'Сохранить')
            this.wrapper.appendChild(this.actionButton)
            this.wrapper.classList.add('has_button')
            this.actionButton.addEventListener('click', () => {
                if (this.action && this.edited) {
                    this.wrapper.classList.add('wait')
                    this.action().then(() => {
                        this.wrapper.classList.remove('wait')
                    })
                } else {
                    console.log('action not set or field not edited')
                }
            })

            this.field.removeAttribute('data-action');

            document.addEventListener('keyup', (event) => {
                if (event.key === 'Enter' && this.field === document.activeElement) {
                    if (this.action && this.edited) {
                        this.wrapper.classList.add('wait')
                        if (this.action().then(() => {
                            this.wrapper.classList.remove('wait')
                        })) {
                            this.field.blur()
                        }
                    } else {
                        console.log('action not set or field not edited')
                    }
                }
            })
        }

    }

    /**
     * Добавляет плейсхолдер
     */
    buildPlaceholder() {
        this.placeholder = newElement('label.if-placeholder');
        this.field.after(this.placeholder);

        this.placeholderValue = document.createElement('span');
        this.placeholderValue.classList.add('if-placeholder__value');
        this.placeholder.appendChild(this.placeholderValue);

        let placeholderText = newElement('span.if-placeholder__text');
        placeholderText.innerText = this.field.placeholder ?? '';
        placeholderText.innerText += this.field.required ? ' *' : '';
        this.placeholder.appendChild(placeholderText);

        if (this.field.hasAttribute('data-icon')) {
            this.setIcon(this.field.getAttribute('data-icon'))
        }
    }

    /**
     * Добавляет выпадающий блок
     */
    buildDropdownBlock() {
        this.dropdownBlock = newElement('div.if-dropdown-block.dropdown');
        document.body.appendChild(this.dropdownBlock);

        this.dropdownBlock.setAttribute('data-hide-event', true)

        if (this.field.hasAttribute('data-buttons')) {
            let lables = {select_all: 'Выбрать все', clear: 'Очистить'};
            let buttonsBlock = newElement('div.if-dropdown__buttons');
            this.dropdownBlock.appendChild(buttonsBlock);

            this.field.getAttribute('data-buttons').split(',').forEach((buttonType) => {
                let button = newElement('div.if-dropdown__button');
                button.innerText = lables[buttonType];
                buttonsBlock.appendChild(button);
                button.addEventListener('click', () => {
                    switch (buttonType) {
                        case 'select_all':
                            this.dropdownBlock.querySelectorAll('.if-list__item').forEach(function (item) {
                                item.classList.add('active')
                            });
                            this.recalcDropdown();
                            break;
                        case 'clear':
                            this.reset();
                            for (const [k, v] of Object.entries(this.customFields)) {
                                ifFields[v].reset()
                            }
                            break;
                        default:
                            console.log(buttonType + ' - not set');
                            break;
                    }

                });
                this.buttons[buttonType] = button;
            });
            this.field.removeAttribute('data-buttons');
        }

        if (this.field.hasAttribute('data-list') && !this.field.hasAttribute('data-custom')) {
            this.listTemplate = JSON.parse(this.field.getAttribute('data-list'));
            let list = newElement('ul.if-list');
            this.dropdownBlock.appendChild(list);

            for (let key in this.listTemplate) {
                let listGroup = newElement('ul.if-list-group');
                list.appendChild(listGroup);

                if (this.listTemplate[key].title !== '') {
                    let listGroupHeader = newElement('div.if-list-group__header');
                    listGroup.appendChild(listGroupHeader);
                    let listGroupTitle = newElement('div.if-list-group-title');
                    listGroupTitle.innerText = this.listTemplate[key].title;
                    listGroupHeader.appendChild(listGroupTitle);

                    if (!this.isSingle) {
                        listGroupTitle.classList.add('has_button');
                        let listGroupButton = newElement('div.if-list-group-button');
                        listGroupHeader.appendChild(listGroupButton);
                        listGroupButton.appendChild(drawIcon('select_all', 16));
                        listGroupButton.addEventListener('click', () => {
                            if (listGroup.querySelectorAll('.if-list__item').length === listGroup.querySelectorAll('.if-list__item.active').length) {
                                listGroup.querySelectorAll('.if-list__item').forEach(function (item) {
                                    item.classList.remove('active')
                                });
                            } else {
                                listGroup.querySelectorAll('.if-list__item').forEach(function (item) {
                                    item.classList.add('active')
                                });
                            }
                            this.recalcDropdown();
                        });
                    }
                }

                let listGroupList = newElement('ul.if-list-group-list');
                listGroup.appendChild(listGroupList);
                for (var key2 in this.listTemplate[key].list) {
                    let item = newElement('li.if-list__item');
                    item.setAttribute('data-value', this.listTemplate[key].list[key2].value);
                    listGroupList.appendChild(item);

                    let listItemTitle = newElement('div.if-list__item-title');
                    listItemTitle.innerText = this.listTemplate[key].list[key2].title;
                    listItemTitle.addEventListener('click', () => {

                        if (item.classList.contains('active')) {
                            item.classList.remove('active')
                        } else {
                            if (this.isSingle) {
                                this.getAllSelectedItems().forEach((item) => {
                                    item.classList.remove('active')
                                });
                                this.field.classList.remove('active')
                                this.hideDropdownBlock();
                            }
                            item.classList.add('active')
                        }
                        this.recalcDropdown();
                    });
                    item.appendChild(listItemTitle);
                }
            }
            this.field.removeAttribute('data-list')
        }

        // window.addEventListener('resize', () => {
        //     if (this.dropdownBlock.classList.contains('active')) {
        //         this.placeDropdownBlock()
        //     }
        // });
    }

    /**
     * Получает значение из поля ввода
     */
    parseValue() {
        switch (this.dataType) {

            case 'array':
                if (!this.field.hasAttribute('value')) {
                    this.field.setAttribute('value', '[]')
                }
                this.value = JSON.parse(this.field.value);
                break;

            case 'bool':
                this.value = this.field.checked;
                break;

            case 'attachment':
                this.value = '';
                for (let a = 0; a < this.field.files.length; a++) {
                    this.value += this.field.files[a].name + ', ';
                }
                this.value = this.value.substring(0, this.value.length - 2);
                break;

            default:
                this.value = this.field.value;

        }

        //console.log(this.value)
    }

    /**
     * Очищает поле ввода
     */
    // TODO переделать
    reset() {
        if (this.value.length || Object.keys(this.value).length || this.value === true) {

            switch (this.type) {
                case 'dropdown':
                    this.getAllSelectedItems().forEach(function (item) {
                        item.classList.remove('active')
                    });
                    this.recalcDropdown();
                    break;
                case 'live_search':
                    this.field.setAttribute('value', '');
                    this.field.value = '';
                    this.dropdownBlock.innerHTML = '';
                    this.dispatchEv()
                    break;
                case 'checkbox':
                    this.setUnchecked()
                    break;
                default:
                    this.field.setAttribute('value', '');
                    this.field.value = '';
                    this.dispatchEv()
                    break;
            }

            for (let key in this.customFields) {
                ifFields[this.customFields[key]].reset()
                ifFields[this.customFields[key]].setFilledClass()
            }

            switch (this.custom) {

                case 'alignment':
                    this.resetCustomAlignment()
                    break;

                default:
                    break;
            }

            this.setFilledClass();
            this.parseValue();
        }
    }

    /**
     * Пересчет значения выпадающего списка
     */
    recalcDropdown(applyFilter = true) {
        let str = '';
        let val = [];
        this.getAllSelectedItems().forEach((item) => {
            str += item.innerText + ', ';
            val.push(item.getAttribute('data-value'))
        });
        str = str.substring(0, str.length - 2);
        this.field.setAttribute('value', JSON.stringify(val))
        this.placeholderValue.innerText = str;
        this.dispatchEv('change', applyFilter)
    }

    /**
     * Устанавливает новое значение аттрибута value
     * @param newValue
     */
    setNewValue(newValue) {
        this.reset();
        this.field.setAttribute('value', newValue);

        switch (this.type) {
            case 'dropdown':
                let val = this.field.value;
                if (val === '') {
                    val = "[]";
                    this.field.setAttribute('value', '[]');
                }
                val = JSON.parse(val);
                val.forEach((id) => {
                    this.dropdownBlock.querySelectorAll('.if-list__item[data-value="' + id + '"]').forEach((item) => {
                        item.classList.add('active');
                    });
                });
                this.recalcDropdown();
                break;

            case 'text':
                this.field.value = newValue
                this.parseValue()
                this.dispatchEv()
                break;

            default:
                this.dispatchEv()
                break;
        }
    }

    /**
     * Управляет состоянием классов .empty и .filled
     */
    setFilledClass() {
        if (this.value.length === 0 || this.value === false) {
            this.field.classList.add('if-empty')
            this.field.classList.remove('if-filled')
        } else {
            this.field.classList.remove('if-empty')
            this.field.classList.add('if-filled')
        }
    }

    /**
     * Возвращает массив всех активных выборов
     */
    getAllSelectedItems() {
        return this.dropdownBlock.querySelectorAll('.if-list__item.active');
    }

    /**
     * Позиционирует выпадающий блок
     */
    placeDropdownBlock() {
        if (this.dropdownBlock && !this.disableDropdown) {
            placeDropBlock(this.dropdownBlock, this.field)
        }
    }

    /**
     * Скрывает выпадающий блок
     */
    hideDropdownBlock() {
        if (this.dropdownBlock) {
            hideDropBlock(this.dropdownBlock)
        }
    }

    /**
     * Отключает выпадающий блок
     */
    disableDropdownBlock() {
        this.hideDropdownBlock()
        this.disableDropdown = true
    }

    /**
     * Проверяет, пустое ли поле ввода
     */
    isEmpty() {
        return !Boolean(this.value.length);
    }

    /**
     * Ставит метку, что поле с ошибкой
     */
    setError() {
        this.field.classList.add('if-error');
    }

    /**
     * Снимает метку, что поле с ошибкой
     */
    removeError() {
        this.field.classList.remove('if-error');
    }

    /**
     * Ставит выделение на поле вида checkbox
     */
    setChecked(dispatch = true, applyFilter = true) {
        this.value = true
        this.field.checked = true
        this.setFilledClass()
        if (dispatch) {
            this.dispatchEv()
        }
        if (this.filter && applyFilter) {
            this.dispatchFilter(applyFilter)
        }
    }

    /**
     * Снимает выделение с поля
     */
    setUnchecked(dispatch = true, applyFilter = true) {
        this.value = false
        this.field.checked = false
        this.setFilledClass()
        if (dispatch) {
            this.dispatchEv()
        }
        if (this.filter && applyFilter) {
            this.dispatchFilter(applyFilter)
        }
    }

    setBool(checked, dispatch = true, applyFilter = true) {
        if (checked) {
            this.setChecked(dispatch, applyFilter)
        } else {
            this.setUnchecked(dispatch, applyFilter)
        }
    }

    /**
     * Ставит новое значение текстового поля
     * @param text
     * @param dispatch
     */
    setText(text, dispatch = true) {
        this.value = text
        this.field.value = text
        this.field.setAttribute('value', text)
        this.setFilledClass()
        if (dispatch) {
            this.dispatchEv()
        }
    }

    /**
     * Ставит новое значение выпадающему списку
     * @param array
     * @param dispatch
     * @param applyFilter
     */
    // TODO сделать
    // setDropdownValue(array, dispatch = true, applyFilter = true) {
    //
    // }

    /**
     * Убирает кнопку action
     */
    removeButton() {
        this.actionButton.remove()
    }

    /**
     * Блокирует поле
     */
    setDisabled() {
        this.field.setAttribute('disabled', true)
    }

    /**
     * Добавляет полю иконку
     * @param icon
     */
    setIcon(icon) {
        this.field.classList.add('has_icon');
        let placeholderIcon = newElement('span.if-placeholder__icon');
        placeholderIcon.appendChild(drawIcon(icon, 16));
        this.placeholder.appendChild(placeholderIcon);
        this.field.removeAttribute('data-icon');
    }

    /**
     * Триггерит событие
     * @param event
     * @param applyFilter
     */
    dispatchEv(event = 'change', applyFilter = true) {
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent(event, false, true);
        this.field.dispatchEvent(evt);
        if (this.filter && applyFilter) {
            this.dispatchFilter(applyFilter)
        }
    }

    /**
     * Триггерит событие обновления фильтра
     */
    async dispatchFilter(applyFilter = true, instant = false) {
        if (applyFilter) {

            if (this.type === 'live_search' && !instant) {
                let evt = document.createEvent("HTMLEvents");
                evt.initEvent('filter-start', false, true);
                document.dispatchEvent(evt);
            }

            if (this.liveSearchDelayedRequest) {
                clearTimeout(this.liveSearchDelayedRequest);
            }

            this.liveSearchDelayedRequest = setTimeout(() => {

                this.applyFilter()

                let evt = document.createEvent("HTMLEvents");
                evt.initEvent('filter', false, true);
                document.dispatchEvent(evt);

            }, isMobile() ? (this.type === 'live_search' && !instant ? 750 : 0) : 0);
        }
    }

    /**
     * Получение поля по имени
     * @param name
     * @returns {null|unknown}
     */
    static getByName(name) {
        for (const [k, f] of Object.entries(ifFields)) {
            if (f.name === name) {
                return f;
            }
        }
        return null;
    }

    /**
     * Получение поля элементу поля ввода
     * @returns {null|unknown}
     * @param field
     */
    static getByElement(field) {
        for (const [k, f] of Object.entries(ifFields)) {
            if (f.field === field) {
                return f;
            }
        }
        return null;
    }

    /**
     * Обнуляет все поля с классом
     * @param cls класс полей ввода для обнуления
     */
    static resetFields(cls = '') {
        for (const [k, f] of Object.entries(ifFields)) {
            if ((cls !== '' && f.field.classList.contains(cls)) || cls === '') {
                f.reset();
            }
        }
    }


    // DAMAGE TYPE
    /**
     * Собирает выпадающий блок для простановки типа урона
     */
    buildCustomDamageType() {

        let block = newElement('div.if-dropdown-custom.if-custom-damage_type')
        this.dropdownBlock.appendChild(block)

        let longFieldBlock = newElement('div.if-custom__long_field')
        block.appendChild(longFieldBlock)

        // before
        let before = newElementFromString('<input type="text" class="if if-sm if-text deferred" placeholder="Текст до..." name="' + this.name + '_before">')
        longFieldBlock.appendChild(before)
        before = new ifField(before, 'text')
        before.buildField_text()
        this.customFields.before = before.index

        this.listTemplate = JSON.parse(this.field.getAttribute('data-list'))
        let customList = newElement('ul.if-list')
        block.appendChild(customList)

        this.field.removeAttribute('data-list')

        let header = newElement('li.if-list__header')
        customList.appendChild(header)

        for (const [k, v] of Object.entries(COMPENDIUM.bestiary.damage_types_tags)) {
            let span = newElement('span.header-legend')
            span.innerText = v
            header.appendChild(span)
            span.addEventListener('click', () => {
                for (const [kk, vv] of Object.entries(this.customFields)) {
                    if (vv.includes('_' + k + '_')) {
                        ifFields[vv].setChecked()
                    }
                    if (k === 'ns' || k === 'na') {
                        if (vv.includes('_a_')) {
                            ifFields[vv].setChecked()
                        }
                    }
                }
            })
        }

        for (const [k, v] of Object.entries(COMPENDIUM.bestiary.damage_types)) {
            let key = parseInt(k);
            let item = newElement('li.if-list__item.if-list__item');
            customList.appendChild(item);
            let label = newElement('label.list-item__label');
            item.appendChild(label);
            label.appendChild(newElementFromString('<span class="list-item__title">' + v + '</span>'));

            let check = newElementFromString('<input type="checkbox" class="if if-checkbox if-sm deferred" name="' + this.name + '_damage_type_' + key + '">')
            label.appendChild(check);
            check = new ifField(check, 'checkbox')
            check.buildField_checkbox()
            this.customFields['damage_type_' + key] = check.index

            check.field.addEventListener('change', () => {
                if (check.value) {
                    item.classList.add('active')
                } else {
                    item.classList.remove('active')

                    // очищает дополнительные поля строки
                    for (const [k, v] of Object.entries(this.customFields)) {
                        if (v.includes(check.name)) {
                            ifFields[v].reset()
                        }
                    }
                }
            })

            if (key === 10 || key === 11 || key === 12) {

                Object.keys(COMPENDIUM.bestiary.damage_types_tags).forEach((e) => {
                    let ch = newElementFromString('<input type="checkbox" class="if if-checkbox if-sm deferred" name="' + this.name + '_damage_type_' + key + '_' + e + '">')
                    item.appendChild(ch)
                    ch = new ifField(ch, 'checkbox')
                    ch.buildField_checkbox()
                    this.customFields['damage_type_' + key + '_' + e] = ch.index

                    // выделяет основное поле
                    ch.field.addEventListener('change', () => {
                        if (ch.value) {
                            check.setChecked()
                        }
                    })
                });

                ['ns', 'na'].forEach((e) => {
                    let ch = ifFields[this.customFields['damage_type_' + key + '_' + e]]
                    ch.field.addEventListener('change', () => {
                        if (ch.value) {
                            ifFields[this.customFields['damage_type_' + key + '_a']].setChecked(false)
                        }
                    })
                });

                let ch = ifFields[this.customFields['damage_type_' + key + '_m']];
                ch.field.addEventListener('change', () => {
                    if (ch.value) {
                        ifFields[this.customFields['damage_type_' + key + '_nm']].setUnchecked(false)
                    }
                });

                ch = ifFields[this.customFields['damage_type_' + key + '_nm']];
                ch.field.addEventListener('change', () => {
                    if (ch.value) {
                        ifFields[this.customFields['damage_type_' + key + '_m']].setUnchecked(false)
                    }
                });

                ch = ifFields[this.customFields['damage_type_' + key + '_a']];
                ch.field.addEventListener('change', () => {
                    if (!ch.value) {
                        ifFields[this.customFields['damage_type_' + key + '_ns']].setUnchecked(false)
                        ifFields[this.customFields['damage_type_' + key + '_na']].setUnchecked(false)
                    }
                });

            }


            let conc = newElementFromString('<input type="text" class="if if-sm if-text deferred" placeholder="(пояснение)" name="' + this.name + '_damage_type_' + key + '_after">')
            item.appendChild(conc)
            conc = new ifField(conc, 'text')
            conc.buildField_text()
            this.customFields['damage_type_' + key + '_after'] = conc.index

            conc.field.addEventListener('change', () => {
                if (conc.value) {
                    check.setChecked()
                }
            })

            if (key === 10 || key === 11 || key === 12) {
                conc.field.addEventListener('focusin', () => {
                    conc.wrapper.classList.add('active')
                })
                conc.field.addEventListener('focusout', () => {
                    conc.wrapper.classList.remove('active')
                })
            }

        }

        longFieldBlock = newElement('div.if-custom__long_field');
        block.appendChild(longFieldBlock);

        let after = newElementFromString('<input type="text" class="if if-sm if-text deferred" placeholder="...текст после" name="' + this.name + '_after">')
        longFieldBlock.appendChild(after);
        after = new ifField(after, 'text')
        after.buildField_text()
        this.customFields.after = after.index

        // преобразует выбор пользователя в массив
        for (const [k, v] of Object.entries(this.customFields)) {
            ifFields[v].field.addEventListener('change', () => {

                this.value = {};

                if (ifFields[this.customFields.before].value) {
                    this.value.before = ifFields[this.customFields.before].value;
                }
                if (ifFields[this.customFields.after].value) {
                    this.value.after = ifFields[this.customFields.after].value;
                }
                this.value.types = {};

                for (let a = 10; a < 23; a++) {

                    if (ifFields[this.customFields['damage_type_' + a]].value) {

                        this.value.types[a] = {};
                        this.value.types[a].value = true;

                        if (a === 10 || a === 11 || a === 12) {
                            if (ifFields[this.customFields['damage_type_' + a + '_nm']].value) {
                                this.value.types[a].nm = ifFields[this.customFields['damage_type_' + a + '_nm']].value;
                            }
                            if (ifFields[this.customFields['damage_type_' + a + '_ns']].value) {
                                this.value.types[a].ns = ifFields[this.customFields['damage_type_' + a + '_ns']].value;
                            }
                            if (ifFields[this.customFields['damage_type_' + a + '_na']].value) {
                                this.value.types[a].na = ifFields[this.customFields['damage_type_' + a + '_na']].value;
                            }
                            if (ifFields[this.customFields['damage_type_' + a + '_m']].value) {
                                this.value.types[a].m = ifFields[this.customFields['damage_type_' + a + '_m']].value;
                            }
                            if (ifFields[this.customFields['damage_type_' + a + '_a']].value) {
                                this.value.types[a].a = ifFields[this.customFields['damage_type_' + a + '_a']].value;
                            }
                        }

                        if (ifFields[this.customFields['damage_type_' + a + '_after']].value) {
                            this.value.types[a].after = ifFields[this.customFields['damage_type_' + a + '_after']].value
                        }
                    }
                }

                if (!Object.keys(this.value.types).length) {
                    delete this.value.types
                }

                if (!this.dropdownBlock.querySelectorAll('.if-filled').length) {
                    this.value = [];
                }

                this.field.setAttribute('value', JSON.stringify(this.value));

                this.dispatchEv()
                this.textCustomDamageType()
            })
        }

        // парсит значение поля
        if (this.value) {

            if (this.value.before !== undefined) {
                ifFields[this.customFields.before].setText(this.value.before, false)
            }

            if (this.value.after !== undefined) {
                ifFields[this.customFields.after].setText(this.value.after, false)
            }

            if (this.value.types !== undefined) {
                for (const [k, v] of Object.entries(this.value.types)) {
                    if (v.value !== undefined) {
                        ifFields[this.customFields['damage_type_' + k]].setChecked(false)
                        ifFields[this.customFields['damage_type_' + k]].wrapper.parentNode.parentNode.classList.add('active');

                        Object.keys(COMPENDIUM.bestiary.damage_types_tags).forEach((e) => {
                            if (v[e] !== undefined) {
                                ifFields[this.customFields['damage_type_' + k + '_' + e]].setChecked(false)
                            }
                        })

                        if (v.after !== undefined) {
                            ifFields[this.customFields['damage_type_' + k + '_after']].setText(v.after, false)
                        }
                    }
                }
            }
        }

        // собирает текст
        this.textCustomDamageType()
    }

    /**
     * собирает текстовую строку для поля ввода с типами урона
     */
    textCustomDamageType() {

        if (this.value) {
            let str = '';

            if (this.value.before !== undefined) {
                str += this.value.before + ' ';
            }

            if (this.value.types !== undefined) {
                for (const [k, v] of Object.entries(this.value.types)) {
                    if (v.value !== undefined) {

                        str += COMPENDIUM.bestiary.damage_types[k];

                        Object.keys(COMPENDIUM.bestiary.damage_types_tags).forEach((e) => {
                            if (v[e] !== undefined) {
                                str += ' ' + COMPENDIUM.bestiary.damage_types_tags[e];
                            }
                        })

                        if (v.after !== undefined) {
                            str += ' (' + v.after + ')';
                        }

                        str += ', ';
                    }
                }
            }

            if (this.value.after !== undefined) {
                str += this.value.after;
            }

            this.placeholderValue.innerText = str;
        }
    }


    // ALIGNMENT
    /**
     * Собирает выпадающий блок для мировоззрений
     */
    buildCustomAlignment() {

        this.alignmentButtons = {}

        let block = newElement('div.if-dropdown-custom.if-custom-alignment.grid')
        this.dropdownBlock.appendChild(block)
        for (const [k, v] of Object.entries(COMPENDIUM.bestiary.alignment)) {

            let button, col;

            switch (k) {
                case 'none':
                case 'any':
                    col = newElement('div.col-12')
                    block.appendChild(col);

                    button = newElementFromString('<button class="btn btn-primary btn-sm" data-alignment="' + k + '">' + COMPENDIUM.bestiary.alignment[k] + '</button>')
                    col.appendChild(button)
                    break;

                default:
                    col = newElement('div.col-8.col-button')
                    block.appendChild(col);

                    button = newElementFromString('<button class="btn btn-primary btn-custom" data-alignment="' + k + '">' + v + '</button>')
                    col.appendChild(button)
                    break;
            }

            this.alignmentButtons[k] = button;
        }

        Object.keys(this.alignmentButtons).forEach((key) => {

            let btn = this.alignmentButtons[key]

            btn.addEventListener('click', () => {
                switch (key) {
                    case 'any':
                        Object.keys(this.alignmentButtons).forEach((k) => {
                            if(k !== 'any' && k !== 'none') {
                                this.alignmentButtons[k].classList.add('active')
                            }
                        })
                        this.alignmentButtons['none'].classList.remove('active')
                        break;
                    case 'none':
                        Object.keys(this.alignmentButtons).forEach((k) => {
                            if(k !== 'none') {
                                this.alignmentButtons[k].classList.remove('active')
                            }
                        })
                        btn.classList.toggle('active')
                        break;

                    default:
                        btn.classList.toggle('active')
                        this.alignmentButtons['none'].classList.remove('active')
                        this.alignmentButtons['any'].classList.remove('active')
                        break;
                }

                this.valueCustomAlignment()
                this.setFilledClass()
            })

        })

        if (Array.isArray(this.value)) {
            let obj = {};
            obj.types = {};
            this.value.forEach((tag) => {
                obj.types[tag] = {};
                obj.types[tag].value = true;
            })
            this.value = obj
        }

        if (!isEmpty(this.value.types)) {
            Object.keys(this.value.types).forEach((tag) => {
                this.dropdownBlock.querySelector(['[data-alignment="' + tag + '"]']).classList.add('active')
            })
        }

        this.textCustomAlignment();

        if (this.filter) {
            this.value = !isEmpty(this.value.types) ? Object.keys(this.value.types) : []
        }
    }

    /**
     * Преобразует выбранные значения в массив
     */
    valueCustomAlignment() {
        this.value = {};
        this.value.types = {};
        this.dropdownBlock.querySelectorAll('[data-alignment].active').forEach((btn) => {
            this.value.types[btn.getAttribute(['data-alignment'])] = {}
            this.value.types[btn.getAttribute(['data-alignment'])]['value'] = true;
        })
        if (isEmpty(this.value.types)) {
            delete this.value.types
        }

        if (Object.keys(this.value.types || []).join('') === 'any') {
            this.value.types = {}
            Object.keys(this.alignmentButtons).forEach((key) => {
                if (key !== 'none') {
                    this.alignmentButtons[key].classList.add('active')
                    this.value.types[key] = {}
                    this.value.types[key]['value'] = true
                }
            })
        }

        this.alignmentButtons.any.classList.toggle('active', Object.keys(this.value.types || []).length > 8)

        // ветвление для поиска
        if (this.field.classList.contains('filter')) {
            if (!isEmpty(this.value.types)) {
                this.field.setAttribute('value', JSON.stringify(Object.keys(this.value.types)))
            } else {
                this.field.setAttribute('value', '[]');
            }
        } else {
            this.field.setAttribute('value', JSON.stringify(this.value))
        }

        this.value.types = sortObject(this.value.types)

        this.textCustomAlignment()
        this.dispatchEv()
    }

    /**
     * Обнуляет поле
     */
    resetCustomAlignment() {
        this.dropdownBlock.querySelectorAll('.active[data-alignment]').forEach((btn) => {

            btn.classList.remove('active')
        })
        this.value = []
        this.textCustomAlignment()
        this.dispatchEv()
    }

    /**
     * Собирает текстовую строку
     */
    textCustomAlignment() {
        let str = '';
        if (this.value.types !== undefined) {
            delete this.value.types.any
            let union = COMPENDIUM.bestiary.alignment_union[Object.keys(this.value.types).join('.')]
            str += (typeof union !== 'undefined') ? union + ', ' : ''
            if (!str) {
                Object.keys(this.value.types).forEach((tag) => {
                    str += COMPENDIUM.bestiary.alignment[tag] + ', '
                })
            }

        }

        this.placeholderValue.innerText = str.substring(0, str.length - 2)
    }


    // AJAX REQUEST
    /**
     * Собирает выпадающий блок для поля ввода с запросом на сервер
     */
    buildCustomRequest() {

        this.requestSrc = this.field.getAttribute('data-request')
        this.field.removeAttribute('data-request')

        let counter = 0;

        this.field.addEventListener('input', async () => {
            this.dispatchEv()
            if (this.liveSearchDelayedRequest) {
                clearTimeout(this.liveSearchDelayedRequest);
            }
            this.liveSearchDelayedRequest = setTimeout(async () => {
                const httpClient = new HttpClient();
                const data = await httpClient.post(this.requestSrc, {
                    search: this.field.value
                });

                if (!data.result) {
                    return;
                }

                if (this.variants.liveSearchOnReceive) {
                    return this.variants.liveSearchOnReceive(this, data);
                }

                this.dropdownBlock.innerHTML = data.string;
                this.dropdownBlock.querySelectorAll('.if-list__item-title').forEach((item) => {
                    if (this.variants.requestDropdownTitleClick) {
                        item.addEventListener('click', this.variants.requestDropdownTitleClick(item));
                        return;
                    }
                    item.addEventListener('click', () => {
                        let oldVal = this.field.value;
                        this.field.value = item.innerText;
                        if (oldVal !== this.field.value) {
                            this.dispatchEv()
                        }
                        this.field.classList.remove('active');
                        this.field.selectionStart = this.field.selectionEnd = this.field.value.length;
                        this.field.focus();
                        this.hideDropdownBlock()
                    });
                });

            }, 500);
            counter = 0;
            this.field.classList.add('active')
            this.placeDropdownBlock()
        })

        this.field.addEventListener('keydown', async (event) => {
            if (event.code === 'Enter' && this.field.classList.contains('active') && counter) {
                event.preventDefault();
            }
        })

        this.field.addEventListener('keyup', async (event) => {
            let rows = this.dropdownBlock.querySelectorAll('.if-list__item');
            switch (event.code) {
                case 'ArrowDown':
                    counter++;
                    counter = counter > rows.length ? 1 : counter;
                    break;
                case 'ArrowUp':
                    counter--;
                    counter = counter < 1 ? rows.length : counter;
                    break;
                case 'Enter':
                    if (rows.length) {
                        this.field.value = rows[counter - 1].innerText;
                        this.dispatchEv()
                        if (rows[counter - 1].hasAttribute('onclick')) {
                            let func = rows[counter - 1].getAttribute('onclick').toString();
                            func = func.replaceAll("'", '').split(/\(|\);/);
                            window[func[0]](func[1]);
                        }
                        this.field.classList.remove('active')
                        this.hideDropdownBlock()
                    }
                    break;
                default:
                    break;
            }
            if (counter && rows.length) {
                rows.forEach(function (row) {
                    row.classList.remove('hover')
                });
                rows[counter - 1].classList.add('hover')
            }
        })

    }


    // FILTER STRING
    /**
     * Собирает выпадающий блок для поля ввода фильтров на стороне пользователя (LIST.data.filter)
     */
    buildCustomFilter() {

        this.field.addEventListener('input', () => {
            this.dispatchEv()
            this.field.classList.add('active')
            this.placeDropdownBlock()
        })

        let counter = 0;

        this.field.addEventListener('keydown', async (event) => {
            if (event.code === 'Enter' && this.field.classList.contains('active') && counter) {
                event.preventDefault();
            }
        })

        this.field.addEventListener('keyup', async (event) => {
            let rows = this.dropdownBlock.querySelectorAll('.if-list__item');
            switch (event.code) {
                case 'ArrowDown':
                    counter++;
                    counter = counter > rows.length ? 1 : counter;
                    break;
                case 'ArrowUp':
                    counter--;
                    counter = counter < 1 ? rows.length : counter;
                    break;
                case 'Enter':
                    if (rows.length) {
                        this.field.value = rows[counter - 1].innerText;
                        this.dispatchEv()
                        if (rows[counter - 1].hasAttribute('onclick')) {
                            let func = rows[counter - 1].getAttribute('onclick').toString();
                            func = func.replaceAll("'", '').split(/\(|\);/);
                            window[func[0]](func[1]);
                        }
                        this.field.classList.remove('active')
                        this.hideDropdownBlock()
                    }
                    break;
                default:
                    break;
            }
            if (counter && rows.length) {
                rows.forEach(function (row) {
                    row.classList.remove('hover')
                });
                rows[counter - 1].classList.add('hover')
            }
        })

    }


    /**
     * Применяет фильтр
     */
    applyFilter() {

        if ('undefined' === typeof LIST) {
            console.log('Не задан список для фильтрации')
            return;
        }

        let tag = LIST.category + '_' + this.name;

        switch (tag) {

            case 'spells_search':

                let filtered = []

                let str = this.value.toLowerCase().trim();
                let fixed_en_to_ru = strtr(str, COMPENDIUM.eng_to_ru);
                let fixed_ru_to_en = strtr(str, COMPENDIUM.ru_to_eng);

                for (const [key, data] of Object.entries(LIST.cards)) {
                    let match = !str;

                    match = match || (-1 !== data.filter_text.indexOf(str)) || (-1 !== data.filter_text.indexOf(fixed_en_to_ru)) || (-1 !== data.filter_text.indexOf(fixed_ru_to_en));

                    LIST.cards[key].filter[tag] = !match

                    if (match) {
                        filtered.push(data)
                    }
                }

                if (!this.disableDropdown) {
                    this.dropdownBlock.innerHTML = ''

                    let ul = newElement('ul.if-list')
                    this.dropdownBlock.appendChild(ul)

                    let counterList = 0;

                    for (const [key, data] of Object.entries(filtered)) {
                        if (counterList < 10) {

                            counterList++

                            let li = newElement('li.if-list__item')
                            ul.appendChild(li)

                            let title = newElement('span.if-list__item-title')
                            title.innerText = data.title
                            title.addEventListener('click', () => {
                                let oldVal = this.value;
                                this.setText(data.title, false)
                                if (oldVal !== data.title) {
                                    this.dispatchEv('change', false)
                                    //this.dispatchFilter(false)
                                }
                                this.field.classList.remove('active');
                                this.field.selectionStart = this.field.selectionEnd = this.field.value.length;
                                this.field.focus();
                                this.hideDropdownBlock()
                            })
                            li.appendChild(title)

                            let a = newElement('a.if-list__item-link')
                            a.appendChild(drawIcon('external_link', 16))
                            a.href = data.link
                            li.appendChild(a)

                        } else {
                            break
                        }
                    }

                    if (filtered.length > 10) {

                        let total = newElement('div.if-dropdown__total')
                        this.dropdownBlock.appendChild(total)

                        let totalText = newElement('div.if-dropdown__total-text')
                        totalText.innerText = 'и еще ' + (filtered.length - 10) + ' ' + numEnding(filtered.length - 10, ['результат', 'результата', 'результатов'])

                        total.appendChild(totalText)

                    }
                }
                break;

            case 'spells_components':
                let cmps_final = ['\\d', '\\d', '\\d'];
                this.value.forEach(cm => {
                    switch (cm) {
                        case 'v':
                            cmps_final[0] = 1;
                            break;
                        case 's':
                            cmps_final[1] = 1;
                            break;
                        case 'm':
                            cmps_final[2] = 1;
                            break;
                        case '-v':
                            cmps_final[0] = 0;
                            break;
                        case '-s':
                            cmps_final[1] = 0;
                            break;
                        case '-m':
                            cmps_final[2] = 0;
                            break;
                    }
                });
                let componentsReg = new RegExp('^' + cmps_final.join('\\|'));
                for (const [key, data] of Object.entries(LIST.cards)) {

                    LIST.cards[key].filter.spells_components = data.filter_components.match(componentsReg) === null
                }

                break;

            case 'spells_class':
            case 'spells_disableTasha':
                let disableTasha = ifField.getByName('disableTasha').value
                let classValue = ifField.getByName('class').value
                if (disableTasha) {
                    for (const [key, data] of Object.entries(LIST.cards)) {
                        LIST.cards[key].filter['spells_class'] = !isArraysIntersect(classValue.map(String), data['filter_class'].toString()) && classValue.length > 0
                    }
                } else {
                    for (const [key, data] of Object.entries(LIST.cards)) {
                        LIST.cards[key].filter['spells_class'] = (
                            !isArraysIntersect(classValue.map(String), data['filter_class'].toString()) &&
                            !isArraysIntersect(classValue.map(String), data['filter_class_tce'].toString())
                        ) && classValue.length > 0
                    }
                }
                break;

            default:
                for (const [key, data] of Object.entries(LIST.cards)) {
                    LIST.cards[key].filter[tag] = !isArraysIntersect(this.value.map(String), data['filter_' + this.name].map(String)) && this.value.length > 0
                }
                break;

        }

        for (const [key] of Object.entries(LIST.cards)) {
            if (!this.value.length) {
                delete LIST.cards[key].filter[tag]
            }
        }

    }
}

/**
 * Сбрасывает фильтры поиска
 */
function resetFilters() {
    ifField.resetFields('filter');
    document.querySelectorAll('.list .hidden_by_text').forEach((item) => {
        item.classList.remove('hidden_by_text');
    });
    document.querySelectorAll('.first-letter.hidden').forEach((item) => {
        item.classList.remove('hidden');
    });
}

function searchFormToggleFooter() {
    let toggle = document.querySelector('button.toggle-search-footer');
    let footerElements = document.querySelectorAll('div.search-form-footer');

    if (toggle.classList.contains('active')) {
        toggle.classList.remove('active');
        footerElements.forEach(elem => elem.style.display = 'none');
    } else {
        toggle.classList.add('active');
        footerElements.forEach(elem => elem.style.display = '');
    }
}

(function () {

    document.addEventListener("DOMContentLoaded", () => {

        /**
         * Инициализируем поля TEXT
         */
        document.querySelectorAll('.if-text:not(.deferred)').forEach(function (elem) {
            let field = new ifField(elem, 'text');
            field.buildField_text()
        });

        /**
         * Инициализируем поля LIVE_SEARCH
         */
        document.querySelectorAll('.if-live_search:not(.deferred)').forEach(function (elem) {
            let field = new ifField(elem, 'live_search');
            field.buildField_liveSearch()
        });

        /**
         * Инициализируем поля DROPDOWN
         */
        document.querySelectorAll('.if-dropdown:not(.deferred)').forEach(function (elem) {
            let field = new ifField(elem, 'dropdown');
            field.buildField_dropdown()
        });

        /**
         * Инициализируем поля CHECKBOX
         */
        document.querySelectorAll('.if-checkbox:not(.deferred)').forEach(function (elem) {
            let field = new ifField(elem, 'checkbox');
            field.buildField_checkbox()
        });

        /**
         * Инициализируем поля FILE
         */
        document.querySelectorAll('.if-file:not(.deferred)').forEach(function (elem) {
            let field = new ifField(elem, 'file');
            field.buildField_attachment()
        });

        document.querySelectorAll('form:not(#workshop-form)').forEach((form) => {
            form.addEventListener('submit', (event) => {
                event.preventDefault();
                let noErrors = true;
                form.querySelectorAll('.if[required]').forEach((f) => {
                    let field = ifField.getByElement(f);
                    if (field.isEmpty()) {
                        noErrors = false;
                        field.setError();
                    }
                });
                if (noErrors) {
                    form.submit();
                }
            });
        });

        document.querySelectorAll('.deferred').forEach(function (elem) {
            elem.classList.remove('deferred')
        })

        let evt = document.createEvent("HTMLEvents");
        evt.initEvent('fieldsReady', false, true);
        document.dispatchEvent(evt);



    });

})();
/** сворачивание/разворачивание левого меню */
function toggleLeftMenuBlock(elem) {
    elem.addEventListener('click', (e) => {
        e.preventDefault()
        let tag = elem.getAttribute('data-menu')
        if (elem.classList.contains('active')) {
            elem.classList.remove('active')
            setCookie(tag, 1)
        } else {
            elem.classList.add('active')
            Cookies.remove(tag)
        }
    })
}

function rollHits(e, t, n, r, i) {
    void 0 === r && (r = "", i = "");
    for (var o = "", s = 0, a = 0; a < t; a++) {
        var u = Math.floor(Math.random() * n + 1);
        o = o + "<strong>" + u + "</strong> + ", s += u
    }
    o = o.substr(0, o.length - 2), "+" === r && (o = o + " + " + i, s += i), "-" === r && (o = o + " - " + i, (s -= i) < 1 && (s = 1)), o = o + " = <span>" + s + "</span>", $(e).next(".rolled-hits").html(o)
}


/** левое меню и  меню пользователя */
(function () {

    let left = document.getElementById('aside');
    let hamb = document.getElementById('top__hamburger')
    let touchstartX = 0
    let touchendX = 0
    let touchnow = 0
    let minSvipeRoute = 160;
    let screenWidth = window.screen.width;
    let screenPadding = 40; // отстут от края экрана для засчитывания свайпа
    let a = 0;
    let enable_swipe = Cookies.get('disable_swipe') === undefined

    let span = newElement('span');

    function sw() {
        if (touchstartX > screenPadding && touchstartX < (screenWidth - screenPadding) && enable_swipe) {
            if (touchnow < touchstartX && Math.abs(touchstartX - touchnow) > 100) {
                a = minSvipeRoute - Math.abs(touchstartX - touchnow)
                if (a < 20) {
                    left.classList.add('active');
                    hamb.classList.add('active');
                    left.style.transform = ''
                } else if (!left.classList.contains('active')) {
                    left.style.transform = 'translateX(' + a / 2 + '%)'
                }
            }
        }
    }

    function checkDirection() {
        if (touchstartX > screenPadding && touchstartX < (screenWidth - screenPadding) && enable_swipe) {
            if (touchendX < touchstartX && Math.abs(touchstartX - touchendX) > minSvipeRoute) {
                left.classList.add('active');
                hamb.classList.add('active');
            }
            if (touchendX > touchstartX && Math.abs(touchstartX - touchendX) > minSvipeRoute) {
                left.style.transform = ''
                left.classList.remove('active');
                hamb.classList.remove('active');
            }
        }
    }



    document.addEventListener("DOMContentLoaded", () => {

        document.addEventListener('touchstart', e => {
            enable_swipe = Cookies.get('disable_swipe') === undefined
            touchstartX = e.changedTouches[0].screenX
        })

        document.addEventListener('touchend', e => {
            touchendX = e.changedTouches[0].screenX
            checkDirection()
            if (a > 20) {
                left.style.transform = ''
                left.classList.remove('active');
                hamb.classList.remove('active');
            }
        })

        document.addEventListener('touchmove', e => {
            touchnow = e.changedTouches[0].screenX
            sw()
        })

        document.getElementById('top__hamburger').addEventListener('click', () => {
            if (left.classList.contains('active')) {
                left.classList.remove('active');
                hamb.classList.remove('active');
            } else {
                left.classList.add('active');
                hamb.classList.add('active');
            }
        })

        /**
         * Сворачивание/разворачивание блоков левого меню
         */
        document.querySelectorAll('aside .dropdown_trigger').forEach((elem) => {
            toggleLeftMenuBlock(elem)
        })

        /** скрытие блоков левого меню */
        document.querySelectorAll('aside .hide_trigger').forEach((elem) => {
            elem.addEventListener('click', (e) => {
                e.preventDefault()
                setCookie(elem.getAttribute('data-menu'), 1, 365)
                elem.parentNode.remove()
            })
        })

    })


})();

/**
 * Скроллер в начало страницы
 */
(function () {
    let scroller = document.querySelector('.toUp');

    document.addEventListener('scroll', () => {
        let position = window.scrollY;
        if (position > 1500) {
            scroller.classList.add('active')
        } else {
            scroller.classList.remove('active')
        }
    })

    scroller.addEventListener('click', () => {
        window.scrollTo(0, 0)
    })

})();


// document.addEventListener('DOMContentLoaded', ()=>{
//
//     Article.hiddebleElements()
//
// })
$(window).load(function () {

	$(document).on("click", function () {
		$(".input-select,.input-select-multiple,.input-select-multiple-options").each(function () {
			$(this).is(":hover") || $(this).hasClass("active") && $(this).removeClass("active").children("ul").slideUp(200)
		})
	});
	
	$(".input-select-multiple-options").on("click", function () {
		// console.log($("li:hover", this).length);
		if ($("li:hover", this).length) {
			return;
		}

		let input = $(this);
		if (input.hasClass("active")) {
			input.removeClass("active");
			input.children("ul").slideUp(200);
		} else {
			input.addClass("active");
			input.children("ul").slideDown(200);
		}
	});

	function multieditUpdate(ref) {
		let $this = $(ref);
		let holder = $this.parents('.input-select-multiple-options');
		let li = $this.parents('li[data-key]').first();
		let ul = li.parent();
		let span = holder.children('span[data-default]').first();
		let input = holder.children('input').first();
		let dataType = $this.attr("data-unit");
		console.log(ref);
		let active = ('checkbox' == dataType) ? $this.is(':checked') : ('' != $this.val());
		active ? li.addClass("active") : li.removeClass("active");
		
		let multieditCaptionList = [];
		let multieditValueList = [];
		ul.children(".active").each(function () {
			//li = this
			let option = $(".option", this);
			let sub_option = $(".sub_option", this);
			let optionValue = Math.abs(parseInt(option.val()));
			let optionTitle = option.attr("data-stat") || '';;

			let units = option.attr("data-unit");
			let subOptionValue = sub_option.val() || '';

			let thisCaption = '';
			let thisValue = [$(this).attr("data-key")];

			let dataType = $(this).attr("data-type");
			switch (dataType) {
				case "int": 
				case 'number': {
					let sign = ('number' == dataType) ? '' : (/[\+\-]/.test(option.val()) ? /[\+\-]/.exec(option.val())[0] : "+");
					thisCaption = `${optionTitle} ${sign}${optionValue}` ;
					thisValue.push(sign + optionValue);
				} break;
				case "unit": {
					thisCaption = `${optionTitle} ${optionValue} ${units}`;
					thisValue.push(optionValue);
				} break;
				case 'checkbox': {
					thisCaption = optionTitle;
					thisValue.push(1);
				} break;
				case "none": 
				default: {
					thisCaption =  `${optionTitle} ${optionValue}`;
					thisValue.push(optionValue);
				} break;
			}

			if (subOptionValue) {
				thisCaption += " (" + subOptionValue + ")";
				thisValue.push(subOptionValue);
			}

			if (subOptionValue.includes('@') || subOptionValue.includes('$') || subOptionValue.includes('#')) {
				thisCaption = subOptionValue
					.replace('@', optionTitle)
					.replace('#', '')
					.replace('$', optionValue);
			}

			multieditCaptionList.push(thisCaption);
			multieditValueList.push(thisValue);
		});

		let multieditCaption = multieditCaptionList.filter(v => v).join(', ');
		let multieditValue = multieditValueList.map(values => values.join('~')).join('|');
		let placeholder = span.attr("data-default");
		if (multieditCaption) {
			span
				.addClass("active")
				.text(multieditCaption)
				.attr("title", placeholder + ": " + multieditCaption);
			input.attr("value", multieditValue);
		} else {
			span
				.removeClass("active")
				.text(placeholder)
				.removeAttr("title");
			input.removeAttr("value");
		}
	}

	$(".input-select-multiple-options .option")
		.on("focusout", function () { multieditUpdate(this); })
		.on("change", function () { multieditUpdate(this); });
	$(".input-select-multiple-options .sub_option")
		.on("focusout", function () { multieditUpdate(this); })
		.on("change", function () { multieditUpdate(this); });

	$(".input-select-multiple-options .sub_option").on("focusout", function () {
		$(this).prev().focus().blur()
	});

});

(function () {
    document.addEventListener("DOMContentLoaded", () => {

        // проверяем хэш
        if (window.location.hash) {
            let header = document.getElementById(window.location.hash.substring(1))
            if (!header) {
                return;
            }
            header = header.closest('.hide-next-h2');
            if (!header) {
                return;
            }

            header.classList.add('active');
            header.nextElementSibling.style.display = 'block';
        }

        document.querySelectorAll('.icon-checkbox').forEach((elem) => {
            elem.addEventListener('click', () => {
                elem.classList.toggle('active')
            })
        })

        document.querySelectorAll('.scroll-link').forEach(function (elem) {
            let target = document.getElementById(elem.getAttribute('href').substring(1));

            elem.addEventListener('click', function (event) {
                event.preventDefault();
                document.querySelectorAll('.hide-next.active').forEach(function (block) {
                    block.classList.remove('active');
                });
                document.querySelectorAll('.hide-wrapper').forEach(function (block) {
                    block.style.display = 'none';
                });

                window.location.hash = elem.getAttribute('href');

                target.parentElement.classList.add('active');
                target.parentElement.nextElementSibling.style.display = 'block';
                target.scrollIntoView({block: 'start', behavior: 'smooth'});
            });
        });

        // подтверждение действия для элемента с классом .confirm
        document.querySelectorAll('.confirm').forEach(function (elem) {
            elem.addEventListener('click', (e) => {
                window.confirm("Вы уверены?") || e.preventDefault()
            })
        })

    })
})()

$(window).load(function () {

    $(".switch-box").on("click", function () {

        var e;

        if ($(this).hasAttr("data-switch")) e = $(this).attr("data-switch"); else e = 0;

        if ($(this).hasAttr("revers")) {
            if ($(this).hasClass("active")) {
                $(this).removeClass("active"), setCookie(e, 1, 365)
            } else {
                $(this).addClass("active"), setCookie(e, 1, 365), Cookies.remove(e)
            }
        } else {
            // console.log(1);

            if ($(this).hasClass("active")) {
                $(this).removeClass("active"), Cookies.remove(e)
            } else {
                $(this).addClass("active"), setCookie(e, 1, 365)
            }
        }


    })

    $(".input-select:not(.input-cast_time)").on("click", function () {
        var e = $(this);
        e.hasClass("active") ? (e.removeClass("active"), e.children("ul").slideUp(200)) : (e.addClass("active"), e.children("ul").slideDown(200))
    })

    $(".input-select li").on("click", function () {
        "" != $(this).attr("data-value") ? ($(this).parent().prev().addClass("active").text($(this).text()).attr("title", $(this).parent().prev().attr("data-default") + ": " + $(this).text()).prev().attr("value", $(this).attr("data-value")).val($(this).attr("data-value")).trigger('change'), $(this).parent().children("li").removeClass("active"), $(this).addClass("active")) : ($(this).parent().prev().removeClass("active").text($(this).parent().prev().attr("data-default")).attr("title", $(this).parent().prev().attr("data-default")).prev().attr("value", '').val('').trigger('change'), $(this).parent().children("li").removeClass("active"))
    })

    $(".input-select-multiple").on("click", function () {
        var e = $(this);
        0 == $("li:hover", this).length && (e.hasClass("active") ? (e.removeClass("active"), e.children("ul").slideUp(200)) : (e.addClass("active"), e.children("ul").slideDown(200)))
    })

    $(".input-select-multiple li").on("click", function () {
        if ("" != $(this).attr("data-value")) {
            $(this).hasClass("active") ? $(this).removeClass("active") : $(this).addClass("active");
            var e = "", t = "";
            $(this).parent().children(".active").each(function () {
                e += $(this).text() + ", ", t += $(this).attr("data-value") + "|"
            }), e = e.slice(0, -2), t = t.slice(0, -1), $(this).parent().prev().addClass("active").text(e).attr("title", $(this).parent().prev().attr("data-default") + ": " + e).prev().attr("value", t).val(t).trigger('change')
        } else {
            if (!$(this).hasClass('select_all')) {
                e = $(this).parent().children(".default").text();
                $(this).parent().prev().removeClass("active").text(e).removeAttr("title").prev().attr("value", '').val('').trigger('change'), $(this).parent().children("li").removeClass("active"), $(this).parent().slideUp(200).parent().removeClass("active")
            } else {
                var e = "", t = "";
                $(this).nextAll().each(function () {
                    $(this).addClass('active');
                    e += $(this).text() + ", ", t += $(this).attr("data-value") + "|"
                }), e = e.slice(0, -2), t = t.slice(0, -1), $(this).parent().prev().addClass("active").text(e).attr("title", $(this).parent().prev().attr("data-default") + ": " + e).prev().attr("value", t).val(t).trigger('change')
            }
        }
        0 == $(this).parent().children(".active").length && $(this).parent().prev().text($(this).parent().prev().attr("data-default")).removeClass("active")
    })

    document.querySelectorAll('.show-email').forEach((link) => {
        let user = link.getAttribute('data-user');
        link.onclick = async () => {
            const mail = await HttpClient.get(`/request/show_email/?user=${user}`);
            if (!mail || !mail.email) return;

            link.onclick = null;
            link.setAttribute('href', `mailto:${mail.email}`);
            link.innerText = mail.email;
            link.classList.remove('show-email');
        };
    });

    $(".message-close").on("click", function () {
        $(this).parent().parent().addClass("active").slideUp(200)
    })

    $(".error,.message,.notification").each(function () {
        var e = $(this);
        setTimeout(function () {
            e.hasClass("active") || e.addClass("active").slideUp(200)
        }, 5e3)
    })

    $(".inner-card .item-link").on("click", function (e) {
        e.preventDefault();
        var t = $(this).closest(".inner-card");
        t.hasClass("active") ? t.removeClass("active").find(".card__body").slideUp(300) : t.addClass("active").find(".card__body").slideDown(300)
    })

    $(".hide-next").on("click", function () {
        $(this).hasClass("active") ? $(this).removeClass("active").next().slideUp(100) : $(this).addClass("active").next().slideDown(100)
    })

})

$.fn.hasAttr = function (e) {
    return void 0 !== this.attr(e)
}

$(window).load(function () {

    Array.prototype.remove = function () {
        var what, a = arguments, L = a.length, ax;
        while (L && this.length) {
            what = a[--L];
            while ((ax = this.indexOf(what)) !== -1) {
                this.splice(ax, 1);
            }
        }
        return this;
    };

    var comparater_source = function (a, b) {
        var result = 0;
        if ($(a).hasClass('tile-filtered') > $(b).hasClass('tile-filtered')) result = 1; else result = -1;
        return result;
    }
    var comparater_title = function (a, b) {
        var result = 0;
        if (!$(a).hasClass('tile-filtered')) {
            if ($(a).find('.article_title').text() > $(b).find('.article_title').text()) result = 1; else result = -1;
        } else result = 1;
        return result;
    }

})


//////////// COMMON.NEW ///////////////////

/**
 * Фильтр массива на уникальные значения
 * @param value
 * @param index
 * @param self
 * @returns {boolean}
 */
function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

/**
 * Удаляет из массива ВСЕ заданные значения
 * @param arr
 * @param value
 * @returns {*}
 */
function removeItemAll(arr, value) {
    var i = 0;
    while (i < arr.length) {
        if (arr[i] === value) {
            arr.splice(i, 1);
        } else {
            ++i;
        }
    }
    return arr;
}

/**
 * Живой поиск
 */
async function liveSearch(field) {
    const httpClient = new HttpClient();
    const data = await httpClient.post(field.getAttribute('data-request'), {search: field.value});
    if (data.result) {
        field.nextElementSibling.innerHTML = data.string;
    }
}

/**
 * Скрывает поясняющий блок
 * @param note
 */
function hideNote(note) {
    setCookie('hide_note_' + note, 1);
    let noteBlock = document.getElementById('note_' + note);
    noteBlock.classList.add('hide');
}

/**
 * Обновляет настройки пользователя
 * @param elem
 * @param flagName
 * @param reverse
 */
function setUserSetting(elem, flagName, reverse = false) {
    let flag = elem.checked;
    if (reverse) {
        if (flag) {
            setCookie(flagName, 1, -1);
        } else {
            setCookie(flagName, 1);
        }
    } else {
        if (flag) {
            setCookie(flagName, 1);
        } else {
            setCookie(flagName, 1, -1);
        }
    }
}


(function () {

    document.addEventListener("DOMContentLoaded", () => {

        // всякие временные мелочи
        (function () {


            $('.trumbowyg-modal-box form').submit(function (e) {
                e.preventDefault();
            });
        })();


        /**
         * Массив полей ввода
         * @type {{}}
         */
        fields = {};

        /**
         * Массив модалов редактора
         * @type {{}}
         */
        modals = {};

        /**
         * Затемнение редактора
         * @type {{}}
         */
        shadow = {};


        /**
         * Обходит все значения Объекта и конвертирует их в строку
         * @param obj
         * @param fn
         * @returns {{[p: string]: undefined}}
         */
        const objectMap = (obj, fn) =>
            Object.fromEntries(
                Object.entries(obj).map(
                    ([k, v], i) => [k, fn(v, k, i)]
                )
            );

        function integerToString(value) {
            return Number.isInteger(value) ? String(value) : value;
        }

        const filter_event = new Event('filter');

        init();
        hideWorkshopShadow();


        let componentsReg = '';
        let elements = {};
        let filter = {};
        let filterString = {};
        let filter_status;
        if (document.querySelector('.search_columns') != null) {

            filter_status = false;

            for (const [k, f] of Object.entries(ifFields)) {
                if (!f.field.classList.contains('filter')) {
                    continue;
                }
                if (f.value.length > 0) {
                    filter_status = true;
                }
                f.field.addEventListener('change', function () {
                    getFilterValues()
                    applyFilter()
                }, false);
            }

            [].forEach.call(document.querySelectorAll('.for_filter'), function (element) {
                let elem_id = element.getAttribute('data-id');
                elements[elem_id] = {};
                elements[elem_id]['element'] = element;
                // title по идее больше не нужен - весь поиск идёт по полю search
                // elements[elem_id]['title'] = element.querySelector('a').textContent.toLowerCase();
                elements[elem_id]['search'] = (element.getAttribute('data-search') || '').toLowerCase();
                filter_status ? hideElem(elem_id) : showElem(elem_id);
            });

            getFilterValues();

            if (ifField.getByName('search')) {
                ifField.getByName('search').field.addEventListener('change', function () {
                    const str = this.value.toLowerCase();
                    let fixed_en_to_ru = (typeof eng_to_ru !== 'undefined') ? strtr(str, eng_to_ru) : '';
                    let fixed_ru_to_en = (typeof ru_to_eng !== 'undefined') ? strtr(str, ru_to_eng) : '';

                    for (const [element_key, element] of Object.entries(elements)) {
                        let match = !str;
                        match = match || (-1 !== element.search.indexOf(str));
                        match = match || (-1 !== element.search.indexOf(fixed_en_to_ru));
                        match = match || (-1 !== element.search.indexOf(fixed_ru_to_en));
                        if (match) {
                            element.element.classList.remove('hidden_by_text');
                        } else {
                            element.element.classList.add('hidden_by_text');
                        }
                    }
                    letterRowsUpdate();
                });
            }

        }

        /**
         * Собирает значения фильтров с полей ввода
         */
        function getFilterValues() {
            for (const [k, f] of Object.entries(ifFields)) {
                if (!f.field.classList.contains('filter')) {
                    continue;
                }

                filter[f.name] = f.value;
                filterString[f.name] = Array.isArray(filter[f.name]) ? filter[f.name].map(String) : String(filter[f.name]);
                if ('components' === f.name) {
                    let cmps_final = ['\\d', '\\d', '\\d'];
                    f.value.forEach(cm => {
                        switch (cm) {
                            case  'v': cmps_final[0] = 1; break;
                            case  's': cmps_final[1] = 1; break;
                            case  'm': cmps_final[2] = 1; break;
                            case '-v': cmps_final[0] = 0; break;
                            case '-s': cmps_final[1] = 0; break;
                            case '-m': cmps_final[2] = 0; break;
                        }
                    });
                    componentsReg = new RegExp('^' + cmps_final.join('\\|'));
                }
            }
        }

        /**
         * Управляет видимостью заглавных букв в разбиении списка
         */
        function letterRowsUpdate() {
            let letters = [];
            let total = 0;
            let minimum = document.querySelector('[data-min-filtered-count-for-letters]');
            minimum = minimum ? minimum.getAttribute('data-min-filtered-count-for-letters') : 50;

            document.querySelectorAll('.for_filter:not(.hidden):not(.hidden_by_text)').forEach((item) => {
                letters.push(item.getAttribute('data-letter'));
                total++;
            });
            letters = [...new Set(letters)];
            document.querySelectorAll('.first-letter').forEach((group) => {
                group.classList.add('hidden');
            });
            if (total > minimum) {
                letters.forEach(letter => {
                    document.querySelector('.first-letter[id="' + letter + '"]').classList.remove('hidden');
                });
            }
        }

        /**
         * Применение фильтра к результатам
         */
        function applyFilter() {
            console.log('applyFilter');


            for (const [element_key, element] of Object.entries(elements)) {
                // console.log(filterItems[element_key]);
                let visible = true;
                for (const [filter_key, filter_value] of Object.entries(filterString)) {


                    let elem_value = filterItems[element_key][filter_key];
                    // console.log(filter_key);
                    switch (filter_key) {
                        case 'search':
                            break;
                        case 'components':
                            if (elem_value[0].match(componentsReg) === null) {
                                visible = false;
                            }
                            break;
                        case 'class':
                        case 'archetype':
                            if (!filter.class.length && !filter.archetype.length) {
                                break;
                            }
                            if ((filter.class.length > 0 || filter.archetype.length > 0)
                                && !isArraysIntersect(filter.class.map(String), filterItems[element_key].class.map(String))
                                && !isArraysIntersect(filter.archetype.map(String), filterItems[element_key].archetype.map(String))) {
                                visible = false;
                            }
                            break;
                        case 'alignment':
                            if (!filter_value.length) {
                                break;
                            }

                            if (!isArrayContainsArray(elem_value, filter_value)) {
                                visible = false;
                            }
                            break;
                        case 'speed': {
                            if (!filter_value.length) {
                                break;
                            }

                            let present = [];
                            let lacking = [];
                            for (let filterSpeed of filter_value) {
                                let val = parseInt(filterSpeed);
                                if (val > 0) {
                                    present.push(val);
                                } else {
                                    lacking.push(-1 * val);
                                }
                            }

                            if (present.length) {
                                present = present.map(String);
                                if (!isArrayContainsArray(present, filterItems[element_key].speed_applied)) {
                                    visible = false;
                                }
                            }

                            if (lacking.length) {
                                lacking = lacking.map(String);
                                if (!isArrayContainsArray(lacking, filterItems[element_key].speed_lacking)) {
                                    visible = false;
                                }
                            }
                        } break;
                        default:
                            if (!filter_value.length) {
                                break;
                            }

                            let compare_value = filter_value.map(String);

                            // console.log(filter_key, compare_value, elem_value, filter_value.map(String), elem_value.map(String));
                            if (!isArraysIntersect(compare_value, elem_value)) {
                                visible = false;
                            }
                            break;
                    }
                }
                elements[element_key].hidden = !visible;
                // break;
            }

            for (const [element_key, element] of Object.entries(elements)) {
                element.element.classList.toggle('hidden', elements[element_key].hidden);
            }
            letterRowsUpdate();
        }

        /**
         * Проверяет, содержит ли массив 2 все элементы массива 1
         * @param a1
         * @param a2
         */
        function isArrayContainsArray(a1, a2) {
            return a1.every(element => {
                return a2.includes(element);
            });
        }

        /**
         * Скрывает элемент по фильтру
         * @param elem_id
         */
        function hideElem(elem_id) {
            elements[elem_id]['hidden'] = true;
            elements[elem_id]['element'].classList.add('hidden');
        }

        /**
         * Отображает элемент по фильтру
         * @param elem_id
         */
        function showElem(elem_id) {
            elements[elem_id]['hidden'] = false;
            elements[elem_id]['element'].classList.remove('hidden');
        }

        // отправка в приват
        document
            .querySelectorAll('.target-button')
            .forEach( (button) =>
                button.addEventListener('click', () =>
                    document.location.href = button.getAttribute('data-target')));

        const form = document.getElementById('workshop-form');
        if (!!form) {
            const editor = document.getElementById('editor_block');
            const url = form.getAttribute('action');
            const request = new XMLHttpRequest();
            let editor_errors = document.getElementById('editor_errors');

            request.addEventListener("readystatechange", (e) => {
                if (request.readyState !== 4 || request.status !== 200) {
                    return;
                }

                let answer = JSON.parse(request.responseText);
                if (answer.result) {
                    window.location.replace(answer.redirect)
                    return;
                }

                console.log(answer);
                console.log('-----------');

                Object.entries(answer.data).forEach(([name, fieldData,]) => {
                    for ([field_id, field] of Object.entries(fields)) {
                        if (field.element.id === name) {

                            fields[field_id].value = fieldData.value
                            writeValueInInput(field_id);

                        }
                    }
                });

                init();

                Object.entries(answer.data).forEach(([name, fieldData,]) => {
                    for ([field_id, field] of Object.entries(fields)) {
                        if (field.element.id === name && !fieldData.result) {
                            field.element.classList.add('invalid')
                        }
                    }
                });

                Object.entries(answer.errors).forEach(([key, error,]) => {
                    let error_block = document.createElement('div');
                    error_block.innerText = error.text;
                    editor_errors.appendChild(error_block)
                });

                hideWorkshopShadow();
            });


            form.addEventListener('submit', function (event) {
                event.preventDefault();

                showWorkshopShadow(true);

                editor_errors.innerHTML = '';

                let invalids = document.querySelectorAll('.invalid');
                [].forEach.call(invalids, function (invalid) {
                    invalid.classList.remove('invalid');
                });

                let sendData = {};

                for ([field_id, field] of Object.entries(fields)) {
                    if (field.element.id) {
                        sendData[field.element.id] = field.value;
                    }
                }

                //console.log(sendData)

                request.open('POST', url, true);
                request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                request.send(JSON.stringify(sendData));

            });

            [].forEach.call(document.querySelectorAll('.workshop__textarea'), function (editor_block) {

                let editor_block_id = null
                for (const [field_id, field] of Object.entries(fields)) {
                    if (field.element === editor_block) {
                        editor_block_id = field_id;
                    }
                }

                const config = { attributes: true, childList: true, subtree: true };
                const callback = (mutationList, observer) => {
                    for (const mutation of mutationList) {
                        if (mutation.type === "childList") {
                                let editor_elem = editor_block.querySelector('.trumbowyg-editor');
                                let parent = editor_block.querySelector('.trumbowyg-box');
                                let textarea = editor_block.querySelector('.editor');
                                if (editor_elem != null) {
                                    editor_elem.oninput = null;
                                    editor_elem.oninput = function () {
                                        setValue(editor_block_id, parent.classList.contains('trumbowyg-editor-visible') ? editor_elem.innerHTML : textarea.value);
                                        textareaRebuild(editor_block_id);
                                    }
                                    textarea.oninput = null;
                                    textarea.oninput = function () {
                                        setValue(editor_block_id, parent.classList.contains('trumbowyg-editor-visible') ? editor_elem.innerHTML : textarea.value);
                                        textareaRebuild(editor_block_id);
                                    }
                                }
                        }
                    }
                };
                const observer = new MutationObserver(callback);
                observer.observe(editor_block, config);
            });
        }

        // в приват - старый редактор
        document.querySelectorAll('.to_private_old').forEach(function (button) {
            button.addEventListener('click', function (event) {
                ifField.getByName('status').setNewValue('["2"]');
                document.querySelector('[name="private"]').checked = true;
                button.closest('form').submit();
            });
        });





        /**
         * Инициализация полей ввода
         */
        function init() {

            fields = {};
            modals = {};
            shadow = {};
            if (shadow.element = document.getElementById('popup__shadow')) {
                shadow.status = shadow.element.classList.contains('active');
                shadow.animated = shadow.element.classList.contains('anim');
            }

            [].forEach.call(document.querySelectorAll('.workshop__field:not(.template)'), function (field, field_id) {
                fieldsInitNew(field_id, field)
            });

            //console.log(fields)
        }

        function confirmPrivate() {
            return confirm('Снимая этот флажок, вы подтверждаете, что прочли правила одобрения пользовательских карточек, и ' +
                'что вы хотите опубликовать эту карточку. Если у вас нет намерения поделиться карточкой со всем миром, ' +
                'вероятно, это не то, что вам нужно. Если вы хотите поделиться карточкой только с друзьями, вместо публикации ' +
                'карточки используйте функционал компендиумов. Вы уверены, что хотите опубликовать карточку?')
        }

        // новый чекбокс привата
        document
            .querySelectorAll('.if-wrapper__checkbox input[type=checkbox][name=private]')
            .forEach((checkbox) => {
                checkbox.onclick = () => checkbox.classList.contains('if-filled') ? confirmPrivate() : true
            });

        /**
         * Инициализирует новое поле
         * @param field_id
         * @param field
         */
        function fieldsInitNew(field_id, field) {
            fieldInitDefaultParams(field_id, field);

            switch (fields[field_id].type) {
                case 'modalbox':
                    fieldsInitmodalbox(field_id)
                    break;
                case 'dropdown':
                    fieldsInitDropdown(field_id)
                    break;
                case 'checkbox':
                    fieldsInitCheckbox(field_id)
                    break;
                case 'textbox':
                    fieldsInitTextbox(field_id)
                    break;
                case 'textarea':
                    fieldsInitTextarea(field_id)
                    break;
                default:
                    break;
            }
            writeValueInInput(field_id);

            return fields[field_id].type;
        }

        /**
         * Перестраивает поле ввода
         * @param field_id
         */
        function fieldsRebuild(field_id) {
            switch (fields[field_id].type) {
                case 'dropdown':
                    dropdownRebuild(field_id)
                    break;
                case 'checkbox':
                    checkboxRebuild(field_id)
                    break;
                case 'textbox':
                    textboxRebuild(field_id)
                    break;
                default:
                    break;
            }
        }


        /**
         * Получает базовые параметры поля ввода
         * @param field_id
         * @param field
         */
        function fieldInitDefaultParams(field_id, field) {

            fields[field_id] = {};
            fields[field_id].element = field;
            fields[field_id].input = field.querySelector('input, textarea')
            fields[field_id].filter = field.classList.contains('filter');
            fields[field_id].active = field.classList.contains('active');
            fields[field_id].value = fields[field_id].input.value;
            fields[field_id].required = fields[field_id].input.required;
            fields[field_id].type = null;
            fields[field_id].data_id = field.getAttribute('data-id');
            fields[field_id].parent_id = null;
            fields[field_id].group_id = null;

            if (field.classList.contains('workshop__dropdown')) {
                fields[field_id].type = 'dropdown';
            } else if (field.classList.contains('workshop__textbox')) {
                fields[field_id].type = 'textbox';
            } else if (field.classList.contains('workshop__checkbox')) {
                fields[field_id].type = 'checkbox';
            } else if (field.classList.contains('workshop__modalbox')) {
                fields[field_id].type = 'modalbox';
            } else if (field.classList.contains('workshop__textarea')) {
                fields[field_id].type = 'textarea';
            }

            switch (fields[field_id].type) {
                case 'modalbox':
                case 'dropdown':
                    fields[field_id].value = fields[field_id].value === '' ? [] : JSON.parse(fields[field_id].value)
                    break;

                default:
                    break;
            }

        }


        // COMMON FUNCTIONS
        /**
         * Устанавливает текст для плейсхоледера
         * @param field_id
         * @param title
         * @param text
         */
        function setPlaceholder(field_id, title, text = '') {

            let placeholder_title = document.createElement('span');
            placeholder_title.classList.add('placeholder-title');
            placeholder_title.textContent = title;

            let placeholder_value = document.createElement('span')
            placeholder_value.classList.add('placeholder-value');
            placeholder_value.textContent = text;

            fields[field_id].placeholder.innerHTML = '';
            fields[field_id].placeholder.appendChild(placeholder_title);
            fields[field_id].placeholder.appendChild(placeholder_value);

            fields[field_id].placeholder.setAttribute('title', title + (text ? ': ' + text : ''));
            fields[field_id].input.setAttribute('title', title + (text ? ': ' + text : ''));
        }

        /**
         * Записывает значение поля в аттрибуты INPUT
         * @param field_id
         */
        function writeValueInInput(field_id) {
            let value = fields[field_id].value;
            switch (fields[field_id].type) {

                case 'modalbox':
                    fields[field_id].input.value = JSON.stringify(value);
                    fields[field_id].input.setAttribute('value', JSON.stringify(value));
                    break;

                case 'dropdown':
                    fields[field_id].input.value = JSON.stringify(value);
                    fields[field_id].input.setAttribute('value', JSON.stringify(value));
                    fields[field_id].input.dispatchEvent(filter_event);
                    break;

                case 'checkbox':
                    value = valueToBool(value);
                    fields[field_id]['input'].value = value;
                    fields[field_id]['input'].setAttribute('value', value);
                    break;

                default:
                    fields[field_id]['input'].value = value;
                    fields[field_id]['input'].setAttribute('value', value);
                    break;
            }
        }

        /**
         * Добавляет значение к массиву текущего значения поля
         * @param field_id
         * @param value
         */
        function addToValue(field_id, value) {
            fields[field_id].value.push(value);
        }

        /**
         * Удаляет значение из массива текущего значения поля
         * @param field_id
         * @param removed_value
         */
        function removeFromArrayValue(field_id, removed_value) {
            fields[field_id].value = fields[field_id].value.filter(function (value, index, arr) {
                return value != removed_value;
            })
        }

        /**
         * Устанавливает новое текущее значение поля
         * @param field_id
         * @param value
         */
        function setValue(field_id, value) {
            switch (fields[field_id].type) {

                case 'checkbox':
                    value = valueToBool(value)
                    break;

                default:
                    break;

            }
            fields[field_id].value = value;
        }


        // MODALBOX FUNCTIONS
        /**
         * Инициализирует новое поле MODALBOX
         * @param field_id
         */
        function fieldsInitmodalbox(field_id) {

            fields[field_id].value.forEach((group, group_id) => {
                fields[field_id].value[group_id] = objectMap(group, v => integerToString(v));
            })
            fields[field_id].placeholder = fields[field_id].element.querySelector('.workshop__placeholder');
            fields[field_id].default = fields[field_id].element.getAttribute('data-default');

            let modal = {};
            modal.element = fields[field_id].element.nextSibling;
            modal.active = modal.element.classList.contains('active');
            modal.cancel = modal.element.querySelector('button[data-action="cancel"]');
            modal.save = modal.element.querySelector('button[data-action="save"]');
            modal.add = modal.element.querySelector('button[data-action="add"]');

            modal.new_group = modal.element.querySelector('.stat-groups').getAttribute('data-group_code');

            modal.group_block = modal.element.querySelector('.stat-groups');

            modal.cancel.onclick = null;
            modal.cancel.onclick = function () {
                if (modal.active) {
                    modalboxToggleModal(field_id);
                }
            }

            modal.save.onclick = null;
            modal.save.onclick = function () {
                //dropdownRebuild(field_id);
                modalboxRebuildModal(field_id)
                if (modal.active) {
                    modalboxToggleModal(field_id);
                }
            }

            modal.add.onclick = null;
            modal.add.onclick = function () {
                fields[field_id].value.push(JSON.parse(fields[field_id].element.getAttribute('data-default_group')));
                writeValueInInput(field_id)
                modalboxRebuildModal(field_id)
            }

            fields[field_id].modal = modal;

            fields[field_id].placeholder.onclick = null;
            fields[field_id].placeholder.onclick = function () {
                if (fields[field_id].active) {
                    modalboxToggleModal(field_id);
                } else {
                    modalboxToggleModal(field_id);
                }
            };

            modalboxRebuildModal(field_id)

        }

        /**
         * Открывает окно ввода modalbox'а
         * @param field_id
         */
        function modalboxToggleModal(field_id) {
            if (fields[field_id].modal.active) {
                fields[field_id].modal.element.classList.remove('active');
                fields[field_id].modal.active = false;
                hideWorkshopShadow()
            } else {
                fields[field_id].modal.element.classList.add('active');
                fields[field_id].modal.active = true;
                showWorkshopShadow()
            }
        }

        /**
         * Включает затемнение
         * @param anim
         */
        function showWorkshopShadow(anim = false) {
            if (shadow.element) {
                shadow['status'] = true;
                shadow.element.classList.add('active');
                if (anim) {
                    shadow.animated = true;
                    shadow.element.classList.add('anim');
                }
            }
        }

        /**
         * Отключает затемнение
         */
        function hideWorkshopShadow() {
            if (shadow.element) {
                shadow['status'] = false;
                shadow.animated = false;
                shadow.element.classList.remove('active', 'anim');
            }
        }

        /**
         * Перестраивает поля ввода модала
         * @param field_id
         */
        function modalboxRebuildModal(field_id) {
            fields[field_id].modal.group_block.innerHTML = '';
            fields[field_id].modal.groups = {};

            if (!fields[field_id].value.length) {
                fields[field_id].value.push(JSON.parse(fields[field_id].element.getAttribute('data-default_group')));
            }

            [].forEach.call(fields[field_id].value, function (value, value_id) {
                fields[field_id].modal.group_block.innerHTML += fields[field_id].modal.new_group;
            });


            [].forEach.call(fields[field_id].modal.element.querySelectorAll('.stat-group'), function (group, group_id) {

                fields[field_id].modal.groups[group_id] = {};
                fields[field_id].modal.groups[group_id].element = group;
                fields[field_id].modal.groups[group_id].remove = group.querySelector('.remove-group');

                fields[field_id].modal.groups[group_id].remove.onclick = null;
                fields[field_id].modal.groups[group_id].remove.onclick = function () {
                    fields[field_id].value.splice(group_id, 1);
                    modalboxRebuildModal(field_id)
                };


                [].forEach.call(group.querySelectorAll('.workshop__field'), function (element, elem_id) {

                    let element_id = field_id + '-' + group_id + '-' + elem_id;

                    fieldsInitNew(element_id, element);
                    fields[element_id].parent_id = field_id;
                    fields[element_id].group_id = group_id;

                    setValue(element_id, fields[field_id].value[group_id][fields[element_id].data_id])

                    fieldsRebuild(element_id)

                    fields[element_id].input.onchange = null;
                    fields[element_id].input.onchange = function () {
                        customReaction(element_id)
                    }

                });

                [].forEach.call(group.querySelectorAll('.workshop__field'), function (element, element_id) {
                    customReaction(field_id + '-' + group_id + '-' + element_id)
                });


            });

            customLogic(field_id);

        }


        // CHECKBOX FUNCTIONS
        /**
         * Инициализирует новое поле CHECKBOX
         * @param field_id
         */
        function fieldsInitCheckbox(field_id) {
            fields[field_id].value = fields[field_id].input.checked;
            if (fields[field_id].value === true) {
                checkboxCheck(field_id)
            } else {
                checkboxUncheck(field_id)
            }

            fields[field_id].input.onclick = null;
            fields[field_id].input.onclick = function () {
                setValue(field_id, fields[field_id].input.checked);
                fields[field_id].active = fields[field_id].input.checked;
                writeValueInInput(field_id);
            }
        }

        /**
         * Отмечает чекбокс
         * @param field_id
         */
        function checkboxCheck(field_id) {
            fields[field_id].input.checked = true;
            fields[field_id].value = true;
            fields[field_id].active = true;
        }

        /**
         * Отключает чекбокс
         * @param field_id
         */
        function checkboxUncheck(field_id) {
            fields[field_id].input.checked = false;
            fields[field_id].value = false;
            fields[field_id].active = false;
        }


        // DROPDOWN FUNCTIONS
        /**
         * Инициализирует новое поле DROPDOWN
         * @param field_id
         */
        function fieldsInitDropdown(field_id) {
            fields[field_id].value = fields[field_id].value.map(String);
            fields[field_id].multiple = Boolean(parseInt(fields[field_id].element.getAttribute('data-multiple')));
            fields[field_id].default = fields[field_id].element.getAttribute('data-default');
            fields[field_id].placeholder = fields[field_id].element.querySelector('.workshop__placeholder');
            fields[field_id].options = {};

            fields[field_id].placeholder.onclick = null;
            fields[field_id].placeholder.onclick = function () {
                document.addEventListener('click', function (e) {
                    if (!fields[field_id].element.contains(e.target) && fields[field_id].active) {
                        dropdownHideList(field_id);
                    }
                })
                if (fields[field_id].active) {
                    dropdownHideList(field_id);
                } else {
                    dropdownShowList(field_id);
                }
            };

            [].forEach.call(fields[field_id].element.querySelectorAll('li:not(.group-title)'), function (option) {
                row = {};
                row.element = option;
                row.text = option.textContent;
                row.subtext = option.getAttribute('data-group') != null ? option.getAttribute('data-group') : '';
                row.active = option.classList.contains('active');
                row.value = option.getAttribute('data-value');
                row.clear = option.getAttribute('data-clear') != null ? true : false;
                fields[field_id].options[option.getAttribute('data-value')] = row;
            });

            dropdownRebuild(field_id);

            /**
             * Клик по опции добавляет / убирает значение к/из общего значения поля
             * Ребилд переделывает поле.
             */
            for (const [option_id, option] of Object.entries(fields[field_id].options)) {
                option.element.onclick = null;
                option.element.onclick = function () {
                    if (option.clear) {
                        setValue(field_id, [])
                    } else {
                        if (option.active) {
                            removeFromArrayValue(field_id, option.value)
                        } else {
                            if (!fields[field_id].multiple) {
                                setValue(field_id, [])
                                dropdownHideList(field_id)
                            }
                            addToValue(field_id, option.value)
                        }
                    }
                    dropdownRebuild(field_id)
                }
            }
            fields[field_id].input.dispatchEvent(filter_event)
        }

        /**
         * Пересобирает поле DROPDOWN
         * @param field_id
         */
        function dropdownRebuild(field_id) {
            let placeholder_text = '';
            for (const [option_key, option] of Object.entries(fields[field_id].options)) {
                if (fields[field_id].value.includes(option_key)) {
                    option.active = true;
                    option.element.classList.add('active');
                    placeholder_text += option.text + (option.subtext ? ' (' + option.subtext + ')' : '') + ', ';
                } else {
                    option.active = false;
                    option.element.classList.remove('active');
                }
            }
            setPlaceholder(field_id, fields[field_id].default, placeholder_text.substr(0, placeholder_text.length - 2));
            writeValueInInput(field_id);

            if (fields[field_id].value.length) {
                fields[field_id].element.classList.remove('invalid')
            }

            let event = new Event('change');
            fields[field_id].input.dispatchEvent(event);
        }

        /**
         * Разворачивает выпадающий список
         * @param field_id
         */
        function dropdownShowList(field_id) {
            fields[field_id]['active'] = true;
            fields[field_id]['element'].classList.add('active');
        }

        /**
         * Сворачивает выпадающий список
         * @param field_id
         */
        function dropdownHideList(field_id) {
            fields[field_id]['active'] = false;
            fields[field_id]['element'].classList.remove('active');
        }


        // TEXTBOX FUNCTIONS
        /**
         * Инициализирует новое поле TEXTBOX
         * @param field_id
         */
        function fieldsInitTextbox(field_id) {
            fields[field_id].value = String(fields[field_id].value);
            fields[field_id].default = fields[field_id].element.getAttribute('data-default');
            fields[field_id].placeholder = fields[field_id].element.querySelector('.workshop__placeholder');

            textboxRebuild(field_id)

            fields[field_id].input.oninput = null;
            fields[field_id].input.oninput = function () {
                setValue(field_id, fields[field_id].input.value);
                textboxRebuild(field_id)
            }
        }

        /**
         * Пересобирает поле TEXTBOX
         * @param field_id
         */
        function textboxRebuild(field_id) {

            if (fields[field_id].value != '') {
                fields[field_id].element.classList.remove('invalid')
            }

            setPlaceholder(field_id, fields[field_id].default, fields[field_id].value);
            writeValueInInput(field_id);
        }


        // CHECKBOX FUNCTIONS
        function checkboxRebuild(field_id) {
            if (fields[field_id].value) {
                checkboxCheck(field_id)
            } else {
                checkboxUncheck(field_id)
            }
            writeValueInInput(field_id);
        }


        // TEXTAREA FUNCTIONS
        /**
         * Инициализирует новое поле TEXTBOX
         * @param field_id
         */
        function fieldsInitTextarea(field_id) {
            fields[field_id].active = true;
        }

        /**
         * Пересобирает поле TEXTAREA
         * @param field_id
         */
        function textareaRebuild(field_id) {
            if (fields[field_id].value != '') {
                fields[field_id].element.classList.remove('invalid')
            }
            writeValueInInput(field_id);
        }


        // CUSTOM FIELDS LOGIC
        /**
         * Реагирует на сохранение модального окна
         * @param field_id
         */
        function customLogic(field_id) {
            switch (fields[field_id].data_id) {

                case 'cast_time':
                    LOGIC__cast_time(field_id)
                    break;

                default:
                    //console.log('LOGIC__' + fields[field_id].data_id + ' function not set')
                    break;
            }
        }

        /**
         * SPELLS cast_time
         * @param field_id
         * @returns {boolean}
         * @constructor
         */
        function LOGIC__cast_time(field_id) {

            let valid = true;
            let text = '';

            for (let a = 0; a < fields[field_id].value.length; a++) {

                text += fields[field_id + '-' + a + '-0'].value + ' ';

                text += fields[field_id + '-' + a + '-1'].options[fields[field_id + '-' + a + '-1'].value[0]].text + ' ';

                if (fields[field_id + '-' + a + '-1'].value == 'reaction') {
                    text = text.substr(0, text.length - 1);
                    text += ', совершаемая вами, когда ' + fields[field_id + '-' + a + '-3'].value + ' '
                }

                text += fields[field_id + '-' + a + '-2'].input.checked ? '(ритуал)' : '';

                text += ', ';
            }

            text = text.substr(0, text.length - 2);

            setPlaceholder(field_id, fields[field_id].default, text);

            return valid;
        }


        // CUSTOM FIELDS REACTION
        /**
         * Реагирует на действия с полями в модале
         * @param field_id
         */
        function customReaction(field_id) {
            switch (fields[fields[field_id].parent_id].data_id) {

                case 'cast_time':
                    REACTION__cast_time(field_id)
                    break;

                default:
                    //console.log('REACTION__' + fields[field_id].data_id + ' function not set')
                    break;
            }
        }

        /**
         * SPELLS cast_time
         * @param field_id
         * @constructor
         */
        function REACTION__cast_time(field_id) {

            let elem = fields[field_id];
            let group_id = fields[field_id].group_id;
            let parent_id = fields[field_id].parent_id;

            let value = parent_id + '-' + group_id + '-0';
            let unit = parent_id + '-' + group_id + '-1';
            let ritual = parent_id + '-' + group_id + '-2';
            let condition = parent_id + '-' + group_id + '-3';

            let stored_value = fields[parent_id].value[group_id][elem.data_id];

            switch (elem.data_id) {

                case 'unit':
                    if (elem.value == 'reaction') {
                        fields[condition].element.classList.remove('hide_empty')
                        stored_value = '1';
                    } else {
                        //console.log(fields)
                        fields[condition].element.classList.add('hide_empty')
                        stored_value = '0';
                    }
                    fields[parent_id].value[group_id][elem.data_id] = elem.value;
                    break;

                case 'ritual':
                    fields[parent_id].value[group_id][elem.data_id] = valueToIntString(elem.value);
                    break;

                default:
                    fields[parent_id].value[group_id][elem.data_id] = elem.value;
                    break;
            }

            writeValueInInput(elem.parent_id)
            writeValueInInput(field_id)

        }


        // SUPPORT


        function valueToBool(value) {
            value = value == 1 || value == '1' ? true : value;
            value = value == 0 || value == '0' ? false : value;
            value = value == 'true' ? true : value;
            value = value == 'false' ? false : value;
            return value;
        }

        function valueToIntString(value) {
            value = value == 1 || value == '1' ? '1' : value;
            value = value == 0 || value == '0' ? '0' : value;
            value = value == 'true' ? '1' : value;
            value = value == 'false' ? '0' : value;
            return value;
        }


    });

})();


(function () {


    document.addEventListener("DOMContentLoaded", () => {

        if (document.querySelectorAll("textarea.editor").length > 0) {
            return;
        }

        if (document.querySelectorAll("div.editorio").length > 0) {
            return;
        }

        /**
         * рейтинг карточек
         */
        function cardRaiting(footer) {
            footer.querySelectorAll('.card-raiting').forEach(function (raitingBlock) {
                raitingBlock.querySelectorAll('.raiting-button').forEach(function (button) {
                    button.addEventListener('click', async function (event) {
                        event.preventDefault();
                        raitingBlock.classList.add('disabled');
                        const httpClient = new HttpClient();
                        const data = await httpClient.get(button.getAttribute('data-href'));
                        let block = document.createElement('div');
                        block.innerHTML = data.block;
                        raitingBlock.classList.remove('disabled');
                        if (data.result) {
                            setTimeout(function () {
                                raitingBlock.replaceWith(block.firstChild);
                                cardRaiting(footer);
                            }, 300);
                        }

                    });
                });
            });
        }

        document.querySelectorAll('.card__footer').forEach(function (footer) {
            cardRaiting(footer);
        });

        /**
         * избранное
         */
        document.querySelectorAll('.card-menu__favorite').forEach(function (button) {
            button.addEventListener('click', async function (event) {
                let footer = button.closest('.card').querySelector('.card__footer');
                event.preventDefault();
                button.classList.add('disabled');
                const httpClient = new HttpClient();
                const data = await httpClient.get(button.getAttribute('data-href'));
                button.innerText = data.string;
                button.classList.remove('disabled');
                if (data.add) {
                    let div = document.createElement('div');
                    div.innerHTML = data.add;
                    footer.prepend(div.firstChild);
                    div.remove();
                } else {
                    footer.querySelector('.card-footer__in-favorite').remove();
                }
            });
        });


        document.querySelectorAll('.delete-x').forEach(function (button) {
            button.addEventListener('click', async function (event) {
                event.preventDefault();
                if (!button.classList.contains('disabled')) {
                    button.classList.add('disabled');
                    const httpClient = new HttpClient();
                    const data = await httpClient.get(button.getAttribute('data-href'));
                    if (!data.add) {
                        button.parentElement.remove();
                    } else {
                        button.classList.remove('disabled');
                    }
                }
            });
        });
        document.querySelectorAll('.mini-cards .card').forEach(function (card) {
            let button = card.querySelector('.favorite-mini');
            button.addEventListener('click', async function (event) {
                event.preventDefault();
                if (!button.classList.contains('disabled')) {
                    button.classList.add('disabled');
                    const httpClient = new HttpClient();
                    const data = await httpClient.get(button.getAttribute('data-href'));
                    if (!data.add) {
                        card.remove();
                    } else {
                        button.classList.remove('disabled');
                    }
                }
            });
        });

        /**
         * закрепленное
         */
        document.querySelectorAll('.card-menu__pin').forEach(function (button) {
            button.addEventListener('click', async function (event) {
                let footer = button.closest('.card').querySelector('.card__footer');
                event.preventDefault();
                button.classList.add('disabled');
                const httpClient = new HttpClient();
                const data = await httpClient.get(button.getAttribute('data-href'));
                button.innerText = data.string;
                button.classList.remove('disabled');
                if (data.add) {
                    let div = document.createElement('div');
                    div.innerHTML = data.add;
                    footer.prepend(div.firstChild);
                    div.remove();
                } else {
                    let pinned = footer.querySelector('.card-footer__pinned');
                    if (pinned !== null) {
                        pinned.remove();
                    }
                }

                let oldGroup = document.getElementById('pinned_menu');
                if (oldGroup !== null) {
                    oldGroup.remove();
                }

                if (data.menu) {
                    document.querySelector('[data-menu="menu-2"]').parentElement.insertAdjacentHTML('afterend', data.menu)
                    toggleLeftMenuBlock(document.querySelector('[data-menu="menu-3"]'))
                } else {
                    document.querySelector('[data-menu="menu-3"]').remove()
                }

            });
        });

        /**
         * Свич карточек
         */
        document.querySelectorAll('.cards-wrapper').forEach(function (wrapper) {
            let cards = wrapper.querySelectorAll('.card');
            if (cards.length < 2) {
                return;
            }

            let currentMultiverse = wrapper.querySelector('.card.active').getAttribute('data-cardlink').includes('multiverse');
            let cardClassic = wrapper.querySelector('.card__group-classic');
            let cardMultiverse = wrapper.querySelector('.card__group-multiverse');

            let switcher = document.createElement('div');
            switcher.classList.add('content-switch', 'contrast', 'compact');
            switcher.innerHTML = '<span class="content-switch__title">Мультивселенная:</span>';
            wrapper.parentNode.insertBefore(switcher, wrapper);
            let inputSpan = document.createElement('span');
            switcher.appendChild(inputSpan);
            inputSpan.classList.add('content-switch__button', 'form__checkbox', 'checkbox-sm');
            let input = document.createElement('input');
            inputSpan.appendChild(input);
            let inputButton = document.createElement('span');
            inputButton.classList.add('checkbox__button');
            inputSpan.appendChild(inputButton);
            input.type = 'checkbox';
            if (currentMultiverse) {
                input.checked = true;
            }
            input.addEventListener('change', function () {
                wrapper.querySelectorAll('.card.active').forEach(function (elem) {
                    elem.classList.remove('active')
                });
                let classicUrl = cardClassic.getAttribute('data-cardlink');
                let multiUrl = cardMultiverse.getAttribute('data-cardlink');
                if (input.checked) {
                    cardMultiverse.classList.add('active');
                    setCurrentPageUrl(multiUrl, classicUrl)
                } else {
                    cardClassic.classList.add('active');
                    setCurrentPageUrl(classicUrl, multiUrl)
                }
            });
        });


        /**
         * Враппер таблиц
         */
        document.querySelectorAll('.card__body table').forEach(function (table) {
            if (table.closest('.editorio')) {
                return
            }
            let wrapper = document.createElement('div');
            wrapper.classList.add('table-wrapper');
            table.after(wrapper);
            wrapper.appendChild(table);
        });


        /**
         * Копируем в буфер
         */
        document.querySelectorAll('[data-copy]').forEach(function (elem) {
            elem.addEventListener('click', function (event) {
                navigator.clipboard.writeText(elem.getAttribute('data-copy')).then(r => {
                });
                let viewportOffset = elem.getBoundingClientRect()
                let message = document.createElement('div');
                message.classList.add('copy-success');
                message.innerText = 'Скопировано';
                message.style.top = viewportOffset.top + 'px';
                message.style.left = (viewportOffset.left + elem.offsetWidth / 2) + 'px';
                elem.after(message);
                setTimeout(function () {
                    message.remove();
                }, 500);
            });
        });

        let remember_me = ifField.getByName('remember_me');
        if (remember_me) {
            remember_me.field.addEventListener('change', () => {
                if (remember_me.value) {
                    setCookie('remember_me', 1, 1)
                } else {
                    Cookies.remove('remember_me')
                }
            })
        }

        /** ФИНИК */
        document.querySelectorAll('.finik, .article-body__finik').forEach((finik) => {
            let text = finik.innerHTML;
            finik.innerHTML = '';

            let icon = HTML.createElement('div', ['sprite-finik__dice', 'finik__icon'])
            finik.appendChild(icon)

            let grid = HTML.createElement('div', 'finik__grid')
            finik.appendChild(grid)

            let content = HTML.createElement('div', 'finik__content')
            content.innerHTML = text;
            grid.appendChild(content)

            let sign = HTML.createElement('div', 'finik__sign')
            sign.innerText = '— Господин Финик'
            grid.appendChild(sign)

        })


        document.querySelectorAll('[data-reply-to]').forEach((comment) => {
            elemHover(comment, 'comment__reply-hovered', document.getElementById('comment_' + comment.getAttribute('data-reply-to')))
        })

    });


})();


function indexShowLetters(letters) {
    if (!letters.length) {
        return;
    }

    let letter = letters.shift();
    document.querySelectorAll(`[data-letter="${letter}"]`).forEach((div => div.style.display = ''));
    window.setTimeout(() => indexShowLetters(letters), 200);
}